export default {
  lobby: {
    theme34_dz: { promote: '', events: '' },
    theme27_dz: {
      home: {
        promoteTitle: '',
        popular: '',
        total: '',
        distancial: '',
        recebido: '',
        totalAmount: '',
        invite: '',
        player: '',
        open: '',
        justWin: '',
        jackpotTitle: '',
        downloadTips: ''
      },
      header: { inviteFriends: 'Freunde einladen' }
    },
    theme19_dz: { search: '' },
    theme33_dz: {
      search: '',
      discount: '',
      jackpot: '',
      helpCenter: '',
      popular: '',
      pgTop: '',
      jiliLucky: '',
      ppSlot: '',
      feature: '',
      featuredGames: '',
      feast: '',
      galore: '',
      downloadTitle: '',
      downloadContent: '',
      googleText: '',
      appText: '',
      centerWallet: '',
      withdrawalManagement33: '',
      accountDetails33: '',
      bettingRecord33: '',
      security33: '',
      feedback33: '',
      messageCenter33: ''
    },
    theme14_dz: {
      home: {
        downloadAppTxt: '',
        footer: {
          license: '',
          protect: '',
          followUs: '',
          playResponsibly: '',
          tgLink: '',
          youtubeLink: '',
          fbLink: ''
        },
        welcome: '',
        h5: ''
      }
    },
    theme12_dz: {
      header: { tool_tips_hot: '' },
      platform: { start_game: '' },
      download: { h1: '', h3: '', ios: '', android: '' },
      card: '',
      real: '',
      events: '',
      popular: '',
      discount: ''
    },
    theme15_dz: {
      download: {
        h1: '',
        h3: '',
        p: '',
        app: '',
        downloading: '',
        nodeNeed: '',
        domin: ''
      },
      more: '',
      header: { servider: '', suporte: '' },
      headerNav: {
        menu0: '',
        promote: '',
        download: '',
        collected: '',
        collectedRecord: ''
      },
      asideList: {
        game: '',
        club: '',
        discount: '',
        customerService: '',
        checkLine: '',
        aboutUs: ''
      },
      tabLable: { Ajuda: '', Sugestao: '', FAQ: '', Sobre: '' },
      bran: {
        cli: { label: '', label1: '' },
        Comite: { label: '', label1: '' },
        Filipinas: { label: '', label1: '' },
        Certificacao: { label: '', label1: '' }
      },
      footerText: ''
    },
    theme13_dz: {
      header: {
        week: {
          day0: '',
          day1: '',
          day2: '',
          day3: '',
          day4: '',
          day5: '',
          day6: ''
        },
        onlineService: '',
        welcome: '',
        balance: ''
      },
      home: {
        partInfo: {
          safeTitle: '',
          safeTxt: '',
          varietyTitle: '',
          varietyTxt: '',
          topupTitle: '',
          topupTxt: '',
          fastTitle: '',
          fastTxt: '',
          playNow: ''
        },
        winner: '',
        downloadAppTxt: '',
        h5: ''
      }
    },
    error: {
      lostTo404: 'Hoppla, es sollte nicht passieren',
      backToHome: 'Zurück zu Home',
      demoAccountTips: 'Die Ankernummer hat keine Autorität',
      networkTimeout:
        'Beim Netzwerk ist eine Zeitüberschreitung aufgetreten. Bitte versuchen Sie es später erneut. Wenn die Anfrage weiterhin fehlschlägt, wenden Sie sich bitte an den Kundendienst',
      networkTimeout2: 'Netzwerk-Timeout, bitte',
      networkTimeout3: 'Zeitüberschreitung, bitte versuchen Sie es erneut',
      networkError:
        'Das Netzwerk ist klein. Überprüfen Sie bitte Ihre Netzwerkverbindung',
      upgraded: 'Die aktuelle Seite ist keine Zeit mehr',
      upgradedMsg:
        'Wir haben ein Upgrade durchgeführt! Für ein besseres Erlebnis aktualisieren Sie bitte auf die neueste Version!',
      upgradedBtn: 'Sofort upgraden',
      guide2Reload:
        'Sie haben lange nicht mehr betrieben, bitte aktualisieren Sie die Seite!',
      channelErrorText:
        'Bitte mit dem generierten Kanal oder der Promotions-Verknüpfung besuchen. Sonst ist eine normale Bindung nicht möglich!',
      loadingError: 'Timeout, bitte {reday} oder {reload} Page!',
      updatePage:
        'Der aktuelle Seiteninhalt ist abgelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut!',
      update: 'Jetzt aktualisieren',
      friendlyReminder: 'Tipps'
    },
    common: {
      number: {
        '1': '<span>Eins</span>',
        '2': 'Zwei',
        '3': 'Drei',
        '4': 'Vier',
        '5': 'Fünf',
        '6': 'Sechs',
        '7': 'Sieben'
      },
      formRules: {
        required: '{requiredItem} Das Feld darf nicht leer sein!',
        requiredWithoutItem: 'Das Feld darf nicht leer sein!',
        username:
          '{range} Bit -Zeichen, Unterstützung Englisch/Zahlen unterstützen',
        userpass: '{range} Buchstaben/Ziffern/Symbole (2 Typen)',
        userpassSpecial:
          'Das Symbol wird nicht unterstützt, bitte geben Sie ein!@#$%^&*_ _ =+-,./? ().',
        usercpf: 'Bitte geben Sie CPF ein',
        paypass: '{length} Zahlen',
        numberRequired: '{type} müssen ganze Zahlen sein',
        itemRequired: 'Du verfügst noch nicht über die benötigten Items',
        withdrawalPass:
          'Bitte geben Sie ein {length} -Bit -Zeichen ein, um Zahlen/englische Buchstaben/englische Symbole zu unterstützen',
        atLeast: '　Zeichen, muss mindestens enthalten　',
        digit: 'Ziffern',
        lowercase: 'Kleinschrift',
        uppercase: 'Großschrift',
        num: 'Nummer',
        special: 'Symbol',
        psswdstrength: 'Stärke'
      },
      tips: {
        paste: 'Einfügen',
        copy: 'Erfolgreich kopiert',
        return: 'Zurück',
        next: 'Weiter',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        skip: 'Überspringen',
        validating: 'Wird getestet...',
        loadingTip: 'Laden, bitte warten…',
        customerNotEnabled: 'Der Online Kundenservice ist noch nicht offen',
        downloadAppPageNotEnabled:
          'Die Download-Funktion der App ist noch nicht aktiviert',
        month: 'Monat'
      },
      supports: {
        simple: '<span>Kontaktiere Uns</span>',
        notBind:
          'Fehlerhaftes Konto. Bitte<span> kontaktiere den Kundenservice</span>',
        accountException:
          'Fehlerhaftes Konto. Bitte<span>Kontaktiere den Kundenservice</span>',
        forgotPwd: 'Passwort vergessen? <span>Kontaktiere Uns</span>',
        forgotSecrecyQuestion:
          'Sicherheitsfrage vergessen? <span>Kontaktiere den Kundenservice</span>',
        authUnavailable:
          'Die obige Methode ist nicht verfügbar? <span>Kontaktiere uns</span>',
        notBindVaild:
          "Verfeintigungsprüfungen ungebunden, bitte <s'pan> Wenden Sie sich an den Kundendienst </span>",
        accountError:
          "Das Konto existiert nicht, bitte <s'pan> Wenden Sie sich an den Kundendienst </span>"
      },
      pagination: {
        prev: 'Vorherige Seite',
        next: 'Nächste Seite',
        total: 'Gesamt {0}',
        goto: 'Gehe Zu',
        page: 'Buchseite',
        select: '{0} Eintrag/Seite'
      },
      components: {
        auth: {
          contactUS: 'Support Kontaktieren',
          othersVerify: 'Andere Methoden',
          ga: {
            title: 'Google-Bestätigung',
            label: 'Google-Best Atigungscode',
            inputTips: 'Bitte geben Sie den Google-Bestätigungscode ein'
          },
          email: {
            inputTips: 'Bitte geben Sie Ihre E-Mail ein',
            current: 'Gegenwärtig Gebundene E-Mail',
            title: 'E-Mail-Bestätigung',
            label: 'Post',
            success: 'E-Mail-Eingabe nicht korrekt',
            error: 'Email-Fehler',
            formatError: 'E-Mail-Formatfehler, bitte gebe sie erneut ein',
            required:
              'Erschaffe bitte eine mittlere E-Mail-Adresse für deine Kontosicherheit',
            requiredNew:
              'Bitte machen Sie die vollständige Mailbox nach, um den Bestätigungscode zu erhalten'
          },
          phone: {
            current: 'Gegenwärtig Gebundenes Handy',
            title: 'Handy Verifizieren',
            label: 'Handy',
            success: 'Handynummer ist richtig',
            error: 'Falsche Handynummer, bitte gebe sie erneut ein',
            required:
              'Bitte gib für deine Kontosicherheit die {length} fehlende Handynummer ein',
            requiredNew:
              'Bitte machen Sie die vollständige Mobiltelefonnummer aus, um den Bestätigungscode zu erhalten (dh die Mitte {length} Bit eingeben).',
            requiredOfActivity:
              'Bitte erstellen Sie {x} Bit volles Handynummer',
            sendSuccess: 'Der Verifizierungscode ist erfolgreich!',
            toBindPhone: 'Sie haben die Mobiltelefonnummer nicht gebeugt,',
            toBindPhoneBtn: 'Gehen Sie zu binden'
          },
          withdrawal: {
            title: 'Abhebungs-PIN-Überprüfung',
            label: 'Bestätige das Abhebungspasswort',
            forgot: 'Passwort Vergessen?'
          },
          question: {
            name: 'Geheimer Schutz',
            title: 'Überprüfung der Sicherheitsfrage',
            label: 'Frage',
            label2: 'Antwort',
            inputTips: 'Bitte Antwort Eingeben'
          }
        },
        geetest: {
          clickToValid: 'Klicke die Taste zur Bestätigung',
          success: 'Bestätigung erfolgreich',
          error:
            'Wenn die Überprüfung fehlschlägt, aktualisieren Sie die Seite, um es erneut zu versuchen'
        },
        datePicker: {
          error: 'Bitte wähle ein korrektes Datum',
          YYYY: 'Jahr',
          MM: 'Monat',
          DD: 'Tag'
        }
      },
      upload: {
        error: {
          fileSize: 'Dateigröße wird nicht unterstützt',
          fileSize2MB: 'Nur PNG, JPG -Format, nicht mehr als 2 MB',
          fileType: 'Dateityp wird nicht unterstützt',
          fileNull: 'Datei wurde nicht erhalten. Bitte erneut hochladen'
        },
        text: 'Datei hochladen'
      },
      deviceContext: {
        betterExperience: 'Für Ihre gute Erfahrung',
        rotateToPortrait:
          'Bitte betreiben Sie den vertikalen Bildschirm Mobiltelefon/Tablet'
      },
      loading: {
        click: 'Geklickt',
        retry: 'Wiederholen',
        reload: 'Erneut eingeben'
      }
    },
    saveShortcut: {
      btn: 'Bitte <span> add </span> zum Hauptbildschirm hinzufügen',
      guideModalTitle: 'Zum Hauptbildschirm hinzufügen',
      guideModalTitleAndriod: 'Zum Hauptbildschirm hinzufügen',
      guideModalStep1:
        '1. Klicken Sie auf [mehr] Symbol und dann klicken Sie, um zum Hauptbildschirm hinzuzufügen',
      guideModalStep2:
        '2. Klicken Sie auf das Hinzufügen, wählen Sie [Hinzufügen]',
      label1: 'Aktie',
      label2: 'Finden Sie auf der Webseite',
      label3: 'Desktop -Versionswebsite',
      label4: 'Zu schnellem Memo hinzufügen',
      label5: 'Auf der Seite finden',
      label6: 'Markieren',
      label7:
        'Ein Symbol wird Ihrem Hauptbildschirm hinzugefügt, damit Sie diese Website schnell besuchen können',
      cancle: 'Abbrechen',
      add: 'Hinzufügen zu',
      useH5: 'weiterhin benutzen',
      click: 'Geklickt',
      openmenu: 'Öffnen Sie die Menüleiste',
      select: 'wählen',
      addHome: 'Zum Hauptbildschirm hinzufügen'
    },
    rightBar: {
      reward: '+',
      backHome: 'Startseite',
      backTop: 'Oben',
      downloadTitleFromClickGame:
        'Um Ihr Benutzererlebnis zu verbessern, müssen Sie die native APP herunterladen, um das Spiel zu spielen!',
      downloadApp: 'App herunterladen',
      downloadAppTitle: 'App herunterladen',
      downloadAndroidApp: 'Android',
      downloadIosApp: 'iOS',
      onlineCustomer: 'Onlineservice 24/7',
      scanQR: 'Mit QR-Code folgen',
      downloadAppSpeed: 'Schnell-Version',
      downloadAppNormal: 'Normale Version',
      downloadAppComplete: 'Vollständige Version',
      downloadDevice: 'Mobilen Client herunterladen',
      redPocketEnd: 'Beendet',
      noDownApp: 'Ich habe die Download -Adresse noch nicht konfiguriert ~ ~',
      downloadAppTips:
        'Laden Sie die App herunter und verwenden Sie die App, um an weiteren Aktivitäten teilzunehmen und mehr Rabatte zu genießen!',
      useH5: 'Verwenden Sie weiterhin H5',
      titleFromChannel: 'Wichtige Erinnerung',
      channelTip1:
        'Sie müssen die APP herunterladen und verwenden, um das Spiel zu spielen!',
      channelTip2:
        'Gleichzeitig bietet Ihnen das System zusätzliche Möglichkeiten',
      channelTip3: 'Bonus!',
      channelTip4:
        'Sie müssen die H5-Desktopverknüpfung herunterladen und verwenden, um das Spiel zu spielen!',
      saveShortcutMessage: 'H5-Desktop-Verknüpfung',
      channelTip5: '(Nur für erstmalig eingezahlte Mitglieder)'
    },
    tabbar: {
      home: 'Startseite',
      menu: 'Menü',
      event: 'Event',
      service: 'Kunden-\nSupport',
      download: 'APP Herunterladen',
      discount: 'Werbeaktion',
      recharge: 'Einzahlen',
      withDraw: 'Abheben',
      register: 'Registrieren',
      login: 'Anmeldung',
      mine: 'Mein Profil',
      balance_dz: 'Gleichgewicht'
    },
    dz_5159: { tarbar: { service: '' } },
    mine: {
      vip: { tips: { deposit: 'Schlechte Aufladung', bet: 'Codierung' } },
      share: {
        tips: 'Teilen und verdienen',
        yesterdayMembers: 'Die Anzahl der Personen gestern (gültig)',
        yesterdayTotalDirectBets: 'Gestrige Leistung',
        yesterdayTotalDirectCommissionse: 'Provision nicht beansprucht'
      },
      itemList: {
        netWorkStatus: 'Netzwerk-Status',
        selectLanguage: 'Sprache Auswählen',
        switchMode: 'Modus wechseln',
        currentMode: 'Aktueller Modus {mode}',
        versionUpdate: 'Neue Versions -Update',
        versionContent: 'Inhalt der Version',
        gotVersionUpdate: 'Neue Version gefunden',
        club: 'Club',
        music: 'Musik'
      }
    },
    header: {
      account: 'Konto',
      messages: 'Messages',
      withdraw: 'Abheben',
      recharge: 'Einzahlen',
      personalCenter: 'Mitglied-Center',
      menu: 'Menü',
      loginout: 'Ausloggen',
      onlineService_dz: '',
      welcome_dz: '',
      menus: {
        messageCenter: 'Nachrichtenzentrum',
        accountDetails: 'Kontoauszug',
        bettingRecord: 'Wetteinsätze Einträge',
        personalStatement: 'Persönlicher\nBericht',
        personalStatementCyanBlue: 'Persönlicher\nBericht',
        withdrawalManagement: 'Abhebungsverwaltung',
        promote: 'Promotion {content}',
        defaultPromoteAdvertise: 'Millionen Einkommen pro Monat',
        settings: 'Persönliche Informationen',
        security: 'Sicherheits-Center',
        music: 'Musik',
        feedback: 'Belohntes Feedback',
        about: 'Um',
        logout: 'Sicher Abmelden'
      },
      logoutTips: 'Ziehen Sie vom Girokonto ab?',
      logoutOkText: 'Bestätigen Sie das Beenden',
      logoutCancelText: 'Abbrechen',
      moneyInGame: 'Dalam Permainan',
      officeDomain: 'Offizieller Domain -Name'
    },
    modal: {
      noData: 'Derzeit keine Daten verfügbar',
      notOpen: 'Noch nicht freigegeben',
      verify_user_password_text:
        'Das Folgende ist Ihr aktuelles Konto Passwort, bitte vergessen Sie es nicht!',
      importantReminder: 'wichtiger Hinweis',
      reset_withdraw_password:
        'Bitte ändern Sie zuerst das Abhebungskennwort und machen Sie dann die Aufladung/Auszahlung aus',
      force: {
        understood: 'Verstanden.',
        main_not_show_again_today: 'Für heute nicht mehr anzeigen',
        serviceUpgrade:
          'Stoppen Sie den Dienst und führen Sie ein Upgrade durch'
      },
      title: { error: 'Wichtige Erinnerung' },
      forceUpdate: {
        content:
          'Ihre aktuelle Version ist zu niedrig. Sie müssen auf die neueste Version aktualisieren, bevor Sie sie verwenden können.',
        okText: 'Sofort upgraden'
      },
      search: { placeholder: 'Suchen' },
      login: {
        label: 'Anmeldung',
        otherWayLogin: 'Andere Login-Methoden',
        type: { casino: 'Casino Anmeldung', club: 'Club-Anmeldung' },
        googleInitError:
          'Diese Anmeldemethode wird gewartet. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Kundenservice.',
        passwordHint:
          'Ihr aktuelles Passwort ist schwach. Bitte ändern Sie das Passwort so schnell wie möglich.',
        form: {
          smsCode: {
            label: 'OTP',
            placeholder: 'E-Mail-Bestätigungscode',
            counting: 'Erneut senden in {seconds}s',
            send: 'Code Abrufen',
            required: 'Der Bestätigungscode muss ausgefüllt werden',
            getCode: 'Bitte fordern Sie zuerst den SMS-Bestätigungscode an',
            emailCode: 'Bitte erhalte zuerst den Email-Bestätigungscode'
          },
          phone: {
            label: 'Handy-Nr.',
            placeholder: 'Handy-Nr.',
            required:
              'Stimmt nicht mit der mobilen Telefonnummer überein. Bitte erneut eingeben!',
            viError:
              'Es ist nicht erforderlich, 0 vor 0 einzugeben, beispielsweise 0123456789, solange Sie 123456789 eingeben'
          },
          username: {
            label: 'Mitgliedskonto',
            labelShort: 'Konto',
            placeholder: 'Bitte Mitgliedskonto eingeben'
          },
          realName: {
            label: 'Echter Name',
            labelShort: 'Name',
            placeholder: 'Bitte gebe deinen echten Namen ein',
            realNameTips:
              "Unterstützen Sie die Eingabe von Buchstaben, Text, Leerzeichen und Sonderzeichen’'·",
            realNameTips2:
              "Unterstützen Sie Buchstaben/Text/Leerzeichen und Sonderzeichen’'·",
            realNameTips3:
              "Unterstützen Sie Buchstaben/Leerzeichen und Sonderzeichen’'·"
          },
          userpass: { label: 'Passwort' },
          stakeusername: { placeholder: 'Bitte Mitgliedskonto eingeben' },
          stakepassword: { placeholder: 'Bitte gib das Passwort ein' }
        },
        placeholder: {
          platformId: 'Mitgliedskonto',
          platformId3:
            'Bitte geben Sie ein {minmax} -Scharakter ein, um Englisch/Zahlen zu unterstützen',
          passwd: 'Bitte Passwort eingeben',
          passwd3:
            'Bitte geben Sie das {minMax} -Bit ein, zumindest die Symbole in Englisch/Zahlen/Symbolen',
          passwdConfirm:
            'Bitte bestätigen Sie das Passwort erneut wie das Passwort!',
          passwdConfirm3:
            'Bitte geben Sie das {minMax} -Bit ein, zumindest die Symbole in Englisch/Zahlen/Symbolen',
          mobilePhoneNumber: 'Bitte Handynummer eingeben',
          verificationCode: 'Bitte geben Sie den Handy-Verifizierungscode ein',
          verificationCode3: 'Bitte gib den Bestätigungscode ein',
          email: 'Bitte geben Sie das Mailbox -Konto ein',
          emailCode: 'Bitte geben Sie den E-Mail-Bestätigungscode ein',
          emailCode3: 'Bitte gib den Bestätigungscode ein',
          realName:
            'Füllen Sie den wahren Namen aus und machen Sie ihn für einen späteren Rückzug bequem!',
          realName31: 'Bitte gebe deinen echten Namen ein',
          realName32:
            'Bitte geben Sie den richtigen Namen ein, unterstützen Sie nur englisches Kapital',
          cpfCode:
            'Füllen Sie den CPF aus und machen Sie es bequem für einen späteren Rückzug!',
          currency: 'Bitte wählen Sie Währung',
          inviterId: 'Bitte geben Sie Ihren Einladungscode ein',
          inviterId3: 'Bitte geben Sie den Einladungscode ein'
        },
        tabs: {
          accountLogin: 'Konto',
          accountRegister: 'Konto registrieren',
          phoneLogin: 'Melden Sie sich mit dem Telefon an',
          phoneRegister: 'Handy anmelden',
          phoneSubTitle:
            'Dies dient der Registrierung bzw. dem Login und ist unverbindlich.',
          emailLogin: 'Post',
          emailRegister: 'E-Mail Registrierung',
          emailSubTitle:
            'Dies dient der Registrierung bzw. dem Login und ist unverbindlich.'
        },
        operate: {
          rememberPwd: 'Daten merken',
          forgotPwd: 'Passwort Vergessen?',
          registerAccount: 'Registrieren',
          smsLogin: 'Per SMS einloggen',
          accountLogin: 'Konto',
          tryItFree: 'Demo Abspielen',
          registerGive: 'Registrieren +',
          bindingGive: 'Link +',
          accountRegister: 'Einen Account registrieren',
          modify: 'Bearbeiten',
          clickLogin: 'Anmeldung'
        }
      },
      currency: {
        chinese: 'Chinese',
        english: 'English',
        USD: 'USD',
        CNY: 'CNY',
        HKD: 'HK$',
        THB: 'THB',
        VND: 'VND',
        IDR: 'IDR',
        INR: 'INR',
        AUD: 'AUD',
        GBP: 'GBP',
        KRW: 'KRW',
        JPY: 'JPY',
        BRL: 'BRL',
        MXN: 'MXN',
        EUR: 'EUR',
        RUB: 'RUB',
        MMK: 'MMK',
        AED: 'Dirham',
        PHP: 'PHP',
        KHR: 'Ruile, Kambodscha',
        USDT: 'USDT（For USD exchange）',
        USDT7_1: 'USDT 1:7 (For CNY exchange)',
        USDC: 'USDC (For USD exchange)',
        USDC7_1: 'USDC 1:7 (For CNY exchange)',
        BTC: 'BTC',
        BTC100000_1: 'BTC 1:100000  (For CNY exchange)',
        BTC10000_1: 'BTC 1:10000 (For USD exchange)',
        ETH: 'ETH',
        ETH10000_1: 'ETH 1:10000 (For CNY exchange)',
        ETH1000_1: 'ETH 1:1000 (For USD exchange)',
        KPW: 'KPW',
        PRK: 'PKR',
        NPR: 'NPR',
        BDT: 'BDT',
        MUR: 'MUR',
        NGN: 'Nala',
        TRX: 'Tron',
        TRY: 'türkische Lire',
        MAD: 'Molocodiham'
      },
      register: {
        readed: 'Gelesen',
        label: 'Registrieren',
        thirdLabel: 'Konto Einrichten',
        thirdAccountLabel: '{thirdWay}Konto',
        imageVerificationCode: 'OTP',
        successTips: 'Registrierung erfolgreich! Komm und spiel eine Runde~',
        successRegister: 'Registrierung erfolgreich',
        available: 'Konto verfügbar',
        existed: 'Konto vorhanden',
        notMatch: 'Die Passwörter sind nicht identisch, Bitte erneut eingeben!',
        passwdConfirm: 'Passwort Bestätigen',
        inviterAccount: 'Kein Einladungscode kann nicht ausfüllen',
        selectCountry: 'Bitte wählen Sie Währung',
        realNameError: 'Es werden nur englische Großbuchstaben unterstützt.',
        cpfError:
          'Support Geben Sie 11 Ziffern ein, spezieller Charakterunterstützung .-',
        selectCountryError:
          'Die Währung bestimmt das Drei -Way -Spiel und die Zahlung und kann nicht geändert werden!',
        selectCurrencyTips:
          'Die Verbindung schlägt fehl, wenn die Einladungswährung nicht mit deiner Währung übereinstimmt.',
        submitCurrencyError:
          'Die aktuell verknüpfte Währung stimmt nicht mit dem Einladungscode überein. Bitte erneut vervollständigen',
        invitetAccountRequired: 'Bitte geben Sie den Einladungscode ein',
        saveAccountPwd: 'Bild Speichern',
        modifyNow: '',
        confirm: 'Registrierung Bestätigen',
        rangeNumber: '{range} Ziffern',
        editAccountTips:
          'Wichtiger Hinweis: Das Konto kann nur einmal bearbeitet werden. Nach dem Registrieren kann es nicht mehr bearbeitet werden.',
        agreementRequiredTips: 'Bitte überprüfe erst die Nutzungsvereinbarung',
        userAgreement:
          'Ich bin 18 Jahre alt, ich habe <span data-user-agreement="true"> 《Benutzervereinbarung》<span/> gelesen und bin damit einverstanden',
        inviterAccount1: '',
        inviterCode: 'Einladungs-Code',
        close: 'Schließen',
        accountInfo: 'Kontoinformationen',
        successCallback:
          'Herzlichen Glückwunsch zur erfolgreichen Registrierung!',
        saveAccountInfo:
          'Ihr Konto und Ihr Passwort lauten wie folgt, bitte bewahren Sie sie sicher auf, um Anmeldeprobleme zu vermeiden,',
        saveAccountTips: 'Geben Sie sie nicht weiter, um Verluste zu vermeiden!'
      },
      forgotPassword: {
        title: 'Passwort Vergessen',
        step1: 'Identitätsüberprüfung',
        step2: 'Passwort Zurücksetzen',
        step3: 'Fertig',
        newPassword: 'Neues Passwort',
        backHome: 'Zurück zu Home',
        loginNow: 'Jetzt Anmelden',
        resetSuccess: 'Dein Passwort wurde erfolgreich geändert',
        systembusy: 'Server besetzt. Bitte versuchen Sie es später noch einmal'
      },
      task: {
        reward: {
          '8': 'Der erste Einzahlungskragen {reward}',
          '11': 'Herunterladen und {reward} erhalten',
          '17': 'Erhalte für die erste Aufladung {reward}',
          default: '+{reward}'
        },
        amount: 'Preise',
        activity: 'Aktivitätsniveau',
        title: 'Mission',
        activityRate: 'Aktivitätsniveau',
        activityBoxTip:
          'Nach dem Öffnen erhalten Sie einen {reward}-Bonus.<br/>Zum Abheben von Bargeld ist der <span>{x}</span>-fache Umsatz erforderlich',
        activityBoxReceiveTip:
          'Gesammelt{reward}Belohnung benötigt<span>{x}</span>erforderlicher Umsatz für die Auszahlung',
        reactiveTime: 'Aktivitäts-Resetzeit:',
        reactiveTime1: '{h}:{m}:{s}',
        reactiveTime2: '{d}tage {h}:{m}:{s}',
        newbieBenefit: 'Vorteile Für Neue Spieler',
        daily: 'Tägliche Mission',
        weekly: 'Wöchentliche Mission',
        threeDays: '3 Tage Mission',
        arcane: 'Mystik-Aufgaben',
        collectAll: 'Alles Einsammeln',
        applyAll: 'Eine Klick -Anwendung',
        receiveDiscount: 'Erlaubnis Beantragen',
        receiveRecord: 'Bewerb.-aufzeichn.',
        receiveDiscountRequired: 'Bitte gib die Antwort auf die Frage ein',
        receiveDiscountSuccess: 'Einreichung des Antrags erfolgreich!',
        collect: 'Sammeln',
        processing: 'In Bearbeitung',
        forward: 'Gehe Zu',
        applyAward: 'Beantragen Sie eine Belohnung',
        collected: 'GESAMMELT',
        waitReview: 'Warte auf Bestätigung',
        applied: 'Bereits angewendet',
        distributed: 'Verteilt',
        noStart: 'Nicht<br/>Gestartet',
        expired: 'Abgelaufen',
        cancel: 'Abgesagt',
        invalid: 'Noch nicht aktiviert',
        dayCount: 'Der {x} Tag',
        finishTreeDay:
          'Erfüllen Sie an 3 aufeinanderfolgenden Tagendie Mission mit und lösen Sie die ultimativen Belohnungen ein!',
        threeDaysTips:
          'Erhalte nach Anforderung einen Bonus von <br /><span>{x}</span>',
        threeDaysSuccessTips: '<span>{x}</span> Bonus erhalten',
        taskUnstart: 'Die Mission wurde nicht freigegeben.',
        describe: {
          '0': 'Langfristige Aufgabe',
          '1': 'Langfristige Aufgabe (wird jeden Tag um 00:00 Uhr zurückgesetzt)',
          '2': 'Langfristige Aufgabe (wird jeden Montag um 00:00 Uhr zurückgesetzt)',
          '3': 'Langfristige Aufgabe (wird jeden Tag um 00:00 Uhr geupdatet)',
          time: 'Aufgabenzeit',
          condition: 'Aufgabenbedingungen',
          content: 'Inhalt der Aufgabe',
          rule: 'Beschreibung der Regel'
        },
        rulesDes:
          'Du kannst den Aufgabenbonus erst abheben, wenn {times} der Bedingungen erfüllt wurden.',
        receiveSussessTip: 'Erfolgreich erhalten!',
        thisTimeNotShow: 'Diese Sitzung nicht mehr anzeigen.',
        noMorePoptoday: 'Heute tauchen heute nicht mehr auf',
        neverPrompt: 'Nie darauf hinweisen (Überprüfung im Aufgabenzentrum)',
        neverPop: 'Niemals fordern',
        rewardWaitApprove:
          'Die Belohnung muss nach der Überprüfung überprüft werden',
        saveUrl: {
          title: 'Speichere die Seite zum Desktop-Tutorial',
          computer: 'PC-Ende',
          savingURLToGo:
            '1. Klicke auf die Aufgabe Website speichern und dann auf „Gehe Zu“',
          clickTheMore:
            '2. Klicke auf das „Mehr“-Symbol „{x}“ in der oberen rechten Ecke des Browsers',
          createShortcuts:
            'Klicke als nächstes auf > Weitere Werkzeuge > Shortcut erstellen',
          clickToCreate: '3. Klicke auf „Erstellen“',
          returnToTheDesktop:
            '4. Gehe zurück zum Desktop. Klicke auf die erstellte Desktop-Verknüpfung und öffne die Website, um die Belohnungen zu erhalten',
          chrome: 'Mobiltelefon Google-Browser',
          clickMoreIcon: '2. Klicke auf das „Mehr“-Symbol “{x}”',
          clickAdd: 'Klicke als nächstes auf „Zum Hauptbildschirm hinzufügen“',
          selectAdd: '3. Klicke „Hinzufügen“ und wähle „Hinzufügen“',
          safari: 'Mobiltelefon Safari-Browser',
          clickEnjoy: '2. Klicke die untere Teilen-Taste',
          selectToAdd: '3. Wähle „Zum Hauptbildschirm hinzufügen“'
        },
        timeNotArrived: {
          expiryTime: '{x} abgelaufen',
          tomorrow:
            'Diese Missionsbelohnung kann am nächsten Tag empfangen werden',
          weekWhole:
            'Diese Missionsbelohnung kann erst nächste Woche empfangen werden',
          monthWhole:
            'Diese Missionsbelohnung kann im nächsten Monat nicht empfangen werden',
          weekNext: 'Kann nächste Woche gesammelt werden',
          monthNext: 'Sie können es nächsten Monat bekommen'
        },
        only: 'Nur beschränkt auf:',
        onlyGame: 'Nur beschränkt auf Spiele.',
        onlyRecharge: 'Nur beschränkt auf Nachladungen.',
        contact: 'Kontaktmethode',
        close: 'Schließen',
        rechargeAtLeastOnce:
          'Sie müssen eine Aufladung durchführen, um es zu erhalten!'
      },
      event: {
        payAfter: 'Zusammenfassung der Aufladeaktivitäten',
        moreActivities: 'Weitere Events'
      },
      smartPay: {
        edit: 'Bearbeiten',
        closeButtonTips: 'Sie können es nach {s}s schließen',
        balance: 'Aktueller Gleichgewicht',
        recommendAmount: 'Empfohlene Aufladungsbetrag',
        recommendChannel: 'Empfohlener Zahlungskanal',
        give: 'Geschenk',
        payedAmount: 'Erwartet'
      },
      pay: {
        retry: 'Erneut versuchen',
        bobiBalance: 'Wellen-Währungssaldo',
        buyBobi: 'Kaufen Sie Wellen-Währung',
        title: 'Einzahlen',
        title2: 'Oben',
        onceTips:
          'Zum Wechseln klicken. Eingabe erfolgt gemäß der hoch/eingezahlten Währung',
        artificial: 'Manueller Kundenservice',
        record: 'Einzahlung\nEinträge',
        accountTotal: 'Kontostand',
        payBtn: 'Jetzt Einzahlen',
        bindBtn: 'Sofort binden',
        openNow: 'Sofort aktivieren',
        openBobi: 'Bitte aktivieren Sie das Waves-Währungs-Wallet umgehend',
        expand: 'Offenlegen',
        required: 'Erforderlich ',
        putAway: 'Aufgeben',
        payMoney: 'Einzahlungsbetrag',
        giveTip: 'Plus Aktivitätsbeschreibung',
        giveInfo:
          'Es kann durch den empfohlenen Betrag aufgeladen werden, bevor Sie das entsprechende zusätzliche Geschenk erhalten können.',
        payScore: 'Aufladungsbetrag',
        mark: 'Tipps',
        placeholder: 'Minimum{a}, Maximum{b}',
        suffix: 'Letzte Nummer {no}',
        lastNo: '**** {no}',
        firstNo: '{no} ****',
        channelLimit: 'Grenze. ({a}-{b})',
        give: 'Frei{num}',
        give2: 'Frei {num}%',
        copy: 'Kopieren',
        chatPay: 'Chat Einzahlen',
        accountNo: 'Konto: {no}',
        noBindUrlError:
          'Die Konfigurationsinformationen sind falsch. Bitte wenden Sie sich an den Kundendienst, um Hilfe zu erhalten!',
        artificialError:
          'Falsche Konfiguration des Kundendienstes für die Einzahlung',
        silverMerchantError:
          'Fehler bei der Konfiguration der Einzahlungsadresse des Bankhändlers',
        realName: 'Payers Richtiger Name',
        realNameRequired: 'Der Name darf nicht leer sein',
        cpfRemark:
          '(Bitte korrekt ausfüllen: Der CPF des Bestellzahlungskontos kann normal gutgeschrieben werden)',
        cpfPlaceholder: 'Bitte geben Sie die CPF -Nummer ein',
        realNameRemark:
          '(Bitte gebe den echten Namen des Bezahlungskontos an, damit der Betrag normal gutgeschrieben werden kann)',
        realNamePlaceholder: 'Bitte gebe den echten Namen des Zahlers ein',
        payEmpty1:
          'Derzeit gibt es bitte keinen für Sie geeigneten Einzahlungskanal',
        payEmpty2: 'Erfahren Sie mehr',
        realNameFreezePlaceholder:
          'Bitte gebe deinen echten Namen ein. Der Name kann später nicht mehr geändert werden',
        walletAddress: 'Geldbörsenadresse des Zahlenden',
        walletAddressRequired: 'Die Geldbörsenadresse darf nicht leer sein',
        walletAddressRemark:
          '(Die Geldbörsenadresse des Zahlenden zur reibungslosen Überweisung bitte korrekt ausfüllen)',
        walletAddressPlaceholder:
          'Bitte gib die Geldbörsenadresse des Zahlenden ein',
        personalInfo: 'Überprüfung der Informationen des Zahlenden',
        personalInfoRemark:
          '(Bitte gib die Daten des Einzahlers korrekt an, damit sie dem Konto ordnungsgemäß gutgeschrieben werden können)',
        personalPhoneInfoPlaceholder:
          'Bitte gib die Mobiltelefonnummer des Zahlenden ein',
        personalEmailInfoPlaceholder: 'Bitte gib die E-Mail des Zahlenden ein',
        personalPhoneInfoRequired:
          'Das Feld Telefonnummer kann nicht leer sein',
        personalEmailInfoRequired: 'E-Mail darf nicht leer sein',
        personalEmailInfoError: 'Email-Format-Eingabefehler',
        walletRecommendMoneyNone:
          'Vorübergehend kein Abhebungsschein verfügbar. Bitte erneut auswählen',
        walletRecommendMoneyNone1: 'Gegenwärtig keine große Anzahl',
        walletRecommendMoneyNone2: 'Gegenwärtig keine mittelgroße Anzahl',
        walletRecommendMoneyNone3: 'Gegenwärtig keine kleine Anzahl',
        bindQianNengWalletSuccess: 'Bindung erfolgreich',
        qianNengTitle: 'QianNeng-Gleichgewicht',
        toBuyQianNeng: 'Kaufsaldo',
        noWallet: 'Jedes hat einen Bonus zwischen <span>01 und 3.3%</span>',
        errorMoneyMsg1:
          'Der aktuelle Brieftaschenbetrag ist nicht ausreichend. Bitte kaufen oder wählen Sie zuerst andere Zahlungsmethoden!',
        errorMoneyMsg2:
          'Der aktuelle USDT -Saldo ist unzureichend. Bitte wählen Sie andere Zahlungsmethoden!',
        errorMoneyMsg3:
          'Derzeit ist der Restbetrag von Ziegeln nicht ausreichend. Bitte wählen Sie andere Zahlungsmethoden!',
        notBindQianNeng:
          'Sie haben Ihr QianNeng-Wallet noch nicht registriert oder verknüpft.',
        qianNengBindTip:
          '(Bitte korrekt ausfüllen: richtiger Name, Handynummer, um eine normale Bindung zu ermöglichen)',
        download: 'NO Wallet-APP',
        noWalletID: 'Brieftaschenkontonummer',
        max: 'Max',
        about: 'Um',
        exchangeRate: 'Wechselkurs',
        phonePlaceholder: 'Bitte Handynummer eingeben',
        walletTooltips: 'Belohnung {num}%',
        notBindUPAYWallet: 'Das System erstellt automatisch ein Upay -Konto',
        bindUPAYBtn: 'Sofort verwenden',
        UPAYBalance: 'Upay -Gleichgewicht',
        buyUPAYBtn: 'Kaufen Sie u Münze',
        bindUPAYSuccess: 'Registrieren und verbinden Sie es erfolgreich',
        total: 'Totale Borg',
        rate: 'Wechselkurs',
        fee: 'Gebühren',
        feeRate: 'Höhe der Bearbeitungsgebühr',
        realFee: 'Tatsächliche Bearbeitungsgebühr',
        deduction: 'Ermäßigung',
        realScore: 'Tatsächlicher Up-Betrag',
        feeErrorToast:
          'Der Auszahlungsbetrag muss höher als die Gebühren ({x}) sein',
        gameWalletBalance: 'No wallet-Guthaben',
        usdtBalance: 'USDT -Gleichgewicht',
        brickBalance: 'NO bewegende Ziegelbalance',
        notBindNoWallet:
          'Das vorhandene Konto können Sie sich bei der Bindung anmelden',
        notSettingPayPassword:
          'Zum ersten Mal verwenden? Legen Sie einfach das Zahlungspasswort fest',
        setting: 'Sofort einrichten',
        notBindBobiWallet:
          'Sie haben Ihr Waves-Währungs-Wallet noch nicht registriert oder verknüpft.',
        notBindGoubaoWallet:
          'Sie haben nicht gebannt, Schatzbrieftaschen zu kaufen',
        goubaoBalance: 'Kaufen Sie Bao Brieftaschenbalance',
        goubaoStep2:
          'Schritt 2: Klicken Sie auf, um den SMS -Verifizierungscode zu erhalten und auszufüllen',
        goubaoStep1:
          'Schritt 1: Scannen Sie den QR -Code mit der Kaufschatz -Brieftasche für Kontobindung:',
        goubaoQrCode: 'Kaufen Sie Bao QR -Code',
        payPwdRequired: 'Das Zahlungskennwort kann nicht leer sein',
        goubaoPayPwdPlayceholder: 'Bitte geben Sie das Kaufkennwort ein',
        qrcodeExpired:
          'Der zweidimensionale Code ist fehlgeschlagen. Bitte aktualisieren',
        qrcodeTime: 'QR -Code gültiger Zeit',
        bindNoWalletBtnText: 'Jetzt registrieren oder binden',
        balanceInsufficientText:
          'Bitte entscheiden Sie sich, direkt zu kaufen oder zu übertragen.',
        balanceInsufficientText2:
          'Das aktuelle Guthaben <b>„NEIN“ reicht nicht aus</b>. Möchten Sie jetzt kaufen?',
        thinkAgain: 'Lass mich noch einmal darüber nachdenken',
        balanceCancelText: 'Kaufe jetzt',
        offlineTransferText: 'Direkte Überweisung',
        rechargeSuccessful: 'Aufladung erfolgreich',
        refreshSuccessful: 'Aktualisierung erfolgreich',
        refreshFailed: 'Aktualisierung fehlgeschlagen',
        allCurrency: 'Alle Währungen',
        combination: {
          mobile: 'Handy-Nr.',
          walletAddress: 'Brieftaschenadresse',
          email: 'Post',
          name: 'Echter Name',
          cardNo: 'Kartennummer',
          cardNoRequired: 'Die Kartennummer darf nicht leer sein',
          cardNoPlaceholder: 'Bitte gib die Kartennummer ein',
          cardPass: 'Seriennummer',
          cardPassRequired: 'Die Seriennummer darf nicht leer sein',
          cardPassPlaceholder: 'Bitte gib die Seriennummer ein',
          networkMerch: 'Träger',
          networkMerchRequired: 'Der Träger darf nicht leer sein',
          networkMerchPlaceholder: 'Bitte wähle den Träger',
          onlineBank: 'Bank auswählen',
          onlineBankRequired: 'Die Bank darf nicht leer sein',
          onlineBankPlaceholder: 'Bitte wähle eine Bank'
        },
        table: {
          time: 'Zeit',
          method: 'Methode der Einzahlung',
          amount: 'Betrag',
          status: 'Status',
          action: 'Aktion',
          details: 'Details'
        },
        details: {
          title: 'Einzahlung Einzelheiten',
          name: 'Name des Zahlungsempfängers',
          no: 'Empfänger Kontonummer',
          bankName: 'Empfänger Bank',
          qrCode: 'Empfänger QR-Code',
          channel: 'Aufladekanal',
          method: 'Methode der Einzahlung',
          transaction: 'Transaktionstyp',
          createTime: 'Zeit Erstellt',
          payedTime: 'Tauschzeit',
          transferCertificate: 'Gutschein übertragen',
          orderNo: 'Auftrags-Nr',
          tripartiteWallet: 'Geldbörse einer dritten Partei',
          checkWallet: 'Drei-Parteien-Wallet anzeigen',
          frontRemark: 'Bestellnotizen',
          senderName: 'Name des Überweisers',
          placeHolder: 'Bitte gib den Namen des Überweisers ein',
          senderName2: 'Payers Richtiger Name',
          placeHolder2: 'Bitte gebe den echten Namen des Zahlers ein',
          transferRemk: 'Transfer Bemerkungen',
          transferRemkTip:
            '(Bitte geben Sie die Übertragungsregelungen korrekt ein. Sie können den Betrag schnell aktualisieren.)',
          transferRemkToast: 'Bitte geben Sie die Übertragungsreden ein',
          transferRemarkZFBPayTip: '(Optional können)',
          transferRemarkZFBPayPlaceholder:
            'Bitte geben Sie die Übertragungsreden ein, bis zu 255 Wörter',
          transferRemkPlaceholder:
            'Bitte geben Sie die Bestellnummer/Token/TXID ein, um die Überprüfung -in zu erleichtern',
          UTR: 'UTR',
          UTRPlaceholder: 'Bitte geben Sie die UTR -Nummer ein',
          UTRToast: 'Bitte geben Sie UTR {num} Bit ein',
          UTRPlaceholderLast4: 'Bitte geben Sie die 4 Ziffern nach UTR ein',
          UTRPlaceholderLast6: 'Bitte geben Sie 6 Ziffern nach UTR ein',
          UTRRemark:
            '(Bitte geben Sie die UTR -Nummer korrekt ein. Sie können das Grenzwert für Sie schnell aktualisieren.)',
          UTRRemarkLast4:
            '(Bitte geben Sie die 4 Ziffern nach UTR ein. Sie können den Betrag schnell aktualisieren.)',
          UTRRemarkLast6:
            '(Bitte geben Sie 6 Ziffern nach UTR ein. Sie können das Grenzwert für Sie schnell aktualisieren.)',
          uploadTransferCertificate: 'Einzahlungsnachweis hochladen',
          uploadTransferCertificateRemark1:
            'Klicke auf die Schaltfläche auf der linken Seite, um das Bild des Nachweises hochzuladen',
          uploadTransferCertificateRemark2:
            'Die Bildgröße darf 5 MB nicht überschreiten',
          uploadTransferCertificateRemark3:
            'Kann nach dem Hochladen nicht mehr geändert werden',
          uploadTransferCertificateRemark4:
            'Klicken Sie auf die Schaltfläche „Erneut hochladen“, um das Bild des Proofs hochzuladen',
          uploadTransferCertificateRequired:
            'Bitte lade den Einzahlungsnachweis hoch',
          cancelOrderContent1:
            'Sind Sie sicher, dass Sie die Bestellung stornieren möchten?',
          cancelOrderContent2:
            'Stornierungsbestellungen werden ungültig, Sie können erneut neue Aufladungsbestellungen einleiten ~',
          mark: '* Bitte gib für eine rechtzeitige Überweisung den korrekten Namen des Zahlers ein',
          confirm: 'Ich Habe Überwiesen',
          confirmRemark:
            'Wird in {seconds} Sekunden eingereicht. Fahre fort mit der Überweisung)',
          auditBtn: 'Wird überprüft',
          toPayBtn: 'Weiter aufladen',
          cancel: 'Bestellung Abbrechen',
          usdtText: 'USDT',
          usdtType: 'Währung',
          proto:
            'Hauptnetzwerk-Protokoll (z.B. Netzwerkkanal; das ist sehr wichtig)',
          address: 'Rechnungsadresse',
          usdtRemark1:
            '1. Bitte überprüfe den gutgeschriebenen Betrag nach Abzug der Auszahlungsprovisionen (d.h. der gutgeschriebene Betrag ist korrekt), oder der Betrag wird nicht eingezahlt.',
          usdtRemark2:
            '2. Bitte stelle sicher, dass das Mainnet-Protokoll für deine Überweisung/Aufladung mit deiner Wahl übereinstimmt. Andernfalls kann der aufgeladene/überwiesene Betrag dem Konto nicht gutgeschrieben oder erstattet werden.',
          usdtRemark3:
            '3. Nur USDT wird unterstützt. Bitte überweise keine anderen Währungen an diese Adresse.',
          cpf: 'Empfänger-CPF',
          cnpj: 'Kassierer cnpj',
          accountType: 'Kontotyp',
          noWalletRemark:
            'Du hast noch unerledigte Bestellungen. Bitte gehe zur Bestätigung zur Geldbörse.',
          goToWallet: 'Zur Geldbörse gehen',
          downloadQRCode: 'Herunterladen',
          transferRemark: 'Überweisungsbeleg',
          countdownText1: 'Bitte um',
          countdownText2: 'Vervollständigen Sie die Aufladung'
        },
        toast: {
          moneyIncorrect: 'Bitte gebe den korrekten Betrag ein',
          payFailed:
            'Aufladung fehlgeschlagen. Bitte kontaktiere den Kundenservice!',
          payZFBError:
            'Alipay App -Typ, wenden Sie sich bitte an den Kundendienst, um den Kanaltyp anzupassen',
          chargeMoneyQiannengError:
            'Der Einzahlungsbetrag darf das QianNeng-Guthaben nicht überschreiten',
          chargeMoneyBobiError:
            'Der Einzahlungsbetrag darf den Waves-Währungssaldo nicht überschreiten',
          chargeMoneyUPAYError:
            'Der Einzahlungsbetrag darf den Upay -Saldo nicht überschreiten'
        },
        backHome: 'Terug naar de spellobby',
        payDomainErrorToast:
          'Bitte wenden Sie sich an den Kundenservice, um den Namen der Zahlungsdomäne zu konfigurieren'
      },
      payQRCode: {
        tips1:
          'Bitte öffnen Sie Ihre Zahlungs-App und scannen oder kopieren Sie den untenstehenden QR-Code und fügen Sie ihn ein, um Ihren Kauf abzuschließen;',
        tips2:
          'Dieser QR-Code kann nur einmal bezahlt werden. Wenn Sie erneut bezahlen müssen, gehen Sie bitte zurück und laden Sie ihn auf.',
        tips3:
          'Nach erfolgreicher Zahlung können Sie zur Spielelobby zurückkehren und auf die Gutschrift der Punkte warten!',
        effectiveTime: 'Effektive Zeit',
        copyQRCode: 'QR-Code kopieren',
        orderStatus: 'Bestellstatus',
        createdTime: 'Zeit Erstellt',
        orderNo: 'Auftrags-Nr',
        qrCodeUrl: 'QR-Code-Adresse',
        merchantOrderNo: 'Bestellnummer des Händlers',
        timeoutTips: 'Der QR-Code ist abgelaufen',
        timeoutTips2:
          'Bitte kehren Sie in die Lobby zurück, um erneut eine Bestellung aufzugeben. Die aktuelle Seite wird in 10 Sekunden geschlossen.',
        successTips: 'Erfolgreich empfangen',
        successTips2:
          'Das System hat Ihnen automatisch eine Punktzahl zugewiesen',
        successTips3: 'Die aktuelle Seite wird nach 10 Sekunden geschlossen',
        chose: 'wählen',
        or: 'Oder',
        close: 'Schließe jetzt',
        checkOrder: 'prüfe die Reihenfolge',
        status: {
          wait: 'Audit-Einträge',
          timeout: 'Zeitüberschreitung',
          success: 'Bezahlung erfolgreich'
        }
      },
      passModal: {
        defaultTitle: 'PIN eingeben',
        withdraw: 'PIN zurückziehen',
        remark: 'Bitte gib für deine Kontosicherheit das Abhebungspasswort ein',
        forget: 'Passwort Vergessen?',
        ok: 'Bestätigen',
        next: 'Weiter'
      },
      forceChangePwd: {
        title: 'Passwort Ändern',
        tips: 'Du loggst dich zum ersten Mal ein oder setzt dein Passwort zurück. Wähle bitte ein sicheres Passwort für dein Konto.',
        successTips: 'Passwort wurde erfolgreich geändert'
      },
      forceBindPhone: {
        title: 'Handynummer beim Login verbinden',
        tips: 'Anmerkung: Bestätige vor der Teilnahme an Spielen deine Handynummer',
        successTips: 'Handy wurde erfolgreich verbunden'
      }
    },
    finance: {
      noUrlErrorTip:
        'Die Download -Link -Konfiguration ist falsch. Bitte wenden Sie sich an den Kundendienst für die Beratung!',
      getInfoError:
        'Der Status des Mitglieds wurde nicht empfangen, Bitte versuchen Sie es später noch einmal.',
      withdraw: {
        title: 'Abheben',
        tabs: {
          withdraw: 'Beantragen Sie den Widerruf',
          withdrawRecord: 'Abhebungseinträge',
          heaven_record: 'Wettaufgaben',
          account: 'Forderungen'
        },
        maintain: {
          closeTitle: 'Der Entnahmekanal wurde geschlossen',
          closeTime: 'Schließzeit',
          customer: 'Support Kontaktieren'
        },
        checkDetails: 'Einzelheiten anschauen',
        query: 'Abhebungssuche',
        schedule: 'Rückzugsfortschritt',
        orderSell: 'Bestellungen verkaufen',
        total: 'Gleichgewicht',
        yuebao: 'Interesse',
        remark: 'Muss noch wetten {num} setzen, um sich zurückzuziehen',
        betRequired: 'Muss noch wetten',
        toWithdraw: 'setzen, um sich zurückzuziehen',
        btn1: 'Regelmäßige Auszahlung',
        btn2: 'Abhebung ohne Geldbörse',
        btn3: 'Abhebung digitaler Währungen',
        account: 'Abhebekonto',
        addAccount: 'Abhebekonto hinzufügen',
        accountPlaceholder: 'Bitte wähle das Abhebungskonto',
        accountRequired: 'Bitte füge erst das Auszahlungskonto hinzu',
        withdrawAmount: 'Abhebebetrag',
        pleaseEnterWithdrawAmount: 'Bitte geben Sie den Auszahlungsbetrag ein',
        withdrawAmountPlaceholder: 'Minimum{a}, Maximum{b}',
        withdrawNoAccountPlaceholder:
          'Bitte wählen Sie zuerst das Auszahlungskonto aus',
        selectAccountPlaceholder:
          'Bitte fügen Sie ein Abhebungskonto hinzu, um abzuheben, bevor Sie abheben können',
        all: 'Alle',
        noRemark: 'Jede hat einen Zuschuss zwischen <span>1 und 2.1%</span>',
        download: 'NO Wallet-APP',
        withdrawPass: 'PIN zurückziehen',
        ok: 'Bestätigen',
        give: 'Zuschuss {number}',
        give2: 'Erhalte Subventionen {number}%',
        yearRate: 'Jährlich{number}%',
        exchangeRate: 'Abrechnungswechselkurs$1:{chart}{rate}',
        rate: 'Wechselkurs',
        bankLessNo: '(****{no})',
        bankLess2No: '****{no}',
        alipayTransfer: 'Alipay-Überweisung',
        wechatTransfer: 'WeChat-Übertweisung',
        alipayQR: 'Alipay QR-Code scannen',
        wechatQR: 'WeChat QR-Code scannen',
        crypto: 'Digitale Währung',
        withdrawSuccess:
          'Die Abhebung wird überprüft. Bitte achte auf den Kontostand.',
        show: 'Zeigen',
        hidden: 'Verstecken',
        noAuditText: 'Nehmen Sie nicht an der Prüfungsspielliste teil',
        noAuditListText:
          'Liste des Spiels, ohne in das Audit aufgenommen zu werden',
        noAuditSearchPlaceholder:
          'Bitte geben Sie die Spielplattform oder den Spielnamen ein',
        noAuditExplain:
          'Erläuterung: Der folgende Plattform- oder Spielwettenfluss wird automatisch ohne die Prüfung ausgeschlossen.',
        noAuditTip: 'Erinnerung: Wenn Sie Fragen haben, können Sie sich wenden',
        freeNotice: 'Diesmal fallen keine Bearbeitungsgebühren an',
        verifyAmount: 'Bitte gebe den korrekten Betrag ein',
        table: {
          time: 'Zeit',
          method: 'Abhebungsmethode',
          amount: 'Betrag',
          status: 'Status',
          type: 'Arten',
          action: 'Aktion',
          details: 'Details',
          total: 'Kumulierte Abhebung',
          heaven: 'Ausstehende Prüfungen'
        },
        details: {
          title: 'Abhebung-Details',
          method: 'Abhebungsmethode',
          createTime: 'Zeit Erstellt',
          orderNo: 'Auftrags-Nr',
          transaction: 'Transaktionstyp',
          address: 'Abhebungsadresse',
          net: 'Protokoll',
          usdtMethod: 'Abhebungsmethode',
          completeTime: 'Gesamtzeit',
          usdt: 'Abheben',
          usdtText: 'USDT',
          noWalletRemark:
            'Du hast noch unerledigte Bestellungen. Bitte gehe zur Bestätigung zur Geldbörse.',
          goToWallet: 'Zur Geldbörse gehen',
          cancelReason: 'Grund für den Abbruch',
          rejectReason: 'Grund für die Ablehnung',
          remark: 'Bemerkung'
        },
        auditRecordDetails: {
          title: 'Details zur Wettaufgabe',
          type: 'Quelle Typ',
          status: 'Aufgabenstatus',
          amount: 'Punkte erhalten/hinzufügen',
          range: 'Einsatzmultiplikator erforderlich',
          total: 'Gültige Wette erforderlich',
          needAudit: 'Muss noch wetten',
          audited: 'Bereits gültige Wette',
          limitPlatform: 'Ausgewiesene Spieleplattform',
          limitGame: 'Spiele begrenzt',
          time: 'Zeit Erstellt',
          activeName: 'Event Name',
          completedTime: 'Gesamtzeit'
        },
        accountReceivable: {
          bank: 'Abhebekonto',
          alipay: 'Alipay',
          wechat: 'WeChat',
          addDefault: 'Als Default einstellen',
          disable: 'Deaktiviert',
          disabled: 'Wurde suspendiert',
          qr: 'QR-Code Scan',
          crypto: 'Digitale Währung',
          transfer: 'Überweisung',
          add: 'Hinzufügen zu',
          cryptoName: 'Virtuelle Währung',
          pix: 'PIX',
          upi: 'UPI',
          wallet: 'Geldbörse einer dritten Partei'
        },
        add: {
          account: 'Konto',
          addBank: 'Bankkarte Hinzufügen',
          addWechatDef: 'WeChat hinzufügen',
          addWechat: 'WeChat-Überweisung hinzufügen',
          addWechatQR: 'WeChat QR-Code hinzufügen',
          addAlipayDef: 'Alipay hinzufügen',
          addAlipay: 'Alipay-Überweisung hinzufügen',
          addAlipayQR: 'Alipay QR-Code hinzufügen',
          bankNo: 'Bankkartenummer',
          bankNoRemark:
            '(Bitte überprüfe die Nummer der Karte sorgfältig, sonst wird es nicht auf das Konto gutgeschrieben)',
          bankNoPlaceholder: 'Bitte Bankkartennummer eingeben',
          bank: 'Bank',
          bankPlaceholder: 'Bitte wähle die ausstellende Bank',
          bankDetail: 'Sie müssen die kontoeröffnende Bankfiliale eingeben!',
          bankDetailPlaceholder: 'Bitte geben Sie die Bank-Filiale ein',
          branchBank: 'Bankfilialen',
          branchBankPlaceholder:
            'Bitte geben Sie die Bankfiliale 4 Ziffern 4 Ziffern ein',
          bankDetailIFSC: 'IFSC darf nicht leer sein',
          remark:
            'Bitte überprüfe den Namen und die Nummer der Karte sorgfältig, um Probleme bei der Überweisung zu vermeiden',
          remark2:
            'Bitte überprüfe das Konto sorgfältig, um Probleme bei der Überweisung zu vermeiden',
          remark3:
            'Bitte lade den Sammlungscode mit deinem echten Namen hoch, um Probleme bei der Überweisung zu vermeiden',
          remark4:
            'Nur Dateien im Format png, jpg, etc. werden unterstützt und die Größe darf 2MB nicht überschreiten',
          realName: 'Echter Name',
          realNamePlaceholder: 'Bitte gib den Namen ein',
          realNameUpperCaseRemark:
            '(Sie können nur die englischen Buchstaben ausfüllen!)',
          realNameRemark:
            '(Bitte überprüfe den echten Namen sorgfältig, sonst wird es nicht auf das Konto gutgeschrieben)',
          alipayNo: 'Das Feld Alipay ID darf nicht leer sein.',
          alipayNoPlaceholder: 'Telefonnummer oder E-Mail',
          alipayNoRemark:
            'Alipay-Konto ist ungültig, es muss ein Mobiltelefon oder eine E-Mail sein',
          wechatNo: 'Wechat -Konto kann nicht leer sein',
          wechatNoPlaceholder: 'Bitte WeChat ID eingeben',
          wechatQR: 'WeChat-Empfängernummer',
          alipayQR: 'Alipay-Empfängernummer',
          transfer: 'Bankkonto überweisen',
          receiveQR: 'Empfänger Nummer',
          ok: 'Bestätigen',
          nextStep: 'Weiter',
          retry: 'Hochladen',
          setDefaultSuccess: 'Erfolgreich eingestellt',
          noWalletNobind: 'Sie sind noch nicht gebunden worden',
          nowalletId: 'Brieftaschenkontonummer:',
          noWalletBalance: 'NO brieftaschenbalance:',
          delSuccess: 'Erfolgreich gelöscht',
          addSuccess: 'Erfolgreich hinzugefügt',
          alreadyBindCPF: 'Dieses Konto wurde gebunden',
          addWalletAccount: 'Die Geldbörse einer dritten Partei hinzufügen',
          addCryptoAccount: 'Virtuelles Währungskonto hinzufügen',
          addCrypto: 'Virtuele Valuta Toevoegen',
          addWallet: 'Die Geldbörse einer dritten Partei hinzufügen',
          addWalletAddress: 'Die Adresse der Geldbörse hinzufügen',
          wallet: 'Geldbörse',
          cionType: 'Währung',
          protocol: 'Protokoll',
          address: 'Die Adresse kann nicht leer sein',
          walletAddressPlaceholder: 'Bitte gib die Adresse der Geldbörse ein',
          addressLabel:
            'Bitte bestätigen Sie die Anpassung von Währung, Vereinbarung und Adresse. Andernfalls können Sie das Konto nicht erhalten',
          addressPlaceholder: 'Bitte geben Sie die Kryptowährungsadresse ein',
          addressRemark:
            'Bitte bestätigen Sie die Anpassung von Währung, Vereinbarung und Adresse. Andernfalls können Sie das Konto nicht erhalten',
          cryptoRemark:
            'Hinweis: USDT unterstützt Abhebungsadressen, die dem TRC20-Protokoll unterliegen!',
          addPIX: 'PIX hinzufügen',
          addPIXAccount: 'PIX-Konto hinzufügen',
          accountType: 'Kontotyp',
          PIXAccount: 'PIX-Konto',
          PIXAccountPlaceholder: 'Bitte gebe dein PIX-Konto ein',
          CNPJAccountPlaceholder: 'Bitte geben Sie die CNPJ -Nummer ein',
          CPF: 'CPF',
          CPFPlaceholder: 'Bitte geben Sie die 11 -digit -CPF -Nummer ein',
          addUPI: 'UPI hinzufügen',
          addPayMaya: 'Fügen Sie PayMaya hinzu',
          addGrabPay: 'Fügen Sie GrabPay hinzu',
          PayMayaAccount: 'PayMaya -Konto',
          GrabPayAccount: 'GrabPay -Konto',
          PayMayaFieldPlaceholder:
            'Geben Sie Ihr PAYMAYA-Konto beginnend mit 0 ein',
          GrabPayFieldPlaceholder: 'Bitte geben Sie das GrabPay -Konto ein',
          UPIAccount: 'UPI-Konto',
          UPIAccountPlaceholder: 'Bitte UPI-Konto eingeben',
          addMOMO: 'MOMO hinzufügen',
          MOMOAccount: 'MOMO-Kontonummer',
          MOMOAccountPlaceholder: 'Bitte gib die MOMO-Kontonummer ein',
          addZALO: 'ZALO hinzufügen',
          ZALOAccount: 'ZALO-Kontonummer',
          ZALOAccountPlaceholder: 'Bitte gib die ZALO-Kontonummer ein',
          addHuiW: 'Fügen Sie HUIONE hinzu',
          huiWAccount: 'HUIONE -Konto',
          huiWAccountPlaceholder:
            'Bitte geben Sie die Kontonummer der Huiwang -Brieftasche, die schöne Nummer/ID/Handynummer ein',
          remark5:
            'Bitte sorgfältig überprüfen, sonst wird der Betrag dem Konto nicht gutgeschrieben.',
          fileNull: 'Bitte lade den Erhalt-Code mit dem echten Namen hoch',
          addGCASH: 'GCASH-Konto hinzufügen',
          addCLABE: 'Fügen Sie Clabe hinzu',
          addRocket: 'Rocket hinzufügen',
          addBKash: 'BKash hinzufügen',
          addSureCash: 'SureCash hinzufügen',
          addNagad: 'Nagad hinzufügen',
          addUPAY: 'UPAY hinzufügen',
          addOVO: 'OVO hinzufügen',
          addDANA: 'DANA hinzufügen',
          addLINKAJA: 'LINKAJA hinzufügen',
          addGOPAY: 'GOPAY hinzufügen',
          addDOKU: 'DOKU hinzufügen',
          addGoTymeBank: 'Fügen Sie die Gotyme Bank hinzu',
          addPaga: 'Paga hinzufügen',
          addFlutterwave: 'Fügen Sie Flutterware hinzu',
          addPaystack: 'Paystack hinzufügen',
          addInterswitch: 'Fügen Sie Interswitch hinzu',
          addOpay: 'Fügen Sie Opay hinzu',
          addCellulant: 'Cellulans hinzufügen',
          addKongapay: 'Fügen Sie Kongapay hinzu',
          addLINEPay: 'Zeilenpay hinzufügen',
          addApplePay: 'Zeilenpay hinzufügen',
          gcashField: 'GCASH-Konto',
          CLABEField: 'Clabe -Account',
          CLABEValidate:
            'Ihr Konto ist falsch. Bestätigen Sie die Einreichung?',
          RocketField: 'Rocket-Konto',
          bKashField: 'BKash-Konto',
          SureCashField: 'SureCash-Konto',
          NagadField: 'Nagad-Konto',
          UPAYField: 'UPAY-Konto',
          OVOField: 'OVO-Konto',
          DANAField: 'DANA-Konto',
          LINKAJAField: 'LINKAJA-Konto',
          GOPAYField: 'GOPAY-Konto',
          DOKUField: 'DOKU-Konto',
          GoTymeBankField: 'Gotyme Bank -Konto',
          PagaField: 'PAGA -Konto',
          FlutterwaveField: 'Flutterware -Konto',
          PaystackField: 'PayStack -Konto',
          InterswitchField: 'Interswitch -Konto',
          OpayField: 'Opy Account',
          CellulantField: 'Cellulant Account',
          KongapayField: 'Kongapay -Konto',
          LINEPayField: 'Linepay -Konto',
          ApplePayField: 'Linepay -Konto',
          RocketFieldPlaceholder: 'Bitte geben Sie das Raketenkonto ein',
          bKashFieldPlaceholder: 'Bitte geben Sie das BKASH -Konto ein',
          SureCashFieldPlaceholder: 'Bitte geben Sie das SURECASH -Konto ein',
          NagadFieldPlaceholder: 'Bitte geben Sie das Nagad -Konto ein',
          UPAYFieldPlaceholder: 'Bitte geben Sie das Upay -Konto ein',
          OVOFieldPlaceholder: 'Bitte geben Sie das OVO -Konto ein',
          DANAFieldPlaceholder: 'Bitte geben Sie das Dana -Konto ein',
          DANARemark: 'Bitte geben Sie die Handynummer ein, beginnend mit 0',
          LINKAJAFieldPlaceholder: 'Bitte geben Sie das Linkaja -Konto ein',
          GOPAYFieldPlaceholder: 'Bitte geben Sie das Gopay -Konto ein',
          DOKUFieldPlaceholder: 'Bitte geben Sie das Doku -Konto ein',
          PagaFieldPlaceholder: 'Bitte geben Sie das PAGA -Konto ein',
          FlutterwaveFieldPlaceholder:
            'Bitte geben Sie das Flutterwave -Konto ein',
          PaystackFieldPlaceholder: 'Bitte geben Sie das Paystack -Konto ein',
          InterswitchFieldPlaceholder:
            'Bitte geben Sie das Interswitch -Konto ein',
          OpayFieldPlaceholder: 'Bitte geben Sie das Opay -Konto ein',
          CellulantFieldPlaceholder: 'Bitte geben Sie das Cellulant -Konto ein',
          KongapayFieldPlaceholder: 'Bitte geben Sie das Kongapay -Konto ein',
          LINEPayFieldPlaceholder: 'Bitte geben Sie das Zeilenpay -Konto ein',
          ApplePayFieldPlaceholder: 'Bitte geben Sie das Zeilenpay -Konto ein',
          gcashFieldPlaceholder: 'GCASH-Konto beginnend mit 0 eingeben',
          GoTymeBankFieldPlaceholder: '',
          inputLengthExcessed:
            'Nachdem Sie ein Leerzeichen eingegeben haben, können Sie mit der Eingabe fortfahren.',
          inputMaxLengthExcessed: 'Max: {leng} Zeichen. Raum zum Trennen.',
          addAccount: '{name} hinzufügen}',
          accountName: '{name} Konto',
          accountPlaceholder: 'Bitte geben Sie {name} Kontonummer ein',
          IBANCode: 'IBAN Code',
          IBANCodePlaceholder: 'Bitte geben Sie 26 -bit Iban Code ein',
          IBANCodeVerify:
            'Insgesamt 26 -Bit -Zeichen müssen zu Beginn von TR gestartet werden',
          companyNamePlaceholder:
            'Der BET -Betrag kann nur auf eine Ganzzahl mit mehr als 0 wetten',
          companyName: 'Name der Firma',
          accountFormatError: 'Kontofehler',
          digitOnly: 'Unterstützen Sie nur reine Zahlen'
        },
        warning: {
          needRecord:
            'Die Überprüfung ist noch nicht abgeschlossen, weshalb eine Bargeldauszahlung noch nicht möglich ist',
          withdrawAmountMinError:
            'Dein Auszahlungsbetrag muss größer oder gleich {a} sein',
          withdrawAmountMaxError:
            'Dein Auszahlungsbetrag muss kleiner oder gleich {a} sein',
          cpf: 'Es muss 11 -Bit -Reine Zahlen sein',
          email: 'Bitte geben Sie das richtige Postfachformat ein',
          evp: 'Bitte gebe 36 Zeichen ein.',
          disableAccount: 'Das Entnahmekonto wurde geschlossen',
          phone: 'Bitte gebe {range} Zahlen ein',
          gcashPhone: 'Bitte geben Sie die 11 -da -Nummer ab, ab 0',
          cpfUnanimousPix: 'CPF -PIX -Konto muss mit CPF übereinstimmen',
          pixPhoneNoStartWithZero:
            'Der Anfang ist nicht 0 und muss 11 Ziffern reiner Zahlen betragen',
          pureDigital: 'Muss {range} bit reine Zahlen',
          pixNonEmpty: 'Sie haben ein PIX -Konto, das nicht ausgefüllt ist!',
          cpfNonEmpty: 'Sie haben CPF und Sie haben sich nicht ausgefüllt!',
          companyNameNonEmpty:
            'Bitte geben Sie den Namen des Unternehmens ein!',
          bankNoNonEmpty: 'Müssen das Bankkonto eingeben!',
          bankNonEmpty: 'Sie müssen eine Bank wählen!',
          branchBankNonEmpty: 'Sie müssen die Bankfiliale 4 -Ziffern eingeben!',
          realNameNonEmpty: 'Müssen den richtigen Namen eingeben!',
          bankIFSC: 'Bitte geben Sie den richtigen IFSC -Code ein',
          evpVerify: 'Bitte geben Sie das richtige EVP -Format ein'
        },
        withdrawText: {
          alipay: 'Machen Sie Alipay wieder her',
          wechat: 'Zesie auf Wechat',
          bank: 'Abheben auf Bankkarte',
          crypto: 'Abzug zu digitaler Währung',
          wallet: 'Subs zu einer Drei -Party -Brieftasche',
          huiW: 'Gettle nach Huiwang',
          NoWallet: 'Anfrage an keine Brieftasche',
          withdrawCashTo: 'Ausstellung zu{to}'
        }
      },
      center: {
        wallet: {
          title: 'Das Gleichgewicht abrufen',
          balance: 'Gesamter Kontostand',
          recycle: 'Ein Klick zum Abrufen',
          searchPlatform: 'Plattformsuche:',
          refreshGoldSuccessText: 'Alle saldi zijn teruggetrokken',
          refreshGoldFailText:
            'Er zijn momenteel geen tegoeden die kunnen worden opgenomen',
          prompt: 'Es kann nur die Mahlzeitenbalance zurückziehen',
          updateError: 'Scheitern',
          pending: 'Loading',
          findBackTips:
            'Sie können das Ganzzahl mehrfach des Gleichgewichts nur abrufen (dh kein Dezimalpunkt)'
        }
      }
    },
    aside: {
      music: {
        modalConfigTitle: 'Musik',
        modalLibraryTitle: 'Liste',
        xhbf: 'Kreis',
        sj: 'Zufällig',
        dqxh: 'Wiederholen',
        qk: 'Liste',
        tabSys: 'System-Musik',
        tabMy: 'Meine Musik',
        toastMessage: 'Letztes Lied kann nicht gelöscht werden',
        toastDeleteTitle: 'Tipps',
        toastDeleteMessage: 'Löschen?',
        toastCancel: 'Abbrechen',
        toastOk: 'Bestätigen',
        noMoreMusic: 'Es gibt derzeit keine Lieder zum Abspielen',
        noMoreNewMusic: 'Derzeit keine neuen Songs',
        downloaded: 'Heruntergeladen',
        downloadError: 'Musikressource Download fehlgeschlagen!'
      },
      jackpot: {
        title: 'JACKPOT',
        record: 'Raumrekorde',
        modelTitle: 'Jackpot-Rekorde',
        table: {
          time: 'Zeit',
          nickname: 'Spieler-Spitzname',
          gameName: 'Gewonnene Spiele',
          winningPrize: 'Gewinne'
        }
      },
      ping: {
        network: 'Netzwerk',
        networkLine: 'Server ',
        currentNetworkLine: 'Aktueller Server',
        unavailable: 'Die Linie ist nicht verfügbar',
        selectLine: 'Server Auswählen',
        checkLine: 'Zeilenerkennung'
      }
    },
    gameMenu: {
      all: 'Alle',
      home: 'Startseite',
      loadingRecent: 'Neueste',
      loadingCollect: 'Favoriten',
      loadingDemo: 'Spieler-Demo',
      menu0: 'Heiß',
      menu1: 'Karten',
      menu2: 'Angeln',
      menu3: 'Arkade',
      menu4: 'Live',
      menu5: 'Sport',
      menu6: 'Hahnenkampf',
      menu7: 'E-Sports',
      menu8: 'Lotterie',
      menu9: 'Club',
      menu10: 'Freund',
      menu11: 'Blockchain',
      menu20: 'Spieler-Demo',
      allmenu1: 'Alle Karten',
      allmenu2: 'Alle Angeln',
      allmenu3: 'Alle Arkade',
      allmenu11: 'Alle Blockchain-Spiele',
      allmenu20: 'Spieler-Demo',
      menuClub: 'Club',
      menuFriend: 'Freund',
      tipsClub: ' Het kan alleen aan de APP-kant worden gebruikt!',
      toDownloadApp: 'Jetzt herunterladen',
      NotToDownloadApp: 'Download Later'
    },
    stakeSystem: {
      discount: 'Promotion Center',
      fastShare: 'Schnelles Teilen',
      onlineSupport: 'Online-Support',
      support: 'Hilfecenter'
    },
    system: {
      activity: 'Event',
      task: 'Mission',
      rebate: 'Live-Rabatt',
      award: 'Belohnungen',
      vip: 'VIP',
      promote: 'Promotion',
      yuebao: 'Interesse',
      service: 'Support-Center',
      service2: 'Kunden-\nSupport',
      report: 'Persönlicher\nBericht',
      more: 'Mehr',
      vip2: 'Privilegiengesellschaft',
      vip3: 'Kaiserkonferenz',
      interest: 'Interesse',
      rechargeFund: 'Provident Fund'
    },
    game: {
      nav: {
        fastNews: '',
        clickLogin: 'Anmeldung',
        signUp: 'Registrieren',
        or: 'Oder',
        loginBalance: 'Das Guthaben nach dem Einloggen überprüfen',
        Interest: 'Interesse',
        yuebao: 'Interesse',
        vip: 'VIP',
        promote: 'Promotion',
        active: 'Event',
        task: 'Mission',
        backwater: 'Rückgabe',
        prizeFeedback: 'Belohntes Feedback',
        security: 'Sicherheits-Center',
        settings: 'Persönliche Informationen',
        accountDetails: 'Kontoauszug',
        bettingRecord: 'Wetteinsätze Einträge',
        personalStatement: 'Persönlicher\nBericht',
        award: 'Gewinn',
        withdrawalManagement: 'Abhebungsverwaltung',
        network: 'Netzwerk-Status',
        language: 'Sprache',
        wallet: 'Geldbörse',
        audit: 'Wettaufgaben',
        facebook: 'Facebook',
        google: 'Google',
        line: 'Line',
        wechat: 'WeChat',
        qq: 'QQ',
        fastNewsLabel: 'Newsletter',
        discount: 'Event',
        waitingCollect: 'Ausstehend',
        receiveRecord: 'Sammelverlauf'
      },
      home: 'Lobby',
      lobby: 'Empfangshalle',
      recent: 'Neueste',
      collect: 'Meine Favoriten',
      demo: 'Demo Abspielen',
      openDemoGameTip:
        'Sie treten in die Versuchserfahrung ein, Sie können nach der Rentabilität nicht Geld abheben',
      demoGameToRegTip:
        'Warten Sie nicht, bis sich jemand sofort registriert, ohne zu warten, um den Preis zu gewinnen! Verlieren Sie nicht die Maschine, nicht mehr!',
      all: 'Alle',
      hot: 'Heiß',
      allHot: 'Heiß',
      searchResults: 'Suchergebnisse',
      hotCommend: 'Top-Auswahl',
      menue: 'Spiele',
      egame: 'E-Sports',
      loadingAll: 'Alle',
      empty: 'Noch keine Spiele',
      maintain: 'Wartung',
      gameMaintainText: 'Das Spiel befindet sich in der Wartung',
      platformClose:
        'Die Spieleplattform ist offline, bitte versuche es später erneut',
      fetchingPrize:
        'Goldmünzen werden schnell geladen. Bitte versuche es später erneut.',
      goldInadequate:
        'Sie haben weniger als  {gold}, auf Ihrem Konto. Laden Sie schnell neu auf und beginnen Sie mit der Eroberung!',
      quotaRatioPrompt:
        'Ihr aktueller Kontostand beträgt {balance}, der entsprechend dem Verhältnis von {proportion} eingebracht wird. Nach dem Einbringen beträgt der angezeigte Betrag: {amount}',
      enterGame: 'Spiel Betreten',
      scrollDown: 'Herunterscrollen',
      loadingInfo: 'Zeigt {count} Spiel(e) von {total} {type} Spielen an',
      loadingHot: 'Heiß',
      loadingRecent: 'Neueste',
      loadingCollect: 'Favoriten',
      loadingDemo: 'Spieler-Demo',
      loadingMore: 'Mehr laden',
      loadinged: 'Loading',
      searchHistory: 'Such-Geschichte',
      searchGame: 'Nach Spiel suchen',
      search: 'Suchen',
      deleteAll: 'Alles löschen',
      recommend: 'BEST',
      takeOutScore: 'Klicken Sie auf Ergebnis aktualisieren',
      gameContinueTips:
        'Sie haben das Spiel noch nicht beendet, bitte fahren Sie fort.',
      confirmExitGame:
        'Um Ihren Betrag rechtzeitig zu synchronisieren, kehren Sie bitte nach Spielende in die Lobby zurück.',
      returnLobby: 'Zurück zur Lobby',
      enterCurrenctGame: 'Betreten Sie das aktuelle Spiel',
      continueGame: 'Setzen Sie das Spiel fort',
      continueGameTips:
        'Das letzte Spiel läuft. Möchten Sie das Spiel fortsetzen?',
      nopermission: 'Dieses Konto hat keine Spielberechtigungen',
      needBindBankCard:
        'Für ein besseres Spielerlebnis musst du zuerst einen Zahlungsempfänger binden',
      needFirsstRecharge:
        'Für Ihr Spielerlebnis müssen Sie zuerst den ersten Aufladen abschließen',
      needDownloadApp:
        'Laden Sie die App herunter und verwenden Sie die App, um das Spiel fortzusetzen!',
      noMatchesLive: 'Es gibt derzeit keine Live-Events',
      otherLiveList: 'Andere Live-Events',
      liveEnded: 'Die gegenwärtige Live-Übertragung hat geendet',
      noLiveForNow: 'Es gibt derzeit keine Live-Events',
      worldCupLiveWillStart:
        'Die Weltmeisterschaft hat begonnen. Klicke um zu wechseln',
      drag: 'DRAG',
      liveError:
        'Die derzeitige Reihe ist instabil. Bitte wechsle zu einer anderen Reihe',
      worldCup: 'Weltmeisterschaft',
      refresh: 'Neu laden',
      fullScreen: 'Vollbild',
      update: 'UPDATE',
      new: 'NEU',
      suggest: 'BEST',
      exitFullScreen: 'Vollbild verlassen',
      crownGold: {
        title: 'Kronensport',
        desc: 'Genießen Sie beliebte Top-Events und genießen Sie den Sturm auf dem Spielfeld',
        imgTitle1: 'Stephen Curry',
        imgDesc1: 'Exklusive Bildbotschafter der asiatischen Marke',
        imgTitle2: 'Argentinische Nationalmannschaft',
        imgDesc2: 'Asianer offizieller exklusiver Partner',
        imgTitle3: 'Barcelona Club',
        imgTitle4: 'Manchester United Club',
        bodyLeft1: 'Frauenfußball -Weltmeisterschaft',
        bodyDesc1: 'Offizielle Wettplattform',
        bodyLeft2: 'Basketball -Weltmeisterschaft',
        bodyLeft3: 'Asiatischer Tasse',
        bodyLeft4: 'Europäischer Pokal',
        bodyLeft5: 'American Cup',
        bodyLeft6: 'Pariser Olympischen Spiele',
        bodyRightTitle: 'Das aufregende Ereignis wird verschickt',
        bodyRightDesc:
          'Die höchsten Chancen in der Branche, täglich Tausende von Sportveranstaltungen, die weltweit Sport und Liga abdecken. Geben Sie mehrere Quiz-, Größe, Semi -Full -Feld, Wellen und Doppel, Gesamtziele, Ziele, Serien von Levels usw. und Live -Sendungen an, sodass Sie die beste Wettzeit leicht erfassen können!',
        football: 'Fußball',
        basketball: 'Basketball',
        tennis: 'Tennis',
        snuock: 'Snooker',
        volleyball: 'Volleyball',
        f1: 'Rennauto',
        baseball: 'Baseball',
        football2: 'Rugby',
        copyRight: 'Galaxy Group Copyright',
        logosBjl: 'Baccarat',
        logosLp: 'Roulette',
        logosSb: 'Sic Bo',
        logosLh: 'Dragon Tiger',
        logosNn: 'Bull Bull',
        logosZjh: 'Win Three Cards',
        logosSg: 'San Gong',
        logosSsc: 'Rechtzeitig',
        logosLhc: 'Sechs',
        logosSyxw: '11 Wählen Sie 5',
        logosBjsc: 'Peking Auto',
        logosXync: 'Glückliche Farm',
        logosJssc: 'Speed ​​Racing',
        legend: 'League of Legends',
        kingHonor: 'König Ruhm',
        stoneLegend: 'Hearthstone',
        watchPioneer: 'Overwatch',
        logosGjzl: 'FIFA',
        crownVIP: 'VIP-Royal-Vorteil',
        gamingDesc:
          'Die weltweit führenden Wettbewerbe sind vollständig abgedeckt und bieten professionelle Quotendaten und die Siedlung von Obstdaten. Die durchschnittliche Tageszeitung bietet mehr als 100 E -Sport -Veranstaltungen, ein neues Gameplay von 50+E -Sports, 10+E -Sports -Roll -Dial, dem besten Markt in der Branche. Die erstaunliche visuelle Oberfläche und effiziente Benutzererfahrung machen Sie einfach zu beginnen.',
        lotteryDesc:
          'Konzentration auf die Lotteriespielbranche viele Jahre, dem ersten Blockchain -Lotto -Ticket der Branche, viele exklusive innovative Gameplays, sehr einfach zu bedienende Spielschnittstelle, multi -regionale offizielle Zeit -Lotterie, 11, PK10, PC -Eier und offizielles Liuhecai können nicht kommen Aus den Haushalten können es die ganze Zeit genießen!',
        porkerDesc:
          'Bieten Sie ein umfassendes und diversifiziertes Gameplay, schnappen Sie sich Dutzende von beliebtem Schach und Kartenspielen wie Zhuang Niu Niu, Baccarat, brüten goldene Blumen, Vermieter, zwei Mahjong, Dragon und Tiger -Kämpfe usw. und kämpfen Sie wirklich mit Freunden und anderen Spielern. Schach!',
        realDesc:
          'Die kreativste und spielerischste Unterhaltungsplattform der Branche, die professionelle technische Unterstützung, die erstklassige stabile Ausrüstung, Hunderte von professionellen geschulten Händlern und Simulations -Casino -Umgebungen, die Spieler Spaß haben, spüren die immersive Situationatmosphäre!',
        sportsDesc:
          'Verschiedenes Gameplay, Hochwertigkeitserfahrung, vollständige Berichterstattung über Sportveranstaltungen, hundert Gameplays in einem Spiel, einfache Operation, zufriedenstellende neue und alte Nutzer erleben besondere Ereignisse, Erfahrung in der Erfahrung und besondere, 15 -minütige Ball, Größe, alleine Gewinnen usw. Genießen Sie zu jeder Zeit Leidenschaft.'
      },
      galaxyGold: {
        searchTip: 'Bitte geben Sie den Spielnamen ein',
        backTop: 'Zurück nach oben',
        elecGame: 'Elektronische Unterhaltung',
        elecGameDesc:
          'Klassische Spielautomaten -Plattform, Zehntausende von Spielautomaten -Spielen, lassen Sie Sie frei spielen. Es wurde im Herzen von Handwerkern festgehalten und bietet den Spielern das ultimative Spielerlebnis. Die Tentakel können zig Millionen kumulativer Preise sein und darauf warten, dass Sie berühren!',
        seeMore: 'Mehr sehen',
        elecTips: 'Top -Unterhaltung zu schätzen wissen',
        porkerFishTips: 'Helle Galaxie perfekte Erfahrung',
        porker: 'Schachspiel',
        porkerTips:
          'Greifen Sie auf Manor Niu Niu Dragon Tiger Fighting, mehrere Schach und Karten, zeigen Sie Ihren Verstand mit Schach und Karten, konkurrieren und Unterhaltung Gehirnbrand, Freunde treffen Wettbewerb und Spiele verändern ihr Leben!',
        fishing: 'Angelspiel',
        fishingTips:
          'Fischereispiele kommen stark, viele beliebte Plattformen, die jeden Tag Geschenke geben, Gott des Wohlstands angeln, mit Tausenden von Waffen angeln, Fischteiche sind voll und warten darauf, dass Sie spielen!',
        game4Tips: 'Alle Gefühle haben angenehm',
        realPerson: 'Live-Video',
        electric: 'E-Sports',
        lottery: 'Lotteriespiel',
        sports: 'Sportveranstaltung',
        realPersonTips:
          'Die kreativsten und gamingsten Unterhaltungsplattformen der Branche, die professionelle technische Unterstützung, die stabile Ausrüstung, Hunderte von Berufstrainingsbeamten und Simulations -Casino -Umgebungen, die die Spieler Spaß machen können.',
        electricTips:
          'Die professionellste E -Sport -Plattform in Asien ist für verschiedene E -Sport -Spieler ausgelegt. Sie verfügt über die oberste visuelle Schnittstelle und effizientes Wettenerlebnis. Sie vereint die heißesten und heißesten Ereignisse im gesamten Netzwerk, aus dem Sie auswählen können.',
        lotteryTips:
          'Die professionellste E -Sport -Plattform in Asien ist für verschiedene E -Sport -Spieler ausgelegt. Sie verfügt über die oberste visuelle Schnittstelle und effizientes Wettenerlebnis. Sie vereint die heißesten und heißesten Ereignisse im gesamten Netzwerk, aus dem Sie auswählen können.',
        sportsTips:
          'Genießen Sie die höchsten Chancen in der Branche, decken Sie die beliebtesten Veranstaltungen auf der ganzen Welt, mehrere Quiz, Animation Live -Sendung, Live -Video ab und ermöglichen Sie es, unterhaltsamen Wetten zu erleben und den Ball zu genießen.',
        appTitle: 'Offizielle App Galaxy Group',
        appSubTitle: 'Dachte ein zu einer Zeit, Genuss jederzeit',
        appDesc:
          'Die mobile Wettplattform steht vor den gesamten Netzwerkplayern und bietet fast 10.000 elektronische Unterhaltung, Spielautomaten, Baccarat- und Lotteriespiele, Sportwetten, Online-Einlagen und Online-Abhebungen, One-Click -Dimensionale Bilder. Integrieren Sie vollständig geplante Cross -System -Unterhaltungsplattformen, integrieren Sie synchrone Konten und Datenübertragung, um das Konzept der ununterbrochenen Unterhaltung jederzeit und überall zu erreichen. Zwischen quadratischen Zoll ist es einfach, die Unterhaltung ist praktisch und Reichtum ist zu Ihren Fingerspitzen.',
        downloadTip: 'Mobiltelefon Scanning QR -Code -Download',
        downloadH5: 'Direkter Zugriff ohne Herunterladen',
        aboutTitle:
          'Höflichkeit und Respekt, die Erfahrung ist außergewöhnlich',
        aboutP1:
          'Galaxy Entertainment Group („GEG“ oder die „Gruppe“) ist das weltweit führende Resort-, Hotel- und Gaming-Unternehmen, das an der Hong Kong Joint Exchange notiert ist und Aktien für den Hang Seng Index bildet.',
        aboutP2:
          'Als einer der drei Betreiber in Macau, die Glücksspielkonzessionsverträge gewonnen haben, ist GEG für die erfolgreiche Entwicklung neuer, auffälliger und preisgekrönter Projekte, Produkte und Dienstleistungen bekannt. Gepaart mit dem Servicekonzept „Seien Sie stolz auf die Welt und kümmern Sie sich um Asien“ ist die Leistung der Gruppe weiterhin stolz und führend auf dem Macao-Markt.',
        professional: 'Am professionellsten',
        professionalTips:
          'Die umfassendste Spieleplattform der Welt, ein professionelles Team begleitet Sie, zehntausende elektronische Spiele für Sie, Schach und Karten, Angeln und andere Unterhaltungsmöglichkeiten, damit Sie ein perfektes Spielerlebnis haben.',
        safety: 'Sicherste',
        safetyTips:
          'Dank der exklusiven Entwicklung, der 128-Bit-Verschlüsselungstechnologie und einem strengen Sicherheitsmanagementsystem sind die Kundengelder umfassend geschützt, sodass Sie Unterhaltung, Event-Wetten usw. sorgenfrei genießen können.',
        reliable: 'Zuverlässigste',
        reliableTips:
          'Die Plattform übernimmt das unabhängig entwickelte Finanzverarbeitungssystem mit der neuesten Technologie, das wirklich extrem schnelle Einzahlungen, Auszahlungen und Überweisungen ermöglicht. Die exklusive Netzwerkoptimierungstechnologie bietet Ihnen ein erstklassiges Spielerlebnis und maximiert die Netzwerklatenz.',
        convenient: 'Am bequemsten',
        convenientTips:
          'Als Marktführer mit hervorragender Technologie hat das Unternehmen eigenständig ein komplettes Set an Terminalanwendungen entwickelt, mit denen Sie native Web-, H5- und iOS- und Android-Apps genießen und jederzeit und überall unterhalten und wetten können',
        activities: 'Werbeaktion',
        vip: 'VIP überlegene Vorteile',
        appDownload: 'APP Herunterladen',
        exCenter: 'Exklusives Zentrum',
        newerHelp: 'Neue Hände helfen',
        service: 'Kundendienst',
        monitor: 'Regulierungsbehörde',
        aboutUs: 'Über Uns',
        onlineService: 'Online-Support',
        rewardFeedback: 'Belohntes Feedback',
        privacy: 'Datenschutzerklärung',
        aomen: 'MACAU -Regierung Genehmigung',
        feilvbin: 'Philippinische Regierung Genehmigung',
        jianpuzhai: 'Kambodschanische Regierung Genehmigung',
        gesida: 'Costa Ricaner Regierung autorisiert',
        latestGame: 'Letztes Spiel',
        latest: 'Auf dem Laufenden',
        elecGameTips:
          'Der Explosions -Score -Preis wird ausgegeben, sobald er berührt wird',
        allGame: 'Alle Spiele',
        hotGame: 'Spitzenspiele',
        collectGame: 'Sammlungsspiel',
        fishingDesc: 'Großer Fisch ist voller Bildschirme und wird explodieren',
        porkerDesc: '10.000 Menschen online heiße PK',
        sportsDesc: 'Top -Level -Events genießen Sie Leidenschaft',
        lotteryDesc: 'Es gibt alle beliebte Farbspezies',
        electricDesc: 'Vollständige Berichterstattung über Top -Events',
        realDesc: 'Sexy Händler Postkarten an Ort und Stelle',
        gamingTitle:
          'Massive beliebte Spiele, lassen Sie Sie unbegrenzt spielen',
        legend: 'League of Legends',
        kingHonor: 'König Ruhm',
        eatChicken: 'Jedi Überleben',
        stoneLegend: 'Hearthstone',
        starWar: 'Starcraft 2',
        watchPioneer: 'Overwatch',
        legendMatch: 'League of Legends S -Serie',
        dota2Match: 'DOTA2 Internationales Invitational -Turnier',
        csgoMatch: 'CS: Gehen Sie offizieller Partner',
        lotteryLhc: 'Sechs',
        lotteryCqssc: 'Chongqing',
        lotteryPk: 'PK Abholung',
        lotteryKlsf: 'Glücklich',
        lotterySyxw: '11 Wählen Sie 5',
        lotteryPls: 'Arrangieren 3',
        lotteryKs: 'Schnell 3',
        lotteryJssb: 'Jiangsu Sic Bo',
        lotteryFcsd: 'Fucai 3d',
        lotteryTitle:
          'Massive und beliebte Vermutung, dass Sie unendlich spielen',
        onshowing: 'Angezeigt werden',
        loadingUnit: 'Zahlung',
        loadingContent: 'Mitte',
        loadMore: 'Mehr laden'
      },
      hk: {
        receber_dz: '',
        convidar_dz: '',
        total_dz: '',
        distancia_dz: '',
        recebido_dz: '',
        montante_dz: '',
        hotTest_dz: '',
        play_dz: '',
        playTipTitle_dz: '',
        pplayTipContent_dz: ''
      },
      playStep: 'Schritt {n}',
      createAccount: 'Registriere ein Konto',
      topUpNow: 'Jetzt Einzahlen',
      topUpNowBtn: 'Jetzt einzahlen',
      withdrawNow: 'Jetzt zurückziehen',
      startPlay: 'Jetzt Spielen!',
      playNow: 'Geh jetzt spielen',
      mostPopular: 'Am beliebtesten',
      palyFishing:
        'Die weltweit führende Fischereiplattform, eine Vielzahl von Gameplay, tägliche Geschenke',
      palySlot:
        'Dieses Spiel kombiniert die Kraft zwischen Glück und Rotation und bringt den Spielern Spaß und Attraktivität',
      palyLive: 'Live-Game ist ein Ort für Glücksspiele und Gaming'
    },
    selfoperatedGames: {
      sports: {
        soccer: 'Fußball',
        basketball: 'Basketball',
        football: 'Fußball',
        iceHockey: 'Eishockey',
        tennis: 'Tennis',
        volleyball: 'Volleyball',
        billiards: 'Snooker',
        baseball: 'Baseball',
        badminton: 'Badminton',
        golf: 'Golf',
        motorsports: 'Rennauto',
        swimming: 'Schwimmen',
        politics: 'Politik',
        water: 'Wasser Polo',
        diving: 'Tauchen',
        boxing: 'Boxen',
        tableTennis: 'Tischtennis',
        handball: 'Handball',
        darts: 'Darts',
        rugby: 'Rugby',
        judo: 'Judo',
        ESports: 'eSport',
        beachVolleyball: 'Beach-Volleyball',
        finance: 'Finanzen',
        lotto: 'Lotto',
        unauthorized: 'Zugriff verweigert',
        streamingTemporarilyClosed: 'Video vorübergehend geschlossen',
        fetchStreamingFail: 'Versäumnis, Videos zu erhalten',
        systemIsUnderMaintenance: 'Systemwartung',
        stakeProblem:
          'Der Wettbetrag überschreitet den Maximum oder niedriger als der Mindestwert',
        max: 'Max',
        priceClosed: 'Vorübergehende Schließung',
        searchResult: 'Suchergebnisse',
        pointChanged: 'Der Ballkopf wurde aktualisiert',
        internalServerError: 'Nicht -erwartete Fehler im Server',
        invalidParameterInput:
          'Die Parametereingabe ist ungültig oder wird nicht unterstützt',
        transactionIdNotFound:
          'Die entsprechende Notiznummer kann nicht finden',
        cannotCashout: 'Diese Notiz kann nicht erfüllt werden',
        sellBackFail: 'Ende im Voraus fehlgeschlagen',
        eventClosedOrInvalidMarketID: 'Die Veranstaltung wurde geschlossen',
        parlaySameEvent: '',
        singleWalletFailed: '',
        parlayComboMaxPayoutOverLimit:
          'Diese String -Kombination erreicht die Obergrenze der Kompensation',
        parlayOddsLowerThanMinOdds:
          'Die Gewinnchancen sind geringer als die Mindestgrenze des Saitenpasses',
        overMaxPayoutPerEvent:
          'Das einzelne Rennen hat den maximalen Zahlungsbetrag überschritten',
        parlayNoComboAvailable:
          'Bitte reduzieren Sie die Anzahl der String -Überprüfungen in der maximalen Anzahl der Zeichenfolge',
        parlayMaxBetLessThanMinBet:
          'Der maximale Wettbetrag der Zeichenfolge ist geringer als der minimale Wettbetrag',
        eventClosed: 'Die Veranstaltung wurde geschlossen',
        underParlayCount: 'Unter der Mindestmenge',
        insufficientBalance: 'Mangelhaftes Gleichgewicht',
        oddsChanged: '',
        marketClosed: 'Handicap wurde geschlossen',
        overMaxBet:
          'Die Anzahl der Wetten in einem einzigen Ereignis übersteigt den Maximalwert',
        duplicatedBet: 'Wiederholen Sie die Wette',
        disabledParlayEvent: 'Der Wettbewerb ist vom Streben untersagt',
        disabledParlayByNum:
          'Die Mindestanzahl an Crosslinks wurde nicht erreicht und es können keine Wetten platziert werden.',
        loadMore: 'Klicken Sie hier, um mehr zu laden',
        noMore: 'Nicht mehr',
        handicap: 'Handicap',
        bigsmall: 'big and small',
        winlosee: 'wins  losses',
        winloseequal: 'wins draws losses',
        betting: 'Einsätze',
        betTime: 'Wettzeit',
        inputMoney: 'Bitte geben Sie den Schulleiter ein',
        allMoney: 'Alle salden',
        passLevel: 'Saite',
        canGet: 'Gewinnen',
        all: 'Alle',
        wgSports: 'WG Sports',
        rollingCount: 'Rollender Ball {count}',
        todayCount: 'Heute {count}',
        morningCount: 'Frühem Markt{count}',
        passLevelCount: 'Saite{count}',
        championCount: 'Champion{count}',
        focusOnCount: 'Konzentrieren Sie sich auf{count}',
        home: 'Gastgeber',
        away: 'Gast',
        more: 'Mehr',
        small: 'Klein',
        big: 'groß',
        homewin: 'Meister Sieg',
        awaywin: 'Sieger Sieg',
        win: 'gewinnen',
        foreven: 'Und',
        lose: 'verlieren',
        balance: 'Gleichgewicht',
        limitAmount: 'Bitte Einsatz eingeben (Limit {minBet}~{maxBet})',
        onlyInteger:
          'Der BET -Betrag kann nur auf eine Ganzzahl mit mehr als 0 wetten',
        betted: 'Wette',
        canGetMost: 'Maximal gewinnbar',
        cashout: 'Siedlung',
        cashouting: 'Siedlung im Voraus',
        cashoutTips:
          'Die Wette wird sofort beigelegt, und das Endergebnis im Zusammenhang mit dem Wettbewerb hat keinen Einfluss auf den auf Ihr Konto zurückgegebenen Betrag. Der Rückgabebetrag enthält den Auftraggeber',
        dealSellback: 'Rückkehrbehandlung',
        dealSellbackWaiting: 'Rückkehrbehandlung',
        dealSellbackAccept: 'Kehren Sie zurück, um zu akzeptieren',
        dealSellbackReject: 'Zurück zur Ablehnung',
        newOffer: 'Geben Sie neue Bargeldinformationen an',
        totalStake: 'Gesamtwette',
        sellBack: 'Zurückkehren',
        autoReceiveNewPirce: 'Akzeptieren Sie automatisch die neuesten Quoten',
        autoReceiveHighPirce: 'Akzeptieren automatisch die höchsten Chancen',
        notChangePirce: 'Akzeptieren Sie niemals Quotenänderungen',
        parlayBet: 'String -Wetten',
        league: 'Liga',
        time: 'Zeit',
        europe: 'European Handicap',
        hongkong: 'HongKong Handicap',
        noEventsYet: 'Kein Event',
        routerBack: 'Zurück',
        clearAll: 'Alles leer',
        filterLeague: 'Bildschirm',
        searchEvent: 'Suchen',
        hotSearch: 'beliebte Suchanfragen',
        noLeague: 'Entschuldigung, es gibt keine verwandten Ereignisse',
        showMoreBet: 'Erweitern Sie mehr Stringmethoden',
        showLessBet: 'Weitere Möglichkeiten zum Überprüfen schließen',
        totalBet: 'Gemeinsame Wetten',
        cancle: 'Abbrechen',
        selectAll: 'Alle',
        cancleAll: 'Die vollständige Auswahl abbrechen',
        confirm: 'Bestätigen',
        checkLeague: 'Bitte wählen Sie die Veranstaltung',
        betSuccess: 'Wetten Sie erfolgreich',
        betFalid: 'Die Wette ist fehlgeschlagen',
        parlayTip: 'Sie können die Nummer schließen',
        parlayTip2:
          'Dieselbe Veranstaltung gefunden, durch einen neuen Markt für Sie ersetzt',
        disableParlay: 'Der aktuelle Markt kann nicht geschlossen werden',
        addParlaySuccess: 'Fügen Sie den String -Erfolg hinzu!',
        clearBetType: 'Löschen Sie den String -Erfolg!',
        marketParlayError:
          'Das Zifferblatt ist abnormal. Bitte wählen Sie den Handle erneut aus',
        seeBetRecord: 'Datensätze anzeigen',
        stakeRecord: 'Wetteinsätze\nEinträge',
        continueBetting: 'Wetten Sie weiter',
        betRecord: 'Notizlistendatensatz',
        backToHome: 'Zur Startseite zurückkehren',
        sports: 'Sport',
        settled: 'Erledigt',
        unSettled: 'Unerledigt',
        settledAndNot: 'Alle Aufzeichnungen',
        betAmount: 'Wette',
        transId: 'Wette Nummer',
        betContent: 'Wette',
        markets: 'Handhaben',
        bettingStatus: 'Status',
        winOrLose: 'Verlust/Gewinn (ohne Schulleiter)',
        tranId: 'Einzelne Nummer',
        copy: 'Kopieren',
        screenShot: 'Bildschirmfoto',
        share: 'Aktie',
        screenShotFalid:
          'Der Screenshot ist fehlgeschlagen, bitte versuchen Sie es erneut',
        acceptTikets: 'Erfolgreiche Ordnung',
        betConfirming: 'Hinweis Filterbestätigung',
        void: 'Abscheu',
        refund: 'Erstattung',
        reject: 'Abgesagt',
        draw: 'Binden',
        halfWon: 'Semi -Win',
        halfLose: 'Semi -Lost',
        noData: 'Keine Screenshot -Daten',
        PointDisappear: 'Kugelkopf existiert nicht mehr',
        OddsChanged: 'Die Chancen wurden aktualisiert',
        OddsAdjust: 'Die Quoten werden angepasst',
        OddsError: 'Quotenfehler',
        GameStatusChanged: 'Änderung des Rennstatus',
        GameScoreChanged: 'Änderung der Rennpunktzahl',
        GamePointChanged: 'Austausch des Race-Kugelkopfes',
        sortPlaceholder: 'Sortieren',
        oddPlaceholder: 'Ungerade',
        processing: '',
        accessTitle: 'Eingeschränkter Zugang',
        accessContent:
          'Die Region, in der sich Ihre IP befindet, liegt nicht in unserem Servicebereich. Bitte ändern Sie Ihre IP-Adresse in ein anderes Land. Wir entschuldigen uns für etwaige Unannehmlichkeiten.',
        liveStreaming: 'Live-Video',
        viewData: 'Daten anzeigen',
        yellowCard: 'Gelbe Karte',
        redCard: 'Rote Karte'
      },
      country: {
        China: 'China',
        Russia: 'Russia',
        Argentina: 'Argentina',
        Ukraine: 'Ukraine',
        Mexico: 'Mexico'
      },
      markets: {
        special: 'Spezielle Wetten',
        handicap: 'Handicap',
        handicapUp: 'Der erste halbe-den kugel',
        handicapDown: 'Holen Sie sich den Ball in der zweiten Hälfte',
        bigsmall: 'Scheibe',
        bigsmallUp: 'Erste Hälfte – Über/Unter',
        bigsmallDown: 'Die zweite Hälfte',
        winDrawLose: 'Sieg',
        winDrawLoseUp: 'Shengping Langle-die erste Hälfte',
        winDrawLoseDown: 'Shengping Langle-die zweite Hälfte',
        score: 'Punktzahl',
        scoreUp: 'Punktzahl in der ersten Hälfte',
        scoreDown: 'Punktzahl in der zweiten Hälfte',
        singleDouble: 'Einzel Doppel',
        singleDoubleUp: 'Erste Halbzeit – Ungerade/Gerade',
        singleDoubleDown: 'Zweite Hälfte – Ungerade/Gerade',
        doubleChance: 'Doppelte Chance',
        doubleChanceUp: 'Doppelte Chance in der ersten Hälfte',
        doubleChanceDown: 'Doppelte Möglichkeiten in der zweiten Hälfte',
        totalGoal: 'Punktzahl',
        totalGoalUp: 'Die erste Hälfte erzielte den Ball in der ersten Hälfte',
        rightTotalGoal: 'Genaues Gesamtziel',
        rightHomeTotalGoal: 'Gesamtpunktzahl des genauen Heimteams',
        rightAwayTotalGoal: 'Genauige Gäste -Team -Punktzahl',
        rightTotalGoalUp:
          'Holen Sie sich den Gesamtball in der ersten Hälfte genau',
        rightTotalGoalDown: 'Beachten Sie den Ball in der zweiten Hälfte genau',
        zeroLose: 'Null Ziel',
        zeroLoseWinner: 'Der Sieg eines Null -Ball -Verlustes',
        halfAll: 'Halbspiel/ganzes Feld',
        winLose: 'Sieg'
      },
      live: {
        notSupportFull:
          'Der Browser unterstützt keine vollständige Bildschirmefunktion',
        notSupportInPicture:
          'Der Browser unterstützt die Funktion des Malmalerei nicht',
        pleasePlayFirst: 'Bitte klicken Sie zuerst'
      },
      eventStatus: {
        prepare: 'Nicht anfangen',
        running: 'Im Spiel',
        close: 'Aus',
        postponed: 'aufschieben',
        deleted: 'Abgesagt'
      }
    },
    notice: {
      announcement: 'Nachrichten',
      notice: 'Mitteilung',
      marquee: 'Marquee',
      readed: 'Gelesen',
      unread: 'Ungelesen',
      empty: 'Derzeit keine Meldungen',
      winPrize: 'Bonus',
      receivedSuccess: 'Erfolgreich erhalten!',
      receive: 'Sammeln',
      received: 'GESAMMELT',
      receviePrize: 'Adoptions-Bonus',
      all: 'Alle',
      edit: 'Bearbeiten',
      allRead: 'Alle Lesen',
      delete: 'Löschen',
      cancle: 'Absagen',
      complete: 'Beendet',
      importantNotice: 'Wichtige Erinnerung',
      deleteTip:
        'Sind Sie sicher, dass Sie alle Benachrichtigungen löschen möchten?',
      readTip: 'Alle Markierungen wurden erfolgreich gelesen'
    },
    center: {
      components: {
        categorySelect: {
          allCategory: 'Alle Typen',
          allPlatformCategory: 'Alle Plattformen',
          alGameCategory: 'Alle Spiele',
          allDealCategory: 'Details zur Unterkategorie'
        },
        dateRadio: {
          today: 'Heute',
          yesterday: 'Gestern',
          lastTowDay: 'Fast 2 Tage',
          lastSevenDay: 'Letzten 7 Tage',
          lastFifteenDay: 'Letzten 15 Tage',
          lastThirtyDay: 'Letzten 30 Tage',
          lastSixtyDay: 'Nahe 60 Tage',
          thisWeek: 'Diese Woche',
          lastWeek: 'Letzte Woche',
          thisMonth: 'Dieser Monat',
          lastMonth: 'Im vergangenen Monat',
          lastTwoMonth: 'Letzte 2 Monate',
          lastThreeMonth: 'Letzte 3 Monate',
          all: 'Alle',
          undo: 'Warten auf Wetten',
          pending: 'In Bearbeitung',
          done: 'Erledigt',
          custom: '',
          customize: 'Anpassen'
        }
      },
      report: {
        title: 'Bericht',
        tabs: {
          personalStatement: 'Persönlicher Bericht',
          bettingRecord: 'Wetteinsätze Einträge',
          accountDetails: 'Kontoauszug'
        },
        table: {
          time: 'Zeit',
          type: 'Arten',
          platform: 'Plattform',
          game: 'Spiele',
          betting: 'Gültige Einsätze',
          betSlip: 'Anmerkungen',
          win: 'Gewinn/Verluste',
          no: 'Ausgabenummer',
          accountChangeType: 'Transaktionsart',
          typeDetails: 'Typ-Details',
          amount: 'Betrag'
        },
        statistics: {
          validBetTotal: 'Kumulierte Gültige Einsätze',
          betSlip: 'Kumuliertes Wettvolumen',
          profitTotal: 'Gesamt W/L',
          rechargeTotal: 'Totale Borg',
          reflectTotal: 'Kumulierte Abhebung',
          discount: 'Gesamte Einlösung'
        },
        bettingRecord: {
          canneled: 'Wurden zurückgezogen',
          unsettled: 'Unerledigt',
          settled: 'Erledigt',
          all: 'Jeder Status'
        },
        personalStatement: {
          winOrLose:
            'Anzahl der platzierten Wetten/<br />Wettbetrag/<br />Gesamtgewinn'
        }
      },
      security: {
        title: 'Sicherheits-Center',
        notBind: 'Entbinden',
        none: 'Aufheben',
        done: 'Wurde Festgelegt',
        status: 'Aktuellen Zustand',
        close: 'Aus',
        isClosed: 'Nach Abschluss der\nÜberprüfung öffnen',
        open: 'An',
        isOpened: 'Nach Bestätigung schließen',
        loginLable: 'Anmeldungspasswort',
        valid: 'Passwort Uberprüfen',
        validOldPwd: 'Überprüfen Sie das alte Login-Passwort',
        verifyCode: 'Bitte gib den Bestätigungscode ein',
        passwordvalidation: 'Passwortüberprüfung',
        twoStepVerification: 'Zwei-Schritte-Bestätigung',
        forceBindAnd: 'und',
        forceBindTitle: 'Du musst für deine Kontosicherheit {bindItem} binden',
        forceBindWidthdrawPass:
          'Sie müssen das Abhebungskennwort festlegen, um die Auszahlung zu beantragen',
        forceBindItemTitle:
          'Für deine Kontosicherheit musst du mindestens {length} von {bindItem} Bindungen vornehmen',
        bindOtherPrompt:
          'Bitte binde erst die anderen Sicherheits-Items für deine Kontosicherheit',
        noModificationPhone:
          'Die Mobiltelefonnummer kann derzeit nicht geändert werden',
        bindOther: 'Binden Sie andere Sicherheitsgegenstände ein',
        LargeBalancesBindTitle:
          'Da Ihre Kontovermögenswerte mehr Vermögenswerte sind, müssen Sie zwei Schritte binden, um die Sicherheit von Schutzfonds zu überprüfen! Klicken Sie auf OK, um für den obligatorischen Bindungsprozess zu springen',
        phone: {
          tab: 'Handy',
          forceBind: 'Mobiltelefon binden um Spiele zu genießen',
          phonePlaceholder: 'Bitte Handynummer eingeben',
          smsPlaceholder: 'Bitte gib den Bestätigungscode ein',
          update: {
            title: 'Handy ändern',
            tips: 'Das Handy kann nach Bestätigung des Login-Passworts geändert werden',
            success: 'Handy wurde erfolgreich geändert'
          },
          bind: {
            title: 'Handynummer Verbinden',
            tips: 'Das Handy kann nach Bestätigung des Login-Passworts verbunden werden',
            success: 'Handy wurde erfolgreich verbunden'
          }
        },
        cpf: {
          tab: 'CPF',
          label: 'CPF',
          placeholder:
            'Es kann nach der Einstellung nicht geändert werden, bitte überprüfen Sie CPF sorgfältig',
          tips: 'Bitte geben Sie bis zu 11 Ziffern ein',
          bind: {
            title: 'CPF festsetzen',
            tips: 'CPF kann nach Bestätigung des Login-Passworts festgesetzt werden',
            success: 'CPF erfolgreich festgesetzt'
          }
        },
        email: {
          tab: 'Post',
          forceBind: 'Email binden um Spiele zu genießen',
          auth: {
            placeholder: 'Bitte E-Mail binden',
            codePlaceholder: 'Bitte gib den Bestätigungscode ein'
          },
          update: {
            title: 'E-Mail Ändern',
            tips: 'Email kann nach Bestätigung des Login-Passworts geändert werden',
            success: 'E-Mail erfolgreich geändert'
          },
          bind: {
            title: 'E-Mail binden',
            tips: 'Email kann nach Bestätigung des Login-Passworts verbunden werden',
            success: 'E-Mail-Bindung erfolgreich'
          }
        },
        ga: {
          tab: 'Google-Authentifizierung',
          open: 'Schalte die Google-Authentifizierung ein',
          close: 'Schalte die Google-Authentifizierung aus',
          forceBind: 'Google-Authentifizierung binden um Spiele zu genießen',
          update: {
            title: 'Google-Authentifizierung ändern',
            openTips:
              'Google-Authentifizierung kann nach Bestätigung des Login-Passworts aktiviert werden',
            closeTips:
              'Google-Authentifizierung kann nach Bestätigung des Login-Passworts deaktiviert werden',
            openSuccess: 'Aktivierung der Google-Authentifizierung erfolgreich',
            closeSuccess:
              'Deaktivierung der Google-Authentifizierung erfolgreich'
          },
          bind: {
            title: 'Google-Authentifizierung verbinden',
            tips: 'Google-Authentifizierung kann nach Bestätigung des Login-Passworts verbunden werden',
            success: 'Einstellung der Google-Authentifizierung erfolgreich'
          },
          steps: {
            '1': {
              title: 'Schritt 1: Lade die Google-Authentifizierung herunter',
              content:
                'Suchen Sie in jedem App Store nach „Google Authenticator“ oder „Google Authenticator“, um die App herunterzuladen'
            },
            '2': {
              title:
                'Schritt 2: Öffne die Authentifizierungs-App und füge einen QR-Code hinzu',
              content: 'Kann nicht scannen, bitte gebe den Schlüssel ein'
            },
            '3': {
              title:
                'Schritt 3: Gebe die sechsstellige Nummer zur Bestätigung in die Authentifizierungs-App ein'
            }
          }
        },
        loginPwd: {
          tab: 'Anmeldungspasswort',
          title: 'Passwort Ändern',
          placeholder: 'Bitte Passwort eingeben',
          newPwd: {
            label: 'Neues Passwort',
            placeholder:
              '6–16 Bytes, einschließlich mindestens zwei englischen Buchstaben/Zahlen/Symbolen',
            placeholder2: 'Bitte geben Sie ein neues Passwort ein'
          },
          confirmNewPwd: {
            label: 'Passwort Bestätigen',
            placeholder: 'Bitte bestätigen Sie das neue Passwort'
          },
          update: {
            tips: 'Ändere das Login-Passworts nach der Bestätigung',
            success: 'Kennwortänderung erfolgreich anmelden'
          }
        },
        withdrawalPwd: {
          tab: 'PIN zurückziehen',
          label: 'PIN zurückziehen',
          confirmPwd: 'Bestätigen Sie die neue Abhebungs-PIN',
          oldWithdrawalPwd: 'Originalkennwort',
          newWithdrawalPwd: 'Neues Abhebungskennwort',
          withdrawalPwdNonEmpty: 'Das Abhebungskennwort kann nicht leer sein',
          confirmNewPwd: 'Bestätigen Sie die neue Abhebungs-PIN',
          update: {
            title: 'Abhebungs-PIN Zurücksetzen',
            tips: 'Das Auszahlungspasswort kann nach Bestätigung des Login-Passworts geändert werden',
            success: 'Auszahlungspasswort wurde erfolgreich geändert'
          },
          bind: {
            topTips:
              'Sie sind die erste Auszahlung, Sie müssen das Abhebungskennwort zuerst festlegen',
            title: 'Abhebungs-PIN Einrichten',
            tips: 'Nachdem Sie das Anmeldepasswort überprüft haben, können Sie das Auszahlungspasswort festlegen',
            success: 'Gestenpasswort wurde erfolgreich festgelegt',
            topRemark: 'Bitte lege erst das Abhebungspasswort fest',
            remark:
              'Beachten Sie, dass das Abhebungskennwort Ihre Mittel schützt. Es ist sehr wichtig, Sie können sich nur selbst kennen, was Kapitalverlust verursacht '
          },
          sameOrContinuousTip:
            'Kann nicht 6 gleiche oder kontinuierliche Zahlen sein'
        },
        question: {
          tab: 'Frage',
          label: 'Frage',
          update: {
            title: 'Passwort Ändern',
            tips: 'Sicherheitsfrage kann nach Bestätigung des Login-Passworts geändert werden',
            success: 'Änderung der Sicherheitsfrage erfolgreich'
          },
          bind: {
            title: 'Sicherheitsfrage einrichten',
            tips: 'Sicherheitsfrage kann nach Bestätigung des Login-Passworts festgelegt werden',
            success: 'Festlegen der Sicherheitsfrage erfolgreich',
            topRemark: 'Bitte lege erst eine Sicherheitsfrage fest'
          },
          answerConfirm: 'Antwort Bestätigen',
          answerConfirmPlaceholder:
            'Bitte gebe die Antwort auf die Sicherheitsfrage erneut ein',
          notMatch: 'Die Antworten sind ungültig, bitte erneut eingeben!'
        },
        thirdWay: {
          tab: 'Bindung von Drittanbietern',
          tips: 'Dritte Partei kann nach Bestätigung des Login-Passworts verbunden werden',
          success: 'Dritte Partei wurde erfolgreich verbunden',
          login: 'Bindungsanmeldung dritter -Party'
        },
        securityConfigExpired:
          'Die Sicherheitskonfiguration wurde aktualisiert und die Seite wird auf der Seite aktualisiert',
        WithdrawAccount: { title: 'Auszahlungskonto' }
      },
      setting: {
        avatar: 'Profilbild',
        setting: 'Konfiguration',
        account: 'Mitgliedskonto',
        nick: 'Spitzname',
        wechat: 'WeChat',
        whatsapp: 'WhatsApp',
        facebook: 'Facebook',
        telegram: 'Telegram',
        zalo: 'Zalo',
        line: 'LINE\n',
        twitter: 'Twitter',
        name: 'Name',
        enterbirthday:
          'Bitte Geburtstag auswählen (kann nicht mehr geändert werden)',
        registerDate: 'Registrieren',
        nickPlaceholder: 'Bitte gebe einen Spitznamen ein.',
        wechatPlaceholder: 'Bitte gebe die WeChat-ID ein',
        whatsAppPlaceholder: 'Bitte gebe die Whatsapp-ID ein',
        facebookPlaceholder: 'Bitte gebe die Facebook-ID ein',
        telegramPlaceholder: 'Bitte die Telegram-ID ein',
        zaloPlaceholder: 'Bitte geben Sie Ihre Zalo-Nummer ein',
        linePlaceholder: 'Bitte gebe die Line ID ein',
        twitterPlaceholder: 'Bitte gib das Twitterkonto an',
        realNamePlaceholder: 'Bitte binde erst das Auszahlungskonto',
        phonePlaceholder: 'Bitte binden Sie Ihr Telefon',
        ok: 'Bestätigen',
        birthdayPlaceholder:
          'Bitte Geburtstag auswählen (kann nicht mehr geändert werden)',
        goBackConfirm: 'Bestätigen oder zurückkehren?',
        remark:
          'Gegenwärtige Änderungen wurden noch nicht gespeichert. Die Änderungen werden beim Zurückkehren nicht in Kraft treten',
        cancel: 'Abbrechen',
        man: 'Männlich',
        woman: 'Weiblich',
        updateAvatar: 'Profilbild Ändern',
        error1: 'Zeichenlimit überschritten. Bitte erneut eingeben',
        error2:
          'Das WeChat-Konto muss mit einem Buchstaben oder Unterstrich beginnen und darf aus 6-20 Zahlen, Unterstrichen, Minus oder Kombinationen dieser Zeichen bestehen',
        error3: 'Bitte gebe 6-40 Zahlen ein',
        error4: 'Höchstens 40 Zeichen erlaubt. Bitte erneut eingeben',
        error5: 'Bis zu 40 Zeichen, bitte erneut eingeben',
        error6: 'Bitte gebe 5-40 Buchstaben/Nummern/Unterstriche ein.',
        error7: 'Bitte gebe 4-40 Buchstaben/Nummern ein.',
        error8: 'Bitte gebe 4-40 Buchstaben/Nummern/Symbole ein.',
        error9:
          'Unterstützen Sie nur Eingangsbuchstaben, Zahlen und Sonderzeichen@._- \\\\',
        error10: 'Unterstützen Sie bis zu 60 Englisch/Zahlen/Zeichen',
        error11: 'Bitte geben Sie 3-50 Teile Englisch/Zahlen/Zeichen ein',
        success: 'Persönliche Informationen erfolgreich bearbeitet',
        save: 'Speichern',
        noChangeToast: 'Du hast keine Änderungen vorgenommen',
        goBind: 'Verbinden',
        goRecharge: 'Einzahlen',
        selectDate: 'Datum auswählen'
      }
    },
    footer: {
      quickJump: {
        recreationCity: 'Kasino',
        active: 'Event',
        task: 'Mission',
        backwater: 'Rückgabe',
        award: 'Gewinn',
        vip: 'VIP',
        paidToPromote: 'Promotion',
        game: 'Spiele',
        chessAndCards: 'Karten',
        fishing: 'Angeln',
        electronic: 'Arkade',
        Cockfight: 'Hahnenkampf',
        person: 'Live',
        sports: 'Sport',
        lottery: 'Lotterie',
        support: 'Support',
        onlineSupport: 'Online-Support',
        helpCenter: 'Hilfecenter',
        prizeFeedback: 'Belohntes Feedback',
        quickLogin: 'Quick-Login',
        bindFacebook: 'Facebook Binden',
        bindGoogle: 'Google Verbinden',
        bindLine: 'Binden Line',
        boundFacebook: 'Facebook gebunden',
        boundGoogle: 'Google gebunden',
        boundLine: 'Linie Line',
        aboutUs: 'Invoering',
        aboutUsSub: 'Über Uns',
        privacyPolicy: 'Datenschutzerklärung',
        other: 'Andere',
        withdraw: 'Fragen zur Auszahlung',
        recharge: 'Fragen zum Nachladen',
        language: 'Sprache',
        eSports: 'E-Sports',
        BlockchainGames: 'Blockchain',
        providentFund: 'Provident Fund'
      },
      cyanBlue: {
        daily: 'Vertreter',
        dailyContent:
          'Doe mee met het programma voor gratis bijdragers en leg vast om commissies te verdienen',
        introduceFriends: 'Vrienden voorstellen',
        introduceFriendsContent:
          'Verwijs een vriend door en word vaak direct lid',
        vip: 'VIP',
        vipContent:
          'Upgrade VIP om te genieten van voordelen en vaak exclusief',
        support: 'Support',
        supportContent:
          'De klantenservice staat altijd klaar om u van dienst te zijn',
        moreInformation: 'Meer informatie',
        followUs: 'Volg ons',
        licensor: 'Licentiegever',
        supplier: 'Leverancier',
        gameLicecense: 'Spielerlaubnis',
        certificate: 'Zertifikat',
        paymentMethod: 'Bezahlverfahren'
      },
      footerContactUs: 'Kontaktieren Sie uns',
      copyright: '@Copyright 2002-2022',
      companyInfo:
        '**** Group ist das bekannteste Online-Casino-Unternehmen der Welt. Es bietet aufregende und lustige Live-Dealer-Unterhaltung, Schach, Elektronik, Angeln, Lotterie, Sport usw. Die Gruppe ist von der Regierung von Curaçao autorisiert und reguliert. Sie wird gemäß der Lizenz (Nr. ****) betrieben, die **** erteilt wurde. Die Gruppe hat alle konformen Prüfungen bestanden und ist gesetzlich autorisiert, alle Arten Gelegenheits- und Wettspiele zu betreiben.'
    },
    cashback: {
      title: 'Live-Rabatt',
      successTips:
        'Erfolgreich erhalten. Spiele weiter um mehr Boni zu erhalten~',
      rewardSource: '',
      subInfo: {
        validBets: 'Gültige Einsätze',
        amount: 'Rabattierbar',
        canReceive: 'Sammelbar',
        collectAll: 'Alles Einsammeln',
        allValidBets: 'Kumulierte Gültige Einsätze',
        allAmounts: 'Kumulierter Rabatt',
        washCodeAll: 'Ein Klickcode',
        washableCodesToday: 'Waschen Sie den Code noch heute',
        washableCodesTomorrow: 'Morgen kann gewaschen werden',
        accumulated: 'Akkumuliert',
        totalCodesWash: 'Kumulierter Rabatt',
        todayCollection: 'Kann heute gesammelt werden:',
        tomorrowCollection: 'Sie können es morgen bekommen:',
        washableCode: 'Kann <span>{x}<span> empfangen',
        settingDay: 'Tägliche <span>{x}</span> kommen automatisch an',
        settingWeek: '<span>{x}</span> kommen automatisch an',
        settingMonth: 'Jeden Monat kommen {d} <span>{x}</span> automatisch an'
      },
      popup: {
        dayRebate: 'Täglicher Rabatt',
        weekRebate: 'Wöchentlicher Rabatt',
        moonRebate: 'Monatlicher Rabatt',
        pickUpManually: 'Manuell beanspruchen',
        systemDispatch: 'Systemverteilung',
        upToTip1:
          'Bis {x} werden nicht beanspruchte Prämien automatisch eingezahlt',
        upToTip2: 'Bis {x} verfallen nicht beanspruchte Prämien',
        upToTip3: 'Bis {x} werden die Prämien automatisch eingezahlt'
      },
      tab: { cashback: '{name}' },
      pageTitle: {
        cards: 'Karten',
        fishHunt: 'Fischen',
        electronic: 'Slot',
        sports: 'Sport',
        lottery: 'Lotterie',
        rates: 'Rabattquote',
        records: 'Rabatt-Einträge',
        vipLevel: 'VIP-Level',
        pickUpRecord: 'Sammelverlauf'
      },
      table: {
        platform: 'Plattform',
        downRates: 'Nächster Anteil',
        canReceiveAmount: 'Betrag erhalten',
        upgradeVip: 'Upgrade auf VIP {v} Can {r}%',
        betAgain: 'Wetten erneut{0}kann{r}%',
        amount: 'Rabattbetrag',
        selectCategory: 'Typ',
        selectPlatform: 'Plattform',
        category: 'Arten',
        time: 'Zeit',
        operator: 'Aktion',
        detail: 'Details',
        current: 'Aktuell'
      },
      detail: 'Rabatt Details'
    },
    event: {
      title: 'Event',
      titleGalaxyGold: 'Werbeaktionen',
      galaxyGoldPropaganda1:
        'Genießen Sie die wundervolle Punktzahl des Lebens',
      galaxyGoldPropaganda2: '',
      allActivities: 'Alle Events',
      tabLabel: '{x}',
      rules: 'Beschreibung der Regel',
      content: 'Inhalte der Aktivität',
      rulesDes:
        'Du kannst den Aktivitätsbonus erst abheben, wenn {times} der Bedingungen erfüllt wurden.',
      condition: 'Event-Anforderung',
      conditionDeposit: 'Gewählte Aufladung',
      conditionPlatform: 'Gewählte Plattform',
      time: 'Event-Zeit',
      reset: 'Täglich um 00:00 Uhr zurücksetzen',
      resetWeek: 'Täglich um 00:00 Uhr zurücksetzen',
      resetMonth: 'Wird am ersten Tag jedes Monats um 00:00 Uhr zurückgesetzt',
      rulesOnlyDes:
        'Du kannst den Aktivitätsbonus auf {device} erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
      rulesOnlyDesNoTimes:
        'Diese Aktivitätsbelohnung muss auf {device} erhalten werden.',
      onlyAndroid: 'Android-App',
      onlyIos: 'iOS-App',
      onlyApp: 'App',
      onlyH5: 'Mobile Webseite',
      onlyWeb: 'PC-Webseite',
      receiveTimes: 'Anzahl der verbleibenden Applikationen',
      receiveBtn: 'Sofort Beantragen',
      questionPlaceholder: 'Bitte gib die Antwort auf die Frage ein',
      unconditional: 'Keine Bedingungen',
      cumulativereCharge: 'Totale Borg',
      cumulativeCoding: 'Gesamt-Wetten',
      firstIndex: 'I.',
      secondIndex: 'II.',
      thirdIndex: 'III.',
      fourIndex: 'IV.',
      participate: 'Beitreten',
      verifyTips: 'Die Belohnung muss nach der Überprüfung überprüft werden',
      pendingApply: 'Angewendet werden',
      tipsText1: 'Zurück zum Wasser wurde es noch nicht geöffnet',
      tipsText2: 'VIP wurde noch nicht geöffnet',
      tipsText3: 'Zinsschatz wurde noch nicht eröffnet',
      expiredTip: 'Abgelaufen am {0}',
      valid: {
        hasH5: 'Anmeldung',
        hasApp: 'Herunterladen und einloggen',
        h5: 'Mobile Webseite',
        reward: 'Bitte in {reward} erhalten'
      },
      validRule: {
        limit_1:
          'Du kannst den Aktivitätsbonus in der iOS-App erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_2:
          'Du kannst den Aktivitätsbonus in der Android-App erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_3:
          'Du kannst den Aktivitätsbonus auf der mobilen Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_4:
          'Du kannst den Aktivitätsbonus auf der PC-Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_1_2:
          'Du kannst den Aktivitätsbonus in der App erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_1_3:
          'Du kannst den Aktivitätsbonus in der iOS-App und auf der mobilen Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_1_4:
          'Du kannst den Aktivitätsbonus in der iOS-App und auf der PC-Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_2_3:
          'Du kannst den Aktivitätsbonus in der Android-App und auf der mobilen Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_2_4:
          'Du kannst den Aktivitätsbonus in der Android-App und auf der PC-Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_3_4:
          'Du kannst den Aktivitätsbonus auf der mobilen und PC-Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_1_2_3:
          'Du kannst den Aktivitätsbonus in der App und auf der mobilen Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_1_2_4:
          'Du kannst den Aktivitätsbonus in der App und auf der PC-Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_1_3_4:
          'Du kannst den Aktivitätsbonus in der iOS-App und auf der mobilen sowie PC-Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_2_3_4:
          'Du kannst den Aktivitätsbonus in der Android-App und auf der mobilen sowie PC-Webseite erhalten und abheben, aber erst, wenn {times} der Bedingungen erfüllt wurden.',
        limit_1_2_3_4:
          'Du kannst den Aktivitätsbonus erst abheben, wenn {times} der Bedingungen erfüllt wurden.',
        limitNoTimes_1:
          'Die Belohnungen für diese Aktivität müssen auf der iOS App empfangen werden.',
        limitNoTimes_2:
          'Die Belohnungen für diese Aktivität müssen auf der Android App empfangen werden.',
        limitNoTimes_3:
          'Die Belohnungen für diese Aktivität müssen auf der Handywebsite empfangen werden.',
        limitNoTimes_4:
          'Die Belohnungen für diese Aktivität müssen auf der Computerwebsite empfangen werden.',
        limitNoTimes_1_2:
          'Die Belohnungen für diese Aktivität müssen auf der App empfangen werden.',
        limitNoTimes_1_3:
          'Die Belohnungen für diese Aktivität müssen auf der iOS App und Handywebsite empfangen werden.',
        limitNoTimes_1_4:
          'Die Belohnungen für diese Aktivität müssen auf der iOS App und Computerwebsite empfangen werden.',
        limitNoTimes_2_3:
          'Die Belohnungen für diese Aktivität müssen auf der Android App und Handywebsite empfangen werden.',
        limitNoTimes_2_4:
          'Die Belohnungen für diese Aktivität müssen auf der Android App und Computerwebsite empfangen werden.',
        limitNoTimes_3_4:
          'Die Belohnungen für diese Aktivität müssen auf der Handy- und Computerwebsite empfangen werden.',
        limitNoTimes_1_2_3:
          'Die Belohnungen für diese Aktivität müssen auf der App und Handywebsite empfangen werden.',
        limitNoTimes_1_2_4:
          'Die Belohnungen für diese Aktivität müssen auf der App und Computerwebsite empfangen werden.',
        limitNoTimes_1_3_4:
          'Die Belohnungen für diese Aktivität müssen auf der iOS App, Handywebsite und Computerwebsite empfangen werden.',
        limitNoTimes_2_3_4:
          'Die Belohnungen für diese Aktivität müssen auf der Android App, Handywebsite und Computerwebsite empfangen werden.'
      },
      validTips: {
        limit_1: 'Zum Erhalt die iOS-App herunterladen und einloggen.',
        limit_2: 'Zum Erhalt die Android-App herunterladen und einloggen.',
        limit_3: 'Zum Erhalt auf der mobilen Webseite einloggen.',
        limit_4: 'Zum Erhalt auf der PC-Webseite einloggen.',
        limit_1_2: 'Zum Erhalt die App herunterladen und einloggen.',
        limit_1_3:
          'Zum Erhalt die iOS-App herunterladen und dort und auf der mobilen Webseite einloggen.',
        limit_1_4:
          'Zum Erhalt die iOS-App herunterladen und dort und auf der PC-Webseite einloggen.',
        limit_2_3:
          'Zum Erhalt die Android-App herunterladen und dort und auf der mobilen Webseite einloggen.',
        limit_2_4:
          'Zum Erhalt die Android-App herunterladen und dort und auf der PC-Webseite einloggen.',
        limit_3_4: 'Zum Erhalt auf der mobilen und PC-Webseite einloggen.',
        limit_1_2_3:
          'Zum Erhalt die App herunterladen und dort und auf der mobilen Webseite einloggen.',
        limit_1_2_4:
          'Zum Erhalt die App herunterladen und dort und auf der PC-Webseite einloggen.',
        limit_1_3_4:
          'Zum Erhalt die iOS-App herunterladen und dort und auf der mobilen sowie PC-Webseite einloggen.',
        limit_2_3_4:
          'Zum Erhalt die Android-App herunterladen und dort und auf der mobilen sowie PC-Webseite einloggen.'
      },
      validDay: {
        monday: 'Jeden Montag',
        tuesday: 'Jeden Dienstag',
        wednesday: 'Jeden Mittwoch',
        thursday: 'Jeden Donnerstag',
        friday: 'Jeden Freitag',
        saturday: 'Jeden Samstag',
        sunday: 'Jeden Sonntag',
        daily: 'Täglich begrenzte Zeit',
        day: 'Täglich',
        renPocketTime: 'Verteilungszeit',
        reset: 'Zurücksetzen',
        template: '{day} {startTime} - {endTime}'
      },
      eventTypes: {
        deposit: 'Einzahlungs-Bonus Event',
        chips: 'Wett-Event',
        characters: 'Wortsammlungsaktivität',
        sign: 'Anmelde-Event',
        redPocket: 'Roter Umschlag Event',
        rescue: 'Unterstützungs-Bonus Event',
        invest: 'Investition Event',
        luckyWheel: 'Glücksrad Event',
        customize: 'Individuelles Event',
        proxy: 'Agent-Aktivität',
        promote: 'Promotion-Event'
      },
      listedRewards: {
        perTime: 'Jeden',
        perMonth: 'Pro Monat',
        perDay: 'Täglich',
        perWeek: 'Wöchentlich',
        upperLimit: '(Die Obergrenze {x})',
        noRewards: 'Keine Belohnung für den Strom',
        firstRecharge: 'Zuerst aufladen',
        weeklyPay: 'Single laden jede Woche auf',
        weeklyTotalPay: 'Kumulative Aufladung jede Woche',
        perMonthPay: 'Monatliches Aufladen monatlich',
        perMonthTotalPay: 'Kumulatives Aufladen monatlich',
        perMonthReceive: 'Monat {time} Nein.',
        weeklyReceive: '{time} Empfangen',
        receiveTimeDay: 'Täglich {startTime}-{endTime} Empfangen',
        canReceiveTip:
          'Diese Belohnung {day} kann empfangen werden und abgelaufene Belohnungen werden ungültig!',
        canReceiveTip1:
          'Diese Belohnung {day} kann in Zukunft empfangen werden',
        canReceiveTip2:
          'Die Belohnung kann täglich von {startTime} bis {endTime} beansprucht werden',
        canReceiveTip3:
          'Die Belohnung {week}{startTime}-{endTime} kann beansprucht werden',
        canReceiveTip4:
          'Diese Belohnung jeden Monat {day} {startTime}-{endTime} kann empfangen werden',
        source: 'Quelle',
        toBeCollectedToday: 'Heute sammeln',
        collectTomorrow: 'Morgen kann <Pan> (denken Sie daran, komme) </span>',
        receivedToday: 'Ich bin heute automatisch angekommen',
        rewardSource: 'Belohnungsquelle',
        rewardName: 'Belohnungstyp',
        rewardTime: 'Belohnungszeit',
        rewardexplain: 'Belohnungsanweisungen',
        distributed: '',
        validBet: 'Kumulierte Gültige Einsätze',
        ratio: 'Anteil',
        award: 'Belohnungstyp',
        arrivalTime: 'Zeit zu berücksichtigen',
        availableTime: 'Kann Zeit erhalten',
        validityTime: 'Gültigkeitszeitraum',
        status: 'Status',
        remark: 'Bemerkung',
        pending: 'Ausstehend',
        received: 'GESAMMELT',
        dispatched: 'Verteilt',
        expiredDispatched: 'Abgelaufen sind',
        bonus: 'Preise',
        ruleTabe: {
          singleRechargeAmount: 'Einzelaufladungsbetrag',
          awardAmount: 'Betrag der Belohnung',
          activityDescription: 'Aktivitätsbeschreibung',
          singleRecharge: 'Einzelner Aufladen {x}, Sie können {y} erhalten',
          single: 'Einzelne Aufladung',
          rewardRatio: 'Belohnungsverhältnis',
          awarMaxLimit: 'Obergrenze belohnen'
        }
      },
      redPocket: {
        todaySinglePay: 'Einzelaufladung an diesem Tag',
        todayPay: 'Kumulatives Aufladen an diesem Tag',
        todaySingleBet: 'Einzelcode an diesem Tag',
        todayBet: 'Kumulative Kodierung an diesem Tag',
        redPocketAmount: 'Rote Umschlagbetrag',
        grabPocketAwarMaxLimit: 'Nehmen Sie eine rote Umschlaglimit',
        payTip:
          'Die Aufladung {x} an diesem Tag kann beteiligt sein, es hat sich aufgeladen, {y}',
        grabTip1:
          'Gesamt obere Grenze {x} mal, die obere Grenze der roten Hülle in dieser Runde {y} mal (immer noch {z} mal)',
        grabTip2:
          'Die obere Grenze der roten Umschlag in dieser Runde {x} Zeiten (noch {y} mal)',
        betTip: 'Code {x} an diesem Tag kann involviert sein, codiert {y}',
        sendRedPockTip:
          'Nehmen Sie die obere Grenze der roten Umschlag {x} Zeiten (immer noch {y} mal)',
        times: '{x} mal',
        closeTip:
          'Nach Abschluss werden die Belohnungen für diese Runde nicht mehr angezeigt. <br />Beim freiwilligen Verzicht auf die Belohnung.',
        open: 'Ein',
        grab: 'schnappen',
        send: 'Liefern',
        congrats: 'Herzlichen Glückwunsch zu Ihrem Gewinn!',
        message: 'Der Bonus wurde in deine Geldbörse überwiesen',
        pinReset: 'Leeren',
        pinDelete: 'Löschen',
        pinText: 'Öffnen und Schnappen Code',
        errorTips: 'Sie haben den falschen Code eingegeben'
      },
      rescue: {
        yesterdayData: 'Gestern verloren',
        yesterdayData1: 'Verlust letzte Woche',
        yesterdayData2: 'Verlust letzten Monat',
        todayData: 'Heutiger Hilfsgelder',
        todayData1: 'Hulpgeld Van de Week',
        todayData2: 'Hulpgeld Deze Maand',
        columns: {
          amount: { label: 'Höhe des Verlusts' },
          reward: {
            label: 'Extra-Belohnungen ({unit})',
            labelNoPercent: 'Extra-Belohnungen'
          }
        }
      },
      proxy: {
        yesterdayCommission: 'Belohnungen von gestern',
        todayCommission: 'Belohnungen von heute',
        todayReward: 'Heutiger Bonus',
        dayPay: {
          '0': 'Gestern unterer -Level -Wiederaufladung',
          '1': 'Tägliche Aufladung unter -Level'
        },
        day: {
          '0': 'Belohnungen von gestern',
          '1': 'Tägliche Belohnungen',
          '2': 'Heutige Belohnungen'
        },
        weekPay: {
          '0': 'Letzte Woche niedrigere Aufladung',
          '1': 'Nachgeordnete Wiederaufladung jede Woche'
        },
        week: {
          '0': 'Belohnungen von letzter Woche',
          '1': 'Wöchentliche Belohnungen',
          '2': 'Belohnungen von dieser Woche'
        },
        monthPay: {
          '0': 'Letzte Monat laden Sie sich auf',
          '1': 'Monatliche Wiederaufladung jeden Monat'
        },
        month: {
          '0': 'Belohnungen von letztem Monat',
          '1': 'Monatliche Belohnungen',
          '2': 'Belohnungen von diesem Monat'
        },
        otherReward: 'Extra-Belohnungen'
      },
      invest: {
        todayData: 'Heutiger Rabatt',
        daysReceived: 'Eingelöste Tage',
        investmentAmount: 'Investitionsbetrag',
        accumulated: 'Gesamte Einlösung',
        now: 'Jetzt Investieren',
        receive: 'Sammeln',
        receiveSuccess: 'Erfolgreich erhalten!',
        applySuccess: 'Erfolgreiche Anwendung!',
        received: 'GESAMMELT',
        confirm: 'Investition Bestätigen',
        title: 'Investition',
        balance: 'Kontostand',
        amount: 'Investitionsbetrag',
        investSuccess: 'Erfolgreich investiert',
        investLimitTips: 'Ungenügender Kontostand.',
        receiveItem: 'Investiere {range} und verdiene zusätzlich {give}',
        tips: 'Nach der Investierung wird der Betrag von deinem Konto abgezogen und der Bonus kann am nächsten Tag beansprucht wurden',
        columns: {
          investmentAmount: { label: 'Investitionsbetrag' },
          dayRewardRate: { label: 'Tägliche\nAuszahlung' },
          rewardDays: { label: 'Tage Rückzahlung', value: '{days}Tag(e)' },
          totalRewardRate: { label: 'Gesamte\nBoni' }
        }
      },
      collectWords: {
        beingSynthesized: 'Synthetisierung',
        synthesized: 'Erfolgreich verbunden',
        totalAmount: 'Wörter sammeln und Gewinnanteil',
        reveal: 'Belohnungen',
        collected: 'Ich habe {x} Set(s) gesammelt',
        collectedStrong: 'Ich habe <span>{x}</span> Sets gesammelt',
        tips: 'Erfülle Missionen und erhalte Einträge, um täglich Charaktere zu ziehen',
        extract: 'CHARAKTERE ZIEHEN',
        extractAllWord: 'Ein Klickendes Wort Pumpen',
        extractValidTimes: 'Verbleibende {x} Male',
        button: 'SYNTHESE',
        ruleButtons: {
          unstarted: 'Nicht<br/>Gestartet',
          forward: 'Gehe Zu',
          processing: 'In Bearbeitung',
          complete: 'Erledigt'
        },
        syntheticSuccess: 'Erstellen erfolgreich',
        syntheticFailed: 'Erstellen nicht erfolgreich',
        ruleTimes: 'Abgeschlossene {x}/{y} male',
        congrats: 'Herzlichen Glückwunsch!  ',
        resultSummary:
          '{x} Spieler haben {y} Sets gesammelt. Jedes Set ist dabei <span>{z}</span> wert',
        resultCollect: 'Sammeln',
        resultCollected: 'GESAMMELT',
        result: '{x}×{y} Sets: <span>{z}</span>',
        resultUnFinish:
          'In dieser Aktivität nicht vollständig gesammelt. Bitte weiter so!'
      },
      sign: {
        continued: 'Eingeloggt für <span>{x}</span> Tage in Folge',
        grand: 'Du hast dich für insgesamt <span>{x}</span> Tage eingeloggt',
        topupNeed: 'Zur Ladung notwendig <span>{x}<span>/{y}</span></span>',
        collected: 'GESAMMELT <strong>{x}</strong>',
        betNeed: 'Wetten <span>{x}<span>/{y}</span></span>',
        signIn: 'Einloggen',
        hasSignIn: 'Angemeldet',
        hasReceive: 'GESAMMELT',
        dayCount: 'Der {x} Tag',
        extraPrize: 'Extra-Belohnungen',
        successText: 'Glückwunsch! Sie haben Boni erhalten {x}',
        extraPrizeSuccessText:
          'Glückwunsch! Sie haben zusätzliche Boni erhalten {x}',
        noSignIn: 'Kann sich derzeit nicht anmelden'
      },
      luckyWheel: {
        tabs: {
          silver: 'Silber Glücksrad',
          gold: 'Golden Glücksrad',
          diamond: 'Diamant Glücksrad',
          luckyValue: 'Glückspunkte',
          turntableTask: 'Aufgabe erfordern',
          getAnnouncement: 'Ankündigung des Preises',
          myRecord: 'Meine Einträge',
          noData: 'Keine Datensätze',
          drawNow: 'JETZT<br/>VERLOSEN',
          currentLuckyValue: 'Aktuelle Glückspunkte',
          details: 'Details'
        },
        splicingGet: '{user} erhalten Sie es unter {zhuanpan}',
        effectiveBetTips:
          'Sie müssen außerdem {x} setzen, um den Glückswert {n} zu erhalten',
        betDetails: {
          betTotal: 'Gesamtcodierung während der Veranstaltung',
          currentRulesLabel: 'Aktuelle Regeln',
          currentRules: 'Erhalten Sie {n} Glückswert für jeden {B} -Cod',
          luckyPointsUsed: 'Glückswert',
          luckyValueAvailable: 'Kann Glückswert verwenden',
          expireIntegral: 'Abgelaufener Glückswert',
          countingMethodTitle: 'Lucky Value -Berechnungsmethode:'
        },
        toast: {
          notEnough: 'Dein Glückswert ist nicht hoch genug',
          receiveSuccess: 'Erfolgreich erhalten',
          depositBalance: 'Auf das Guthaben überwiesen'
        },
        table: {
          time: 'Zeit',
          dayTask: 'Tägliche Mission',
          weekTask: 'Wöchentliche Mission',
          luckyValue: 'Glückspunkte',
          canGetluckyValue: 'Glückswer'
        }
      },
      promote: {
        currentValid: '<span>{x}</span> Anerkannte Empfehlungen',
        currentRequire:
          '(Einzahlung erforderlich <span>{x}</span>, Wetteinsatz erforderlich <span>{y}</span>)',
        currentRecharge: '(Aufladungsbedingungen <span>{x}</span>)',
        currentBet: '(Wettbedingungen<span>{y}</span>)',
        copySuccess: 'Erfolgreich kopiert!',
        copyFailed: 'Kopieren fehlgeschlagen. Bitte manuell kopieren',
        people: '{x} Leute',
        promoteUrl: 'Empfehlungs-URL',
        userName: 'Untergeordneter Konto',
        createTime: 'Registrierungszeit',
        isItEffective: 'Ist es effektiv',
        yes: 'Ja',
        no: 'NEIN',
        validConditions: 'Gültige Bedingungen',
        details: 'Details',
        all: 'Alle',
        isEffective: 'Ist es effektiv',
        efficient: 'Effizient',
        invalid: 'Ungültig',
        accountFirstDeposit: 'Konto zuerst aufladen',
        cumulativeRecharge: 'Totale Borg',
        cumulativeCoding: 'Gesamt-Wetten',
        cumulativeRechargeDays: 'Kumulative Aufladungszeiten',
        cumulativeRechargeTimes: 'Kumulative Aufladungszeiten',
        registerIPRestrictions: 'Wiederholen Sie registrierte IP',
        registerDeviceRestrictions: 'Wiederholte Registrierungsgeräte',
        downloadAPPLogin: 'Laden Sie die App herunter und melden Sie sich an',
        promotionDetails: 'Agentendetails',
        effectivePromotionNumber:
          'Effektive Werbung für die Anzahl der Personen',
        award: 'Gewinn',
        effectivePromotionNumberQuestion:
          'Wie hoch ist die effektive Personenanzahl für die Werbung?(Erfüllen Sie gleichzeitig die folgenden Bedingungen)',
        effectivePromotionNumberArbitrarily:
          'Wie hoch ist die effektive Personenanzahl für die Werbung? (Irgendjemanden befriedigen)',
        effectivePromotionNumberTip0:
          'Die App mit niedrigerer Ebene Download -App und melden Sie sich an',
        effectivePromotionNumberTip1:
          'Dieser Untergebene lädt sich zum ersten Mal auf',
        effectivePromotionNumberTip2:
          'Die kumulierte Anzahlung der Untergebenen',
        effectivePromotionNumberTip3: 'Die kumulative Wette der Untergebenen',
        effectivePromotionNumberTip4:
          'Die kumulierte Anzahl der Einzahlungen für diesen Untergebenen',
        effectivePromotionNumberTip5:
          'Der Untergebene hat Einlagen angesammelt',
        mySubordinate: 'Meine Untergebenen',
        numberPeople: 'Person',
        effectiveNumberOfPeople: 'Effektive {x} Person',
        yesterdayEfficient: 'Effektiv {x} Menschen gestern',
        receive: 'Sammeln',
        quickShare: 'Schnelles Teilen',
        shareNow: 'Sofort teilen',
        more: 'Mehr',
        shareTo: 'Teilen mit',
        orAbove: 'Oder darüber',
        timesOrMore: 'Mal oder darüber',
        copyLink: 'Link kopieren',
        save: 'Speichern',
        cancel: 'Abbrechen',
        cumulativeRewards: 'Kumulative Belohnungen',
        cumulativeRewardsTip:
          'Verteilen Sie das Konto automatisch für den nächsten Tag',
        effectivePromotionYesterday: 'Effektiv gefördert gestern',
        dayOrMore: 'Tage oder höher',
        updateTime: 'Updatezeit',
        effectiveSubordinate: 'Effektive Subordinate {x} people',
        yesterdaysEffectivePromoter: 'Effektiv beworben {x} Menschen gestern',
        receiveTimeEveryDaily:
          'Die Belohnung ist nur täglich {startTime}-{endTime}',
        receiveTimeNextDay:
          'Diese Belohnung ist nur der nächste Tag {startTime}-{endTime}',
        receiveTimeWeekly:
          'Diese Belohnung ist nur jeden Montag {startTime}-{endTime}',
        receiveTimeMonthly:
          'Die Belohnung ist nur am 1. eines jeden Monats {startTime}-{endTime}'
      },
      bet: {
        endToBeAwarded:
          'Die Aktivität ist vorbei. Bitte warte auf die Verteilung der Boni',
        endAndAwarded:
          'Die Prämie wurde verteilt. Sie können sie im Anspruchsdatensatz einsehen',
        myIntegral: 'Meine Punkte',
        slimageBonusBonus: 'Gesamtbonus teilen',
        award: 'Belohnungen',
        winWin: 'Punkteverluste und -gewinne',
        record: 'Raumrekorde',
        time: 'Zeit',
        result: 'Ergebnis',
        quizProject: 'Quiz-Events',
        bettingBelow: 'Wette {x} um ({y}) zu gewinnen',
        bettingOneBelow: 'Wette {x} um zu gewinnen',
        toBeAwarded: 'Wartet auf Eröffnung',
        winning: 'Gewonnen',
        unintendedPrize: 'Verloren',
        guessRecord: 'Quiz-Aufzeichnungen',
        allDisplayed: 'Alles anzeigen',
        noGame: 'Derzeit keine Spiele verfügbar',
        day: 'Logge dich in die Aktivität ein, um jeden Tag {x} Punkte zu erhalten',
        charge: 'Erhalte für tägliche Aufladungen entsprechende Punkte zu 1:10',
        coding: 'Erhalte für tägliche Wetten entsprechende Punkte zu 1:1',
        item: {
          betting: 'In Quiz',
          bettingEnd: 'Wartet auf Eröffnung',
          win: 'Herzlichen Glückwunsch zu deinem Sieg!',
          failed: 'Fehlgeschlagen',
          opened: 'Erhalten',
          renew: 'Weiter setzen',
          noGame: 'Derzeit keine Spiele verfügbar',
          bet: 'Einsatz',
          seal: 'Geschlossen',
          youDontNote: 'Du Hast Nicht Gewettet',
          integral: 'Punkte',
          toBeDetermined: 'Ausstehend',
          odds: 'Ungerade',
          draw: 'Gleichstand',
          winOut: 'HU',
          all: 'Alle',
          youHaveBet: 'Du hast <span>{x}</span> Punkte gewettet',
          betTeam: 'Du wählst {x} als Gewinn',
          betDraw: 'Du wählst Gleichstand',
          pleaseSelectTheOdds: 'Bitte wähle die Wahrscheinlichkeit',
          pleaseEnterTheBetPoint: 'Bitte gib die Einsatzpunkte ein',
          notBeLower: 'Einsätze dürfen nicht niedriger als {x} sein',
          notBeHigher: 'Einsätze dürfen nicht höher als {x} sein',
          onlySupports: 'Es sind nur Einsätze von {x}-{y} zulässig',
          notBeHigherThanYours: 'Deine Punkte sind zu gering',
          withdrawAmountPlaceholder: 'Minimum{a}, Maximum{b}',
          deadlineForBetting: 'Wett-Deadline:',
          onlyParticipate: '{a}{b} um teilzunehmen'
        }
      },
      luckyBet: {
        awardOrders: 'Heute gewonnene Wetten',
        notAwarded: 'Keine heutigen Gewinne',
        receive: 'Sammeln',
        received: 'GESAMMELT',
        reward: 'Gewinn',
        orderNo: 'Siegerbestellnummer:',
        totalLimit: 'Gesamtlimit - {x} mal. ',
        todayLimit: 'Max. - {y} mal heute ({z} verbleibende)',
        orderEnd: 'Endziffern der Wette',
        orderContinue: 'Ziffernfolge an beliebiger Stelle der Wette',
        orderRandom: 'Beliebige Position der Wette beinhaltet',
        amountTimes: 'Belohnungsmultiplikator',
        betNumTimes: '{x} Male des Wettbetrages',
        fixedAmount: 'Festgelegter Betrag',
        amountLimit: 'Belohnungslimit',
        validBet: 'Tägliche gültige Einsätze',
        validCharge: 'Tägliche Aufladungen',
        dailyLimit: 'Höchstgrenze täglicher Gewinne',
        times: 'Mal',
        piece: 'Eins',
        rewardDescription:
          'Belohnung = Wettbetrag x Belohnungsmultiplikator, ohne die Höchstgrenze zu überschreiten',
        receiveSuccess: 'Erfolgreich erhalten!',
        noLimit: 'Nicht Limitiert'
      },
      ranking: {
        ranking: 'Gegenwart',
        loadingMore: 'Alle laden',
        settling: 'Die Abwicklung läuft',
        rewardAmount: 'Betrag der Belohnung',
        accumulatedRecharge1: 'Aufladen von\nSpielern/kumulativen',
        accumulatedRecharge2: 'Spieler/Single -Wiederaufladung',
        accumulatedRecharge3: 'Spieler/kumulatives\nWetten',
        todayRanking1_1: 'Das heutige Wiederaufladungsranking',
        yesterdayRankingList1_1: 'Gestrige Aufladeranking',
        todayRanking2_1: 'Ranking diese Woche',
        yesterdayRankingList2_1:
          'Das Wiederaufladungsranking der letzten Woche',
        todayRanking3_1: 'Ranking des Aufladens in diesem Monat',
        yesterdayRankingList3_1: 'Letzte Rangliste des letzten Monats',
        todayRanking1_2: 'Das heutige Single -Ranking',
        yesterdayRankingList1_2: 'Gestrige Single -Ranking',
        todayRanking2_2: 'Single -Ranking in dieser Woche',
        yesterdayRankingList2_2: 'Single Ranking der letzten Woche',
        todayRanking3_2: 'Das Single -Ranking dieses Monats',
        yesterdayRankingList3_2: 'Letztes Monat Single Ranking',
        todayRanking1_3: 'Das heutige BET -Ranking',
        yesterdayRankingList1_3: 'Wettenranking gestern',
        todayRanking2_3: 'Wetten -Ranglisten in dieser Woche',
        yesterdayRankingList2_3: 'BET -Rangliste der letzten Woche',
        todayRanking3_3: 'Wetten -Ranglisten in diesem Monat',
        yesterdayRankingList3_3: 'BET -Ranking des letzten Monats',
        yesterdayRanking1: 'Sie haben gestern Rangliste',
        yesterdayRanking2: 'Sie rangieren letzte Woche',
        yesterdayRanking3: 'Sie rangieren letzten Monat',
        maxRow: 'Zeigen Sie bis zu 100 Player -Daten an',
        getBonus: 'Gewinnbonus',
        myself: 'Ich selbst',
        currentRanking: 'Ihr aktuelles Ranking',
        todayBonus: 'Erwarteten Bonus',
        refresh: 'Auffrischen',
        rankingNum: 'Nr. {0} Name',
        everyOneRewardAmount: '/Person',
        notOnList: 'Nicht Aufgelistet'
      },
      discountCode: {
        discountCode: 'Einsteigerbonus',
        firstDepositCount: 'Erster Ladungsbetrag',
        discountCodeSms: 'Überprüfen Sie die SMS erhalten Sie Lotterie',
        placeholder: 'Bitte gib den Einlösungscode ein',
        confirmTheExchange: 'Eine Lotterie erhalten',
        payBtn: 'Jetzt Einzahlen',
        success: 'Herzlichen Glückwunsch, du hast einen Bonus von {x}erhalten.',
        confirm: 'Bestätigen',
        close: 'Schließen',
        needRecharge: 'Aufladen von {0} erforderlich zum Abheben',
        tipsLable: 'Bonus-Betrag:',
        tips3: '{x}%der ersten vollen Menge, die höchste {y}',
        activityNotStarted: 'Die Aktivität hat nicht begonnen',
        activityHasEnded: 'Die Aktivität ist beendet',
        activityIDInvalid: 'Aktivitäts -ID ist ungültig',
        notPhoneGold: 'Aktivitäts -ID ist kein Telefonbonus',
        areaCodeIncorrect: 'Der regionale Code ist falsch',
        phoneNumberNothingness: 'Die Telefonnummer existiert nicht',
        phoneNumberBeUsed: 'Die Telefonnummer wurde verwendet',
        congratulations:
          'Herzlichen Glückwunsch, Sie haben die SMS -Überprüfung abgeschlossen',
        completedRegistration:
          'Herzlichen Glückwunsch, Sie haben Ihre Kontoregistrierung abgeschlossen',
        activityDissatisfy:
          'Sie sind unzufrieden mit den Bedingungen der Veranstaltung und sind eingeladen, an speziellen Benutzern teilzunehmen.',
        notEligibleEvent: 'Sie erfüllen nicht die Bedingungen des Ereignisses',
        alreadyWon: 'Schon gewonnen',
        verifyMobile: 'Überprüfen Sie die Mobiltelefonnummer',
        congratulationsReCode:
          'Herzlichen Glückwunsch, erfolgreicher Austausch!',
        tipsText:
          'Erinnerung: Die maximale Gewinnlimit dieser Lotterie ist {x}. Es ist notwendig, {y} nach Profit aufzuladen!',
        notProfitLimit: 'Nicht Limitiert',
        tipsProfitUpperLimit: 'De maximale winstlimiet van deze bonus is {x}',
        tipstipsNeedRechargeAfterProfit:
          'Nadat u winst heeft gemaakt, moet u {y} opladen om geld op te nemen!',
        distributed: 'Verteilt',
        getRedeemCode: 'Holen Sie sich den Austauschcode'
      },
      cutOnce: {
        lottery: 'Lotterie',
        drawsNumber: 'Verbleibende<span>{x}</span>Male',
        myRecord: 'Meine Einträge',
        winningAnnouncement: 'Gewinnankündigung',
        rule: 'Beschreibung der Regel',
        bonus: 'Bonus <span>{x}-{y}</span>',
        receive: 'Sammeln',
        progressText1:
          'Es wurde {x}%abgeschlossen und es ist immer noch arm {n}%',
        progressText2: 'Abgeschlossen {x}%',
        resetcountdown: '{time} Zurücksetzen',
        updateTime: 'Timing aktualisieren: {time}',
        manualUpdate: 'Manuelles Update',
        detail: 'Details',
        forward: 'Gehe Zu',
        lookover: 'Überprüfen',
        more: 'Mehr',
        userAccount: 'Mitgliedskonto',
        createTime: 'Registrierungszeit',
        detailInfo: 'Einzelheiten',
        announcement:
          'In <span>{time}</span> habe ich erfolgreich <span>{prize}</span> erhalten',
        firstAward: 'Das Ziehung wird direkt <span>{prize}</span>erhält',
        secondAward:
          'Das Zeichnen erhält <span>{prize}</span> (muss die Aufgabe erledigen, um zu empfangen)',
        finishTask: 'Mission erfüllt',
        getAward: 'Erfolgreich <span>{prize}</span> erhalten',
        tips: 'Der kumulative Gewinnpreis ≥ {x} kann erhalten werden. Derzeit insgesamt <span>{y}</span>',
        cardTitle:
          'Nachdem Sie die folgenden Aufgaben erledigt haben, erhalten Sie <span>{prize}</span>',
        detailTitle1: 'Wie bekomme ich Belohnungen?',
        detailTitle2: 'Effektive untere Bedingungen',
        detailTitle3: 'Meine Untergebenen',
        detailTitle4: 'Schnelles Teilen',
        taskText1:
          'Wirksame Förderung von Personen mit niedrigerem Level ≥ {x} Personen',
        taskText2: 'Anzahl der gültigen Wetten ≥ {x}',
        taskText3: 'Die Anzahl der Ersteinleger auf der unteren Ebene ≥{x}',
        taskText4: 'Die Anzahl der niedrigeren Level -Wiederaufladungen ≥ {x}',
        taskText5: 'Die kumulative Aufladungsmenge der niedrigeren Ebene ≥ {x}',
        taskText6: 'Die kumulative Auszahlungsmenge des unteren Niveaus ≥ {x}',
        taskText7: 'Die Anzahl der Untergebenen entsetzt ≥ {x}',
        taskText8: 'Laden Sie die App herunter und melden Sie sich an',
        taskText9: 'Meine einmalige Aufladung ≥{x}',
        taskText10: 'Meine Einzelwette ≥{x}',
        taskText11: 'Meine angesammelte Aufladung beträgt ≥{x}',
        taskText12: 'Meine gesammelten Einsätze sind ≥ {x}',
        text1:
          'Effektive Förderung von niedrigerem Niveau ≥ {x}, können Sie die verbleibenden Boni <span>{prize}</span> erhalten',
        text2:
          'Anzahl der gültigen Wetten ≥ {x}, Sie können die verbleibenden Boni <span>{prize}</span> erhalten',
        text3:
          'Die Anzahl der Personen in der unteren Ebene ≥ {x}, Sie können den verbleibenden Bonus <span>{prize}</span> erhalten',
        text4:
          'Die Anzahl der niedrigeren Level -Wiederaufladungen ≥ {x}, Sie können den verbleibenden Bonus <span>{prize}</span> erhalten',
        text5:
          'Die kumulative Aufladungsmenge der unteren Ebene ≥ {x} können Sie den verbleibenden Bonus <span>{prize}</span>',
        text6:
          'Wenn der kumulierte Auszahlungsbetrag der niedrigeren Stufe ≥ {x} ist, kann der verbleibende Bonus <span>{prize}</span> erhalten werden',
        text7:
          'Die Anzahl der Untergebenen entsetzt ≥ {x}, Sie können den verbleibenden Bonus <span>{prize}</span>erhalten',
        text8:
          'Niedrigerer Einsatz ≥ {x}, Sie können den verbleibenden Bonus <span>{prize}</span> erhalten',
        processText:
          'Effektive niedrigere Level {x} Menschen, auch arme {y} Menschen',
        detailText1:
          'Das erfolgreiche Login der Untergebenen bedeutet, dass es effektiv ist',
        detailText2: 'Untergebene haben Wetten, was bedeutet, gültig',
        detailText3:
          'Die Fertigstellung der ersten Gebühr der Untergebenen zeigt an, dass sie effektiv sind',
        detailText4: 'Melden Sie sich während des Zyklus erfolgreich an',
        withdrawals: 'Anzahl der Abhebungen',
        withdrawValue: 'Abhebebetrag',
        rechargeValue: 'Einzahlungsbetrag',
        rechargeCount: 'Aufladen',
        awardText: 'Herzlichen Glückwunsch, erhalten Sie Boni <span>{x}</span>',
        awardText1: 'Bonus <span>{x}</span>',
        myLink: 'Exklusiver Link',
        change: 'ersetzen',
        progressTextInvitedNumber:
          'Laden effektiv {x} Menschen ein, aber auch arm {n} Menschen',
        progressTextDaMaNumber:
          'Effektive Downline {x} Personen, noch fehlen {n} Personen',
        progressTextFirstRechargeNumber:
          'Effektive Untergebene haben {x} erste Einzahlungen getätigt, und es sind noch {n} Personen übrig',
        progressTextRechargeCount:
          'Effektiv niedrigere Level -Wiederaufladungsnummer {x} mal, immer noch schlecht {n} Zeiten',
        progressTextTotalRechargeValue:
          'Effektiv unteres niedrigeres Level -Akkumulierte Aufladen {x} und schlecht {n}',
        progressTextTotalWithdrawValue:
          'Effektive Untergebene kumulative Rückzug {x}, immer noch arm {n}',
        progressTextWithdrawCount:
          'Effektive untergeordnete Auszahlung {x} mal, immer noch schlecht {n} mal',
        progressTextTotalDaMaValue:
          'Die effektiven Untergebenen haben {x} Einsätze gesammelt und es sind noch {n} übrig.',
        detailInfoText1: 'Wetten während des Zyklus',
        detailInfoText2:
          'Vervollständigen Sie die erste Aufladung innerhalb des Zyklus',
        detailInfoText3:
          'Kumulative Wiederaufladung {n} Zeiten während des Zyklus',
        detailInfoText4: 'Kumulative Aufladung während des Zyklus {x}',
        detailInfoText5: 'Kumulativer Rückzug während des Zyklus {x}',
        detailInfoText6: 'Kumulativer Rückzug während des Zyklus {n} mal',
        detailInfoText7: 'Kumulierte Wetten im Zeitraum {n}',
        secondConditionInvitedNumber:
          'Der Fortschritt beim Einladen von Freunden beträgt 100,00 % und Sie können den verbleibenden <span>{prize}</span> erhalten',
        completedValue: '{x} % abgeschlossen',
        cardInvitedNumber: '{x} Personen unten effektiv beworben'
      },
      newCutOnce: {
        firstAward: '{0}. Ziehung, habe {1}',
        firstAward1:
          'Die {0}te Ziehung hat nicht gewonnen, bitte versuchen Sie es erneut!',
        secondAward:
          '{0} Personen als effektive Promoter hinzugefügt und die Anzahl der Verlosungen +1',
        finishTask: 'Herzlichen Glückwunsch, Sie haben insgesamt {0} gewonnen.',
        getAward: 'Bonus {0} erfolgreich beansprucht',
        lotterytip: 'Anzahl verbleibender Ziehungen: 0',
        demoModeTip: 'Die Ankernummer hat keine Autorität',
        notStartProgress:
          'Sie können es nur beanspruchen, wenn die Gesamtgewinne ≥{totalAward} betragen.',
        nextTaskRechargeCountTip: 'Untergeordnete Aufladung ≥ {0}',
        nextTaskRechargeCountTip1:
          'Die Beförderung von Untergebenen zur erfolgreichen Anmeldung gilt als gültig.',
        progressingpProgress:
          'Der Gesamtgewinn muss ≥ {totalAward} sein, um ihn zu erhalten, und es sind noch {undoneAmount} übrig.',
        cardTipsTitle:
          'Befördern Sie {0} Untergebene, um {1} Verlosungschancen zu erhalten',
        awardText1: '{0} gewonnen (maximal {1})',
        awardText2: '{0} gewonnen',
        tip1: 'Sie haben Preise gezogen und der aktuelle Gesamtpreis beträgt {0}',
        gotoRecord: 'Datensätze anzeigen',
        cardTipsSubText:
          'Von Untergebenen verlangen, dass sie ≥{amount} aufladen, derzeit gültig für {people}',
        cardTipsSubText1:
          'Die erfolgreiche Anmeldung der beförderten Untergebenen gilt als gültig und die aktuellen {people} Personen sind gültig',
        shareText: 'Aktie'
      }
    },
    records: {
      totalReceive: 'Gesamter entgegengenommener Betrag',
      rewardAmount: 'Betrag der Belohnung',
      reward: 'Gewinn',
      activeId: 'ID',
      rewardName: 'Belohnungsname',
      rewardTime: 'Belohnungszeit',
      amount: 'Betrag',
      activity: 'Aktivitätsniveau',
      remark: 'Belohnungsanweisungen',
      activeTypeName: 'Quelle',
      receiveRecords: 'Bewerb.-aufzeichn.',
      checkStatus: 'Status',
      underReview: 'Wird geprüft',
      passed: 'Genehmigt',
      rejected: 'Abgelehnt',
      arriveAccount: 'Im Konto',
      progress:
        'Wenn Sie das Konto erhalten, geben Sie es später auf dem Konto aus',
      cancelled: 'Abgesagt',
      operate: 'Aktion',
      detail: 'Details',
      info: 'Bewerbungsinformationen',
      rewardAmount2: 'Betrag der Belohnung',
      administratorReply: 'Antwort des Administrators',
      noReply: 'Derzeit keine Antwort',
      arrivalTime: 'Zeit zu berücksichtigen',
      platformRewardDetail:
        'Kumulative gültige Wetten {betCode}, Rate {rate}%, Belohnung {gold}'
    },
    cpf: {
      CPFTitle: 'Provident Fund aufladen',
      accumulHistory: 'Kumulative Aufzeichnung',
      betHistory: 'Kumulative Wettanforderungen',
      rulesDesc: 'Beschreibung der Regel',
      totalRechargeAmount: 'Kumulative Aufladung',
      recharge: 'Einzahlen',
      give: 'Geschenk',
      maxLimitFundAmount: 'Geschenkabdeckung',
      maxLimitAddTimes: 'Anzahl der Zeiten',
      noCap: 'Nicht begrenzt werden',
      cpfName: 'Provident Fund',
      withdraw: 'Mitnahme',
      hasWithdraw: 'Entfernen',
      hasSend: 'Verteilt',
      hasCancel: 'Abgesagt',
      currentCPF: 'Aktueller Vorsorgefonds',
      firtRechargeCPF: 'Kostenloser Vorsorgefonds {num} für jede Aufladung',
      maxLimitText1:
        'Die maximale Anzahl an Geschenken beträgt {num1} und der maximale Betrag beträgt {num2}',
      maxLimitText2:
        'Die Anzahl der Geschenke ist {num}-mal begrenzt und der Höchstbetrag ist nicht begrenzt.',
      maxLimitText3:
        'Es gibt keine Obergrenze für die Anzahl der Geschenke und der Höchstbetrag beträgt {num}',
      maxLimitText4:
        'Es gibt keine Obergrenze für die Anzahl der Schenkungen und auch für die Höhe der Schenkung gibt es keine Obergrenze.',
      needRecharge: 'Muss noch wetten',
      finishRecharge: 'Die Anforderungen wurden erfüllt',
      rechargeCount: 'Mal',
      maxAmount: 'Deckel　',
      enableWithdraw: 'Verfügbar sein',
      details: 'Details',
      time: 'Zeit',
      rechargeAmount: 'Einzahlungsbetrag',
      addFundRate: 'Anteil geben',
      addFundAmount: 'Betrag geben',
      totalAmount: 'Gesamtakkumulation',
      addBetCodeRate: 'Wette',
      addBetCodeAmount: 'Neue\nWettanforderungen',
      afterReset: 'Zurücksetzen nach {x}'
    },
    promote: {
      title: 'Promotion',
      unitPeople: ' ',
      empty: 'keiner',
      myPromote: 'Meine Empfehlung',
      myData: 'Meine Daten',
      promoteShare: 'Bewerben und teilen',
      myCommission: 'Meine Komissionen',
      myPerformance: 'Meine Leistung',
      returnCommissionProportion: 'Bonusrate',
      tutorial: 'Promotion\nTutorial',
      videoTutorial: 'Video-Tutorial',
      directAccountOpening: 'Registrieren mit Subagent',
      agencyTransfer: 'Agenten-Überw',
      conversionRecord: 'Überweisungen',
      pickUpRecord: 'Sammelverlauf',
      online: 'Online',
      offline: 'Offline',
      yes: 'Ja',
      times: 'Mal',
      no: 'NEIN',
      date: 'Datum',
      startTime: 'Startdatum',
      endTime: 'Ende',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      memberID: 'Mitgliedsnummer',
      searchMemberID: 'Mitgliedsnummer',
      memberAccount: 'Mitgliedskonto',
      searchMemberAccount: 'Mitgliedskonto',
      memberDetail: 'Untergeordnete Details',
      subordinate: 'Untergebene von {id}',
      userStatusType: {
        normal: 'Normal',
        freezeManually: 'Handbuch gefroren',
        abnormalFreezing: 'Fehler beim Sperren',
        prohibitionOfReceivingDiscounts: 'Verboten, Rabatte zu erhalten',
        blacklist: 'Schwarze Liste',
        disabled: 'Stoppen',
        withdrawalProhibited: 'Rückzug verbieten',
        forbiddenToEnterTheGame: 'Verboten, in das Spiel einzusteigen',
        returnThePrincipal: 'Geben Sie den Auftraggeber zurück und entlassen'
      },
      myDataPage: {
        coreData: 'Kerndatei',
        dataPreview: 'Datenübersicht',
        newDirectMembers: 'Neu direkte Mitgliedschaft',
        firstChargeUsers: 'Anzahl der ersten Gebühren',
        rechargeUsers: 'Anzahl der Aufladungen',
        rechargeAmount: 'Einzahlungsbetrag',
        performance: 'Leistung',
        commission: 'Kommision',
        myTeam: 'La mia squadra',
        totalUsers: 'Totale Menschen',
        directUsers: 'Direkt',
        otherUsers: 'Anzahl anderer',
        totalPerformance: 'Gesamt\nLeistung',
        directPerformance: 'Leistung des\nSubagent',
        otherPerformance: 'Andere Leistung',
        totalCommission: 'Gesamtprovision',
        directCommission: 'Kommision der Subagenten',
        otherCommission: 'Andere Kommision'
      },
      directBetting: {
        memberID: 'Mitgliedsnummer',
        searchMemberID: 'Bitte geben Sie die Mitglieder -ID ein',
        orders: 'Hinweis',
        validBet: 'Gültige Einsätze',
        profit: 'Gesamt W/L',
        statisticalDate: 'Statistisches Datum',
        details: 'Detail',
        directBettingDetail: 'Verrat',
        betTime: 'Wettzeit',
        platform: 'Spielplattform',
        category: 'Spiel Typ',
        name: 'Spielname',
        memberProfit: 'Sieg/Niederlage',
        validOrderAmount: 'Gültige Einsätze',
        profitAmount: 'Gewinn/Verlust',
        totoalValidOrder: 'Gesamtnotizbestellung',
        directValidBet: 'Direkte gültige Wetten',
        directProfit: 'Direkter Gewinn/Verlust',
        otherValidBet: 'Andere effektive Wetten',
        otherProfit: 'Andere oder Verluste',
        totoalValidOrderAmount: 'Gültige Wetten',
        totoalProfit: 'Gesamte Verluste und Gewinne'
      },
      directData: {
        memberID: 'Mitgliedsnummer',
        searchMemberID: 'Bitte geben Sie die Mitglieder -ID ein',
        registrTime: 'Registrierungszeit',
        registrDate: 'Registrieren',
        loginDate: 'Anmeldedatum',
        lastLogin: 'Letzte Anmeldung',
        account: 'Konto',
        firstDeposit: 'Erste Gebühr',
        isFirstDeposit: 'Ob zur ersten Anklage',
        status: 'Status',
        times: 'Online -Login und Nummer',
        now: 'Aktuell',
        subordinate: 'Seine Untergebenen',
        totalRegisterPerson: 'Anzahl der Register',
        totalDepositPerson: 'Anzahl der Aufladungen',
        totalFirstDepositPerson: 'Anzahl der ersten Gebühren',
        totalDepositAmount: 'Einzahlungsbetrag',
        totalValidBet: 'Gültige Einsätze'
      },
      common: {
        all: 'Alle Typen',
        chess: 'Karten',
        fish: 'Angeln',
        street: 'Arcade',
        sports: 'Sport',
        real: 'Live',
        gameing: 'Arkade',
        lottery: 'Lotterie',
        other: 'Andere',
        cockfighting: 'Hahnenkampf',
        game: 'Spiele',
        blockchain: 'Blockchain',
        gaming: 'E-Sports'
      },
      commission: {
        parentAgentID: 'Überlegene ID',
        memberID: 'Mitgliedsnummer',
        searchMemberID: 'Bitte geben Sie die Mitglieder -ID ein',
        addTime: 'Beitrittzeit',
        settleTime: 'Abrechnungszeitpunkt',
        settleDay: 'Vergleichsdatum',
        type: 'Arten',
        performance: 'Leistung',
        lowerLevelPeople: 'Direkt unter',
        count: 'Kommision',
        details: 'Details',
        contributionCommission: 'Beitrag Kommission',
        account: 'Konto',
        commissionReceived: 'Gesammelte Kommisionen',
        searchAccount: 'Konto',
        commissionDetail: 'Details der Provisionen',
        contributebetUsername: 'Beitragskonto',
        contributePerformance: 'Betragsleistung',
        totalPerformance: 'Gesamt\nLeistung',
        totalCount: 'Gesamtprovision',
        directly: 'Subagent',
        lowerLevel: 'Untergebene',
        parentAgent: 'Sein Übergeordneter',
        deposit: 'kumulierte Einzahlung',
        netProfix: 'Nettogewinn',
        unReached: 'Ziel nicht erreicht',
        directPerformance: 'Leistung des\nSubagent',
        directCommission: 'Kommision der Subagenten',
        otherAchievements: 'Andere Leistung',
        otherCommissions: 'Andere Kommision',
        validmembers: 'Mitwirkende',
        memberProfitLoss: 'Mitgliedergewinn oder Verlust',
        discount: 'Rabatt'
      },
      promote: {
        searchMemberID: 'Bitte geben Sie die Mitglieder -ID ein',
        account: 'Konto',
        agentMode: 'Proxy -Modus',
        infinite: 'Unterschied in unendlicher Ebene',
        firstLevel: 'Erster Agent',
        netProfit: 'Erster Nettogewinn',
        threeNetProfit: 'Drei -Level -Nettogewinn',
        national: 'Nationaler Agent',
        settleDurationDay: 'Tagknoten',
        settleDurationWeek: 'Wöchentlich',
        settleDurationMonth: 'Monatlich',
        memberId: 'Meine ID',
        mySuperior: 'Überlegene ID',
        myParent: 'Mein Übergeordneter',
        directNum: 'Direkt unter den Untergebenen',
        inviteCode: 'Einladungs-Code',
        available: 'Sammelbar',
        getCommission: 'Kommisionen sammeln',
        commission: 'Kommision',
        teamData: 'Alle Daten',
        directBetting: 'Direkte Wetten',
        directData: 'Direkte Daten',
        directFinance: 'Direkte Finanzierung',
        directReceive: 'Direkt empfangen',
        totalDeposit: 'Gesamtaufladung',
        totalDepositCount: 'Gesamtzahl der Ersteinführer',
        totalDepositDirect: 'Direkte Einzahlung',
        totalDepositOthers: 'Andere Einzahlung',
        totalValidBet: 'Gültige Wetten',
        totalNetProfit: 'Gesamte Verluste und Gewinne',
        betTimes: 'Gesamtnotizbestellung',
        firstDeposit: 'Anzahl der ersten Gebühren',
        firstDepositDirect: 'Direkt unter der ersten Aufladung',
        firstDepositOthers: 'Andere erste Aufladung',
        more: 'Mehr',
        totalCommission: 'Kumulierte Kommisionen',
        availableCommission: 'Gesammelte Kommission',
        shareSite: 'Agenteninformationen',
        totalNumberOfTeams: 'Gesamtanzahl des Teams',
        directMember: 'Subagent Mitglied',
        totalNetProfix: 'Gesamtnettogewinn',
        directNetProfix: 'Direktes Nettoeinkommen',
        otherNetProfix: 'Anderes Nettoeinkommen',
        directValidNum: 'Gültige Anzahl der direkten Untergebenen',
        otherValidNum: 'Andere gültige Spieler',
        otherMembers: 'Andere Mitglieder',
        totalPerformance: 'Gesamt\nLeistung',
        directPerformance: 'Leistung des\nSubagent',
        directCommission: 'Kommision der Subagenten',
        otherPerformance: 'Andere Leistung',
        otherCommission: 'Andere Kommision',
        lastCommission: 'Letzte Kommisionen',
        validMember: 'Effektive Personen',
        performance: 'Leistung',
        clickSave: 'Klicken zum Speichern',
        myLink: 'Exklusiver Link',
        myLinkChange: 'ersetzen',
        copy: 'Kopieren',
        proxyLevel: 'Agent Stufe',
        receiveSussessTip: 'Provision erfolgreich erhalten',
        noCommonssionTip:
          'Die Provision, die Sie vorerst nicht erhalten können.',
        proxyLevelTable: {
          proxyLevel: 'Agent Stufe',
          promotionConditions:
            'Beförderungsbedingungen (befördert, befördert zu werden, um wieder Kommissionen zu erhalten)'
        },
        publicityIntruduction:
          'Das weltweit erste hochauflösende 2K-Pockerspiel\nScan-Code zum Herunterladen',
        downloadSuccessTips: 'Das Bild wurde erfolgreich gespeichert',
        downloadImageName: 'Aktie',
        shareText: '{account} Promotion -Adresse',
        notSupportShare:
          'Der Browser unterstützt keine gemeinsame Nutzungsfunktion'
      },
      directFinance: {
        memberID: 'Mitgliedsnummer',
        searchMemberID: 'Bitte geben Sie die Mitglieder -ID ein',
        deposit: 'Einzahlen',
        withdrawal: 'Abheben',
        difference: 'Unterschied',
        balance: 'Gleichgewicht',
        totalDeposit: 'Gesamtaufladung',
        totalWithdrawal: 'Totaler Rückzug',
        totalNetDiff: 'Gesamtladedifferenz',
        depositCount: 'Anzahl der Aufladungen',
        firstDepositPerson: 'Anzahl der ersten Gebühren',
        withdrawPerson: 'Anzahl der Abhebungen',
        regCount: 'Anzahl der Register',
        timesCount: 'Frequenz',
        statisticalDate: 'Statistisches Datum',
        rechargeAmount: 'Einzahlungsbetrag',
        withdrawalAmount: 'Abhebebetrag',
        netDiff: 'Ladeunterschied',
        currentBalance: 'Aktueller Gleichgewicht'
      },
      directReceive: {
        searchMemberID: 'Bitte geben Sie die Mitglieder -ID ein',
        statisticalDate: 'Statistisches Datum',
        totalClaimed: 'Gesamtsammlung',
        activityClaimed: 'Eventsammlung',
        taskClaimed: 'MISSIONSKAUFEK',
        cashbackClaimed: 'Rückgabe-Bonus',
        vipClaimed: 'VIP -Sammlung',
        agentCommission: 'Agentenkommission',
        balanceTreasureInterest: 'Interesse'
      },
      pickUpRecordRoot: {
        pickUpTime: 'Sammlungszeit',
        contributors: 'Mitwirkende',
        amount: 'Betrag',
        commissionReceived: 'Gesammelte Kommisionen'
      },
      transferRecord: {
        transferTime: 'Überweisungszeit',
        transferInAccount: 'Sammlungs-Konto',
        transferAmount: 'Überweisungbetrag',
        remark: 'Bemerkung',
        totalTransferAmount: 'Gesamt Überweisung'
      },
      proportion: {
        level: 'Level',
        validBet: 'Gültige Einsätze',
        rebateAmount: 'Bonusbeträge',
        validNum: 'Effektive Personen',
        netProfix: 'Nettogewinn',
        profitRate: 'Bonusrate',
        unitSuffix: '(Einheit: 10,000)',
        perRebateAmount: 'Provisionsrückerstattungsbetrag pro 10,000',
        perProfitRate: 'Provisionssatz pro 10.000',
        footer:
          'Gültige Bedingungen: Der Aufladebetrag des niedrigeren Levels beträgt <em> ≥ {0}</em> und die Wette ist gültig <em> ≥ {1}</em>'
      },
      createAccount: {
        username:
          'Bitte geben Sie ein {Bereich} -Bit -Zeichen ein, um Englisch/Zahlen zu unterstützen',
        usernameValid: 'Kontofehler, bitte erneut eingeben',
        passwordLabel: 'Anmeldungspasswort',
        repeatPasswordLabel: 'Passwort Bestätigen',
        password:
          'Bitte geben Sie {Range} Bit ein. Enthält zwei Typen: Englisch/Digital/Symbole',
        repeatPassword: 'Bitte gib das Login-Passwort erneut ein',
        passwordValid: 'Falsches Passwort, bitte gebe es erneut ein',
        passwordRepeat:
          'Die Passwörter sind nicht identisch, Bitte erneut eingeben',
        verifyCodeLabel: 'OTP',
        verifyCode: 'Bitte gib den Bestätigungscode ein',
        verifyCodeValid: 'Falscher Bestätigungscode. Bitte erneut eingeben',
        submit: 'Registrierung absenden',
        model: {
          title: 'Registrierung Erfolgreich',
          account: 'Konto',
          password: 'Passwort',
          userAccount: 'Mitgliedskonto',
          userPassword: 'Anmeldungspasswort',
          importTips:
            'Bitte merken Sie sich diese Daten oder bewahren Sie sie gut auf, da Sie sie nicht mehr abrufen können, wenn Sie diese Seite verlassen.',
          button: 'Kopieren und schließen'
        }
      },
      agentTransfer: {
        usernamePlaceholder: 'Bitte Mitgliedskonto eingeben',
        password: 'Passwort',
        passwordPlaceholder: 'Bitte gib das Passwort ein',
        transferAmount: 'Überweisungbetrag',
        transferAmountPlaceholder: 'Bitte Überweisungsbetrag eingeben',
        availableBalance: 'Verfügbarer Stand',
        remark: 'Bemerkung',
        remarkPlaceholder:
          'Bitte geben Sie einen Kommentar mit maximal {length} Zeichen ein',
        button: 'Überweisung abschicken',
        selectPlaceholder: 'Subagent auswählen',
        settingPwdTitle: 'Abhebungs-PIN Einrichten',
        settingPwdContent: 'Bitte lege erst das Abhebungspasswort fest',
        transferSuccess: 'Betrag erfolgreich überwiesen'
      },
      tutorialContent: {
        national: {
          bigAgent: {
            '0': 'Gesamtprovision <em>{0}</em>',
            '1': 'Direkte Leistung {0}, direkt unter der Kommission <em> {1} </em>',
            '2': 'Andere Kommissionen <em>{0}</em>'
          },
          direct: {
            validBet: 'Gültige Wetten {0}',
            b1Text: 'B1 Trägt Provision bei <em>{0}</em>',
            b2Text: 'B2 Trägt Provision bei <em>{0}</em>',
            b3Text: 'B3 Trägt Provision bei <em>{0}</em>'
          },
          other: {
            validBet: 'Gültige Wetten {0}',
            c1_1Text: 'C1 trägt zu A bei <em>{0}</em><br> Von anderen {1}%',
            c1_2Text: 'C1 Trägt Provision bei <em>{0}</em>',
            c2_1Text: 'C2 Trägt Provision bei <em>{0}</em>',
            c2_2Text: 'C2 Trägt zu A bei <em>{0}</em><br> Von anderen um {1}%',
            c3_1Text: 'C3 Trägt Provision bei <em>{0}</em>',
            c3_2Text: 'C3 trägt zu A bei <em>{0}</em><br> Von anderen um {1}%'
          },
          tutorialDetail: {
            content:
              "<h1> <strong> Beispiel Beschreibung Die Beschreibung lautet wie folgt: </strong> </h1> <p> Angenommen, das aktuelle gültige Wettverhältnis beträgt 1%(dh das Direkt 30%(dh andere) a ist der erste, der Geschäftsmöglichkeiten entdeckt, und B1, B2 und B3 werden sofort entwickelt; B1 hat C1 und C2 entwickelt; B2 hat kein höheres Niveau; B3 hat C3 untergebracht. Das effektive Wettbewerb von B1 am nächsten Tag beträgt 500, das effektive Wettbewerb von B2 3000, das effektive Wettbewerb von B3 2000, das effektive Wettbewerb von C1 beträgt 1000, das wirksame Wettbewerb von C2 beträgt 2000 und das effektive Wettbewerb von C3 ist 20.000. </p> <span> Dann ist die Berechnungsmethode zwischen ihnen wie folgt: </span> <ul> <li> <strong> 1, B1 -Kommission </strong> (Beitrag direkt unter C1 und C2) = (1000+ ) 2000)* 1%= <em> 30 </em> </li> <li> <strong> 2, B2 -Kommission </strong> (kein niedrigeres Niveau) = (0+0)* 1%= <em > 0 </em> </li> <li> <strong> 3, B3s Kommission </strong> (Beitrag direkt unter C3) = 20000 * 1%= <em> 200 </em> </li> <li > <strong> 4. Die Kommission von A </strong> zusätzlich zu den Untergebenen B1, B2 und B3 beiträgt auch Beiträge von anderen niedrigeren Level C1, C2 und C3 wie folgt: <ul> <li: <ul> <li > <strong> (1) Eine direkte Kommission von A </strong> (Beitrag direkt unter B1, B2 und B3) = (500+3000+2000) * 1%= <em> 55 </em> </li> <li> <strong> (2 2) A's andere Provisionen </strong> (aus C1-, C2- und C3 -Beitrag) = (1000+2000+20000) * 1% * 30% = <em> 69 </em> </li> <li> <strong <strongg> (3) Eine Gesamtkommission von A </strong> (direkt angeschlossen+andere) = 55+69 = <em> 124 </em> </li> </li > <li> <strong> 5. Zusammenfassende Anweisungen </strong> <ul> <li> <strong> (1) Eine Beschreibung: </strong> a ist der erste, der Geschäftsmöglichkeiten entdeckt, damit er immer 30% extrahieren kann von den Untergebenen aus dem niedrigeren Niveau. Zum Beispiel: C1 kann 1% * 30% bis a beitragen, kann D1 1% * 30% * 30% bis a beitragen, E1 kann 1% * 30% * 30% * 30% beitragen, beitragen 1% * 30% * 30% , unbegrenzte Untergebene, ein solcher Druck nach einer solchen Push -Essenz </li> <li> <strong> (2) B Hinweis: </strong> b ist nicht der erste, der Geschäftsmöglichkeiten entdeckt, aber B kann immer 30%der niedrigeren Level -Level extrahieren, zum Beispiel: D1 Es kann 1% * 30% bis B beitragen, E1 kann 1% * 30% * 30% bis B beitragen. </li> <li> <strong> (3) C Anweisungen: </strong> Obwohl C später entdeckt wird, kann C immer 30%der Untergebenen aus der unteren Ebene extrahieren, zum Beispiel: E1 kann C an C beitragen, 1% * 30%, F1 kann 1% * 30% * 30% bis C beitragen, G1 kann 1% * 30% * 30% * 30% bis C, unbegrenzte Untergebene beitragen. </li> <li> <strong> (4) Regeln Zusammenfassung: </strong> Egal, ob es a, b, c ist, egal welches Niveau, solange Sie hart daran arbeiten, Ihr niedrigeres Niveau zu entwickeln, können Sie können Immer 30 aus der unteren Ebene extrahieren. Der Anteil von %, das erzielte Einkommen ist dieselbe fair, und nach keinem Bestehen leiden das Phänomen der Geschäftsmöglichkeiten. </li> </ul> </li> </ul>"
          }
        },
        infinite: {
          bigAgent: {
            '0': 'Gesamtleistung {0}',
            '1': 'Gesamtprovision <em>{0}</em>',
            '2': 'Leistung des\nSubagent{0}',
            '3': 'Return {0}% direkt unter der Kommission <em>{1}</em>',
            '4': 'Andere Leistung {0}',
            '5': 'Staffelprovision {0}% andere Provision <em>{1}</em>'
          },
          direct: {
            validBet: 'Gültige Wetten {0}',
            b1Text: 'B1 Trägt Provision bei <em>{0}</em>',
            b2Text: 'B2 Trägt Provision bei <em>{0}</em>',
            b3Text: 'B3 Trägt Provision bei <em>{0}</em>'
          },
          other: {
            validBet: 'Gültige Wetten {0}',
            c1_1Text:
              'C1 Trägt zu A bei <em>{0}</em><br> Von Differenzialen {1}%',
            c1_2Text: 'C1 Trägt Provision bei <em>{0}</em>',
            c2_1Text: 'C2 Trägt Provision bei <em>{0}</em>',
            c2_2Text: 'C2 trägt zu A bei <em>{0}</em><br> Aus Stufe {1}%',
            c3_1Text: 'C3 Trägt Provision bei <em>{0}</em>',
            c3_2Text:
              'C3 Trägt zu A bei <em>{0}</em><br> Kein Unterschied im Tier'
          },
          tutorialDetail: {
            content:
              '<h1><strong>Ein Beispiel ist wie folgt:</strong></h1><p>Angenommen, die aktuellen effektiven Wetten von 0 bis 10.000 erhalten eine Provision von 100 (d. h. 1 %) pro 10.000, und die Effektive Einsätze über 10.000 erhalten eine Provision von 300 pro 10.000. (d. h. 3 %). A war der erste, der auf dieser Website Geschäftsmöglichkeiten entdeckte, und entwickelte sofort B1, B2 und B3. B1 entwickelte C1 und C2 weiter. B2 hat keine Untergebenen, und B3 entwickelte den relativ leistungsstarken C3. Am zweiten Tag beträgt der effektive Einsatz von B1 500, der effektive Einsatz von B2 3000, der effektive Einsatz von B3 2000, der effektive Einsatz von C1 1000, der effektive Einsatz von C2 2000 und der effektive Einsatz von C3 bis zu 20000. </p><span>Dann ist die Einkommensberechnungsmethode zwischen ihnen wie folgt: </span><ul><li><strong>1. Provision von B1</strong> (direkte Beiträge von C1 und C2) = (1000 + 2000) * 1 % = <em>30</em></li><li><strong>2. Provision von B2</strong> (keine Untergebenen) = (0+0) * 1 % = <em> 0</em></li><li><strong>3. B3-Provision</strong> (direkter Beitrag von C3) = 20000 * 3 % = <em>600</em></li><li> <strong>4. Zusätzlich zu den Beiträgen der direkten Untergebenen B1, B2 und B3 stammt die Provision von A auch aus Beiträgen der anderen Untergebenen C1, C2 und C3, wie folgt: </strong><ul><li><strong>( 1 )Direkte Provision von A</strong>(Beitrag von direktem B1, B2 und B3) = (500+3000+2000) * 3% = <em>165</em></li><li><strong>( 2 )As andere Provisionen</strong>(aus C1-, C2-Beiträgen)=(1000+2000) * 2%= <em>60</em></li><li><strong>(3)As Gesamtprovision </strong>(direkt + andere) = 165+60 = <em>225</em></li></ul></li><li>5. Zusammenfassung: <ul><li>< strong> (1) Direktes Team: Bezieht sich auf die direkt von A entwickelten Untergebenen, dh auf die erste Beziehungsebene mit A, die zusammen als direktes Team bezeichnet wird. </li><li><strong>(2) Andere Teams</strong>: Bezieht sich auf diejenigen, die von Untergebenen von A entwickelt werden. Sie haben eine Beziehung der zweiten Ebene zu A oder höher, dh die Untergebenen von Untergebenen , und die Untergebenen von Untergebenen usw. werden zusammenfassend als andere Teams bezeichnet. Da dieses Agenturmodell unbegrenzte Untergebene entwickeln kann, wird in diesem Artikel der Einfachheit halber nur die 2-Ebenen-Struktur als Beispiel verwendet. </li><li><strong>(3) Beschreibung von A</strong>: Die direkte Leistung von A beträgt 5.500 und die sonstige Leistung beträgt 20.000 (aufgrund der Leistung von C3). Die Gesamtleistung beträgt 28.500 und die entsprechende Provision Der Steuersatz beträgt 3 %. Da B1 eine Gesamtleistung von 3.000 hat und nur einen Rabatt von 1 % erhält, während A eine Gesamtleistung von 28.500 hat und ein Rabattverhältnis von 3 % genießt, entsteht zwischen A und B1 eine Rabattlücke. Der Unterschied beträgt: 3 % -1 % = 2 %, dieser Unterschied ist der Teil, den C1 und C2 zu A beitragen, also tragen C1 und C2 zu A bei: (1000+2000)* 2 % = 60, es gibt keinen extremen Unterschied zwischen A und B3, also C3 trägt zu A bei. Die Beitragsprovision beträgt 0. </li><li><strong>(4) Beschreibung von B1</strong>: B1 hat die Untergebenen C1 und C2. Da die direkte Leistung 3000 beträgt, beträgt die entsprechende Rabattquote 1 %. </li><li><strong>(5) B2-Erklärung</strong>: B2 ist möglicherweise faul und wird keinen Nutzen daraus ziehen, wenn er seine Untergebenen nicht fördert. </li><li><strong>(6) B3-Erklärung</strong>: Obwohl B3 relativ spät beigetreten ist und A untergeordnet ist, ist sein untergeordneter C3 sehr leistungsstark und hat eine direkte Leistung von 20.000, sodass B3 direkt arbeiten kann Profitieren Sie von höheren Provisionen. Der Anteil liegt bei 3 %. </li><li><strong>(7) Zusammenfassung der Regeln</strong>: Egal wann Sie beitreten, wem Sie unterstellt sind, egal auf welcher Ebene Sie sich befinden, Ihr Einkommen wird niemals beeinträchtigt, und das werden Sie auch tun Erleiden Sie nicht länger die Verluste der Untergebenen anderer. Die Entwicklung wird nicht eingeschränkt. Dies ist ein absolut faires und unparteiisches Agenturmodell, und niemand wird immer ganz unten sein, nur weil er zu spät einsteigt. </li></ul></li></ul>'
          }
        },
        netProfit: {
          bigAgent: {
            '0': 'Gesamtprovision <em>{0}</em>',
            '1': 'Direkte Leistung {0} Direktkommission <em> {1} </em>'
          },
          direct: { validBet: 'Nettogewinn {0}' },
          a: {},
          b1: {},
          b2: {},
          b3: {},
          tutorialDetail: {
            content:
              '<h1><strong>Ein Beispiel ist wie folgt:</strong></h1><p>Angenommen, die aktuelle Rabattquote des Nettogewinns beträgt 1 % (d. h. Direktverkäufe). A ist der Erste, der das Geschäft entdeckt Möglichkeiten und entwickelt sofort B1, B2 und B3. Am nächsten Tag beträgt der Nettogewinn von B1 500, der Nettogewinn von B2 3000 und der Nettogewinn von B3 -2000. </p><span>Dann lautet die Berechnungsmethode für das Einkommen von A wie folgt: </span><ul><li><strong>1. Provision von A</strong> (direkter Beitrag von B1, B2 und B3) = (500+ 3000-2000) * 1 %=<em>15</em></li><li><strong>2. Zusammenfassende Erklärung</strong><ul><li><strong>(1) Netto Gewinn: Wenn der Benutzer beispielsweise während des Abrechnungszeitraums 2.000 beisteuerte (d. h. die Plattform erzielte einen Gewinn von 2.000) und von der Plattform einen Rabatt von 100 erhielt, betrug der Nettogewinn 1.900; wenn der Benutzer trug während des Abrechnungszeitraums -2.000 bei (d. h. die Plattform verlor 2.000). In diesem Zeitraum erhielt die Plattform 100 Rabatte und der Nettogewinn betrug -2100. </li><li><strong>(2) Beschreibung der Berechnungsmethode</strong>: Dieses Modell basiert auf allen Mitgliedern. Wenn nur verlustbringende Mitglieder berechnet werden, wird der Nettogewinn nicht berechnet, wenn er negativ ist Nummer. </li><li><strong>(3) Erklärung von A: Da der Nettogewinn von B3 negativ ist, beträgt der Gesamtnettogewinn von A 15.000, d. h. die Gesamtleistung von B1, B2 und B3 beträgt 1.500, d. h. Die Beitragsprovision ist 15. </li></ul></li></ul>'
          }
        },
        firstLevel: {
          bigAgent: {
            '0': 'Gesamtleistung {0}',
            '1': 'Rückgabeverhältnis {0}% Gesamtkommission <em> {1} </em>'
          },
          tutorialDetail: {
            content:
              '<h1> <strong> Beispiel Beschreibung Die Beschreibung lautet wie folgt: </strong> </h1> <p> Angenommen Rückkehr zu 300 Provision 300. (dh 3%) As erste Entdeckungsmöglichkeiten auf diesem Standort und entwickelte sich sofort B1, B2 und B3. Am nächsten Tag beträgt das effektive Wetten von B1 selbst 3000, das effektive Wetten von B2 selbst IS 5000 und das effektive Wetten von B3 selbst beträgt 6000. </p> <span> Dann ist die Berechnungsmethode der A -Ausbeute wie folgt: </span> <ul> <li> <strong> 1, eine Provision </strong> (b1-, b2- und b3 -Beitrag) = (3000+5000 ++ 6000)*3%= <em> 420 </em> </li> <li> <strong> 2. Zusammenfassungsanweisung>: Weil die insgesamt effektive Wetten von B1, B2 und B3 direkt unter a direkt unter a IS 14.000, die entsprechende Kommissionsquote beträgt 3%, dh die Provision, die zu A beiträgt, 420. </li> <li> <strong> (2) Regeln Zusammenfassung </strong>: Nur die untergeordnteren Werte werden entwickelt, desto mehr Provisionen erhalten </li> </ul> </li> </ul>'
          }
        },
        threeNetProfit: {
          bigAgent: {
            '0': 'Gesamtleistung {0}',
            '1': 'Leistung des\nSubagent{0}',
            '2': 'Kommision der Subagenten <em>{0}</em>',
            '3': 'Andere Leistung {0}',
            '4': 'Belohnungsverhältnis {0}% anderer Provisionen <em> {1} </em>'
          },
          other: {
            c1_1Text: 'C1 trägt zu A bei <em>{0}</em><br> Von anderen um {1}%',
            c1_2Text: 'C1 Trägt Provision bei <em>{0}</em>',
            c2_1Text: 'C2 Trägt Provision bei <em>{0}</em>',
            c2_2Text: 'C2 trägt zu A bei <em>{0}</em><br> Von anderen um {1}%',
            c3_1Text: 'C3 Trägt Provision bei <em>{0}</em>',
            c3_2Text: 'C3 trägt zu A bei <em>{0}</em><br> Von anderen um {1}%',
            d1_1Text: 'D1 -Beitragskommission <em> {0} </em>',
            d2_2text: 'D1 trägt zu B1 <em> {0} </em> bei'
          },
          level: {
            '0': 'Level-1 Mitglieder <br/> (Direkt)',
            '1': 'Level-2 Mitglieder <br/> (Andere)',
            '2': 'Level-3 Mitglieder <br/> (Andere)'
          },
          tutorialDetail: {
            content:
              '<h1><strong>Ein Beispiel lautet wie folgt:</strong></h1><p>Angenommen, die aktuelle Nettogewinn-Rabattquote beträgt 1 % (d. h. direkte Untergebene) und die nachgeordnete Rationalisierungsquote beträgt 30 % (d. h. andere) A war der erste, der Geschäftsmöglichkeiten entdeckte und entwickelte sofort B1, B2 und B3; B1 entwickelte C1 und C2 weiter; B2 hatte keine Untergebenen; B3 entwickelte C3 und C1 entwickelte D1. Am nächsten Tag beträgt der Nettogewinn von B1 500, der Nettogewinn von B2 beträgt 3000, der Nettogewinn von B3 beträgt -2000, der Nettogewinn von C1 beträgt 1000, der Nettogewinn von C2 beträgt 2000, der Nettogewinn von C3 beträgt 20000, der Nettogewinn von D1 beträgt -3000. </p><span>Dann ist die Einkommensberechnungsmethode zwischen ihnen wie folgt: </span><ul><li><strong>1. Provision von C1 (direkter Beitrag von D1)</strong>=0*1 % = 0</li><li><strong>2. Provision von B1</strong>Zusätzlich zu den Beiträgen der direkten Untergebenen C1 und C2 gibt es auch Beiträge anderer Untergebener D1, wie folgt: <ul><li>< strong>(1)Direkte Provision von B1</strong>(direkter Beitrag von C1 und C2) =(1000+2000)* 1%=<em>30</em></li><li><strong>(2 )Sonstige Provision von B1</strong>(D1-Beitrag)=0*0,1 %*30 %=<em>0</em></li><li><strong>(3)Gesamtprovision von B1</strong >( direkt + andere) = 30+0 =<em>30</em></li></ul></li><li><strong>3. Provision von B2</strong> (keine Untergebenen) =(0 +0)* 1%=<em>0</em></li><li><strong>4. Provision von B3</strong> (direkter Beitrag von C3) = 20000 * 1%=<em >200< /em></li><li><strong>5. Zusätzlich zu den Beiträgen der direkten Untergebenen B1, B2 und B3 stammt die Provision von A auch aus Beiträgen der anderen Untergebenen C1, C2, C3 und D1, wie folgt: :< /strong><ul><li><strong>(1) Direkte Provision von A</strong>(direkte Beiträge von B1, B2 und B3) = (500+3000-2000) * 1 %=<em>15 </ em></li><li><strong>(2)Sonstige Provisionen von A</strong>(aus C1, C2 und C3 und D1-Beitrag)=(1000+2000+20000+0)*1 ​​% * 30 %= <em>69</em></li><li><strong>(3) Gesamtprovision von A</strong> (direkt + andere) = 15+69 =<em>84</em> </li> </ul></li><li><strong>6. Zusammenfassung </strong><ul><li><strong>(1) Nettogewinn: </strong>Zum Beispiel während des Abrechnungszeitraums der Benutzer Wenn der Benutzer während des Abrechnungszeitraums 2.000 beisteuerte (d. h. die Plattform machte einen Gewinn von 2.000) und 100 Rabatte von der Plattform erhielt, läge der Nettogewinn bei 1.900; wenn der Benutzer während des Abrechnungszeitraums -2.000 beisteuerte (d. h. die Plattform verlor 2.000). ) und im Berichtszeitraum 100 Rabatte von der Plattform erhalten haben, beträgt der Nettogewinn -2100. </li><li><strong>(2) Beschreibung der Berechnungsmethode:</strong>Dieses Modell basiert auf allen Mitgliedern. Wenn nur verlustbringende Mitglieder berechnet werden, wird der Nettogewinn nicht berechnet, wenn er negativ ist Nummer. </li><li><strong>(3) Erklärung von A:</strong>A ist der Erste, der Geschäftsmöglichkeiten entdeckt, sodass er immer 30 % der Untergebenen von Untergebenen und der Untergebenen von Untergebenen extrahieren kann. Da der Nettogewinn von D1 negativ ist, beträgt neben anderen Provisionen die von D1 an A gezahlte Provision 0. Die Provision für die Beiträge von C1, C2 und C3 beträgt 69. Da bei der Direktprovision der von B3 beigesteuerte Nettogewinn eine negative Zahl ist, muss der entsprechende negative Nettogewinn abgezogen werden, d. h. die gesamte beigesteuerte Direktprovision beträgt 15. </li><li><strong>(4) Beschreibung von B1: </strong>Obwohl D1 ein weiterer Untergebener von B1 ist, wird keine Provision generiert, sodass B1 keine andere Provision hat. Nur C1 und C2 generierten direkte Provisionen für B1, also 30. </li><li><strong>(5) B2-Erklärung: </strong>Da B2 keine Untergebenen hat, gibt es für B2 keine Provision. </li><li><strong>(6) B3-Erklärung: </strong>Da C3 keine Untergebenen hat, hat B3 keine anderen Provisionen, nur direkte Provisionen, und es ist relativ mächtig, sodass es nur direkte Provisionen von 200 hat . </li><li><strong>(7) C1-Erklärung: </strong>Obwohl D1 ein Untergeordneter von C1 ist, ist der Nettogewinn von D1 negativ, sodass er keine Provision zu C1 beiträgt, d. h. die Provision von C1 beträgt 0 . </li><li><strong>(8) Zusammenfassung der Regeln: </strong>Egal um welches Level es sich handelt, A, B, C oder D, solange die Plattform profitabel ist, wird es kein Einkommen geben betroffen. Die erzielten Vorteile sind alle gleichermaßen fair und es werden keine Geschäftsmöglichkeiten entdeckt, die später aufgedeckt werden</li></ul></li></ul>'
          }
        }
      }
    },
    reward: {
      base: {
        topVip: 'Glückwunsch! Du hast die höchste VIP-Stufe erreicht!',
        unReceive: 'Sammeln',
        noReceive: 'Nicht gesammelt',
        notReceive: 'Nicht erreicht',
        allReceive: 'Alles Einsammeln',
        distance: 'Distanz',
        needBet: 'Muss noch wetten',
        other: 'Andere',
        expired: 'Abgelaufen in {0} Tagen',
        expiredTime: '{x} abgelaufen',
        resetTime: 'Zurücksetzen nach {x}',
        expiredHour: 'Abgelaufen in {0} Stunden',
        available: 'Kann nach {0} Tag(en) beansprucht werden',
        availableHouur: '{0} Stunden können empfangen werden',
        canReceive: 'Sammeln',
        hasReceive: 'GESAMMELT',
        awardAmount: 'Preise',
        otherAward: 'Andere Belohnungen',
        hasExpired: 'Abgelaufen',
        hasSend: 'Verteilt',
        toBeCollected: 'Ausstehend',
        CPF: '',
        current: 'Aktuelle Stufe',
        rewardProgress: 'Holen Sie sich den Fortschritt',
        receiving: 'Sammeln',
        rewardSuccess:
          'Herzlichen Glückwunsch, um die folgenden Belohnungen zu erhalten!',
        gotoHome: 'Zur Startseite zurückkehren',
        activity: 'Aktivitätsniveau',
        award: 'Preise',
        tip1: 'Total {x} Eintrag, <span> erfolgreiche {y} Balken </span>',
        tip2: 'Hat erhalten: Bonus {0}',
        tip3: 'Aktivitätsniveau{0}',
        tip4: 'Fehler <span>{x}</span>',
        templateTitle: 'Belohnungsquelle',
        isTopVip: 'Glückwunsch! Du hast die höchste VIP-Stufe erreicht!',
        receivedErrorAll: '',
        receivedError: '',
        availableCollection: '{x} kann danach gesammelt werden',
        claimedBonus: 'Hat erhalten: <span> Bonus {x} </span>',
        activeLevel: 'Aktivitätsniveau{x}'
      },
      vip: {
        rewardMap: {
          vipPromote: 'Wohlfahrt für VIPs {0}',
          power: 'VIP -Privileg',
          dailyWithdrawalLimit: 'Der Gesamtbetrag der täglichen Auszahlung',
          numberWithdrawals: 'Die Obergrenze des täglichen Rückzugs',
          freeTimes: 'Tägliche Befreiungsgebühren Stift',
          promotion: 'Upgrade-Bonus',
          day: 'Tagesgehalt',
          week: 'Wochengehalt',
          month: 'Monatsgehalt',
          relegation: 'Anforderungen für die Requalifizierung',
          needBets: 'Zur Entgegennahme muss noch {0} gewettet werden',
          vipProgressTips1: 'Distanz',
          vipProgressTips2:
            'Die Aufladezeit beträgt immer noch weniger als <strong>{0}</strong>',
          vipProgressTips3:
            'Wetten sind immer noch schlecht <strong> {0} </strong>',
          vipProgressTips4:
            'Gültiges BET ist immer noch erforderlich <strong>{0}</strong>',
          needRecharge: 'Aufrüsten Und Aufladen',
          needBet: 'Upgrade Benodigd Wager',
          validNeedBet: 'Upgrade Benodigd Wager',
          monthRelegation: 'Anforderungen für die Requalifizierung',
          needLack: 'Promotion <strong> {0} </strong>',
          retainLack: 'Lesen arm <strong> {0} </strong>',
          rewardTips0: '{x}erhalten',
          rewardTips5: 'Countdown zu behaupten',
          rewardTips1: '',
          rewardTips2: '',
          rewardTips3: '',
          rewardTips4: '',
          rewardTimeTips: '{x} kann danach gesammelt werden'
        },
        table: {
          vipLevelMap: 'Liste der VIP-Ränge',
          level: 'Level',
          validBet: 'Kumulierte Gültige Einsätze',
          vipGift: 'Upgrade-Bonus',
          dayBonus: 'Täglicher Bonus',
          weekBonus: 'Wöchentlicher Bonus',
          monthBonus: 'Monatlicher Bonus',
          depositChannel: 'Beschleunigte Einzahlung',
          personalServer: 'Exklusiver Support',
          totalDeposit: 'Totale Borg',
          totalBet: 'Gesamt-Wetten',
          lastWeekDeposit: 'Letzte Woche aufladen',
          lastWeekBet: 'Code letzte Woche',
          lastMonthDeposit: 'Aufgeladen im letzten Monat',
          unmetTips: 'Bei Nichterfüllung eine Stufe herabsetzen',
          lastMonthBet: 'Letztes Monat Wetten',
          dayDeposit: 'Tägliche Aufladung',
          dayBet: 'Tägliches Wetten',
          validDayBet: 'Tägliche gültige Einsätze',
          dayBonusLimit: 'Preise',
          weekDeposit: 'Aufladung in der laufenden Woche',
          weekBet: 'Wöchentliches Wetten',
          validWeekBe: 'Gültige Wetten für die Woche',
          weekBonusLimit: 'Preise',
          monthDeposit: 'Monatliche Aufladung',
          monthBet: 'Monatliches Wetten',
          validMonthBet: 'Wetten des Monats',
          monthBonusLimit: 'Preise',
          needRechargeTips:
            'Um in den nächsten Level aufzusteigen, müssen die Mitglieder mehr aufladen, je nachdem wie viel sie bereits aufgeladen haben. Zum Beispiel: Für die Beförderung zum VIP1 ist eine Aufladung von 1000 erforderlich, für die Beförderung zum VIP2 eine Aufladung von 2000, d. h. dann müssen die Mitglieder insgesamt 1000+2000=3000 aufladen, um zum VIP2 befördert zu werden, und so weiter.',
          needBetTips:
            'Das heißt, die Menge der Werbung zur nächsten Ebene muss auf der Grundlage der ursprünglichen Codierungscodierung codiert werden, z. Nur in der Lage sein, nur VIP2 zu versprechen, also weiter.',
          validNeedBetTips:
            'Das heißt, die Beförderung in die nächste Ebene muss auf dem ursprünglichen akkumulierten effektiven Wetten beruhen, und dann die Menge an effektiv Akkumulieren Sie effektive BET 1000+2000 = 3000, um den Fortschritt zum Advance VIP2 zu erreichen.'
        },
        rules: 'Erklärung der VIP-Regeln',
        lack: 'Behoefte <strong> {0} </strong>'
      },
      award: {
        table: {
          time: 'Zeit',
          name: 'Name',
          reward: 'Preise',
          operate: 'Aktion'
        }
      }
    },
    customersQuestionDetail: { title: 'Fragendetails' },
    service: {
      customerLiteral: 'Kunden-\nSupport',
      commonQuestion: 'FAQ',
      hotQuestion: 'Heiße Sorgen',
      contact: 'Kontaktmethode',
      copy: 'Kopieren',
      copyAndOpen: 'Kopieren & Öffnen',
      immediateContract: 'Wenden Sie sich sofort an',
      search: 'Suchen',
      weChatLiteral: 'Wechat -Kundendienst',
      customer: 'Sonstiger Kundenservice',
      questionRem: 'Konntest du keine Lösung finden? Bitte kontaktiere uns',
      online: {
        title: '24/7Online -Kundendienst',
        describe:
          'Professioneller Kundenservice steht für Online-Gespräche zur Verfügung und hilft Ihnen bei allen Problemen, auf die Sie stoßen.',
        consult: 'Echtzeit-Beratung'
      }
    },
    feedback: {
      demoModeNotReceived: 'Die Ankernummer kann keine Lotterie erhalten.',
      toBeCollected: 'Ausstehend',
      toBeCollectedAll: 'Alles Einsammeln',
      empty: 'Derzeit keine Meldungen',
      createFeedback: 'Erstellen',
      mineFeedback: 'meins',
      feedbackContent: 'Feedback Inhalt',
      feedbackReply: 'Offizielle Antwort',
      feedbackSubtitle:
        'Du sprichst die Probleme an und ich korrigiere oder verbessere sie',
      feedbackContentMessage: 'Der Inhalt des Feedbacks darf nicht leer sein',
      feedbackPlaceholder:
        'Jede Meinung, die Sie haben, ist uns sehr wichtig. Jede wertvolle Meinung wird angenommen. Je nach Wichtigkeit der Meinung gibt es verschiedene Geldbelohnungen. Sie sind herzlich eingeladen, Ihre Meinung zu äußern!',
      feedbackUpload: 'Bilder lügen nicht',
      feedbackUploadSubtitle: 'Leichter zu übernehmen',
      feedbackUploadPlaceholder:
        'Das Hochladen von Bildern und Videos (nicht größer als 50 MB) wird unterstützt',
      feedbackRuleTitle: 'Regeln zur Gewinnvergabe',
      feedbackRule:
        'Wir sammeln Feedback zur Optimierung unseres Systems und der Funktionen, um dir ein noch besseres Erlebnis zu bieten! Nach der Annahme wird eine Prämie erteilt.',
      submit: 'Feedback einreichen',
      feedbackTips: 'Vielen Dank für dein wertvolles Feedback',
      geetest: 'Zur Bestätigung bitte klicken',
      feedbackID: 'Feedback-ID',
      replyContent: 'Offizielle Antwort',
      award: 'Bonus',
      pendding: 'Verarbeitet Werden',
      adopted: 'Habe Adoptiert',
      ignored: 'Nicht übernommen',
      deleted: 'Gelöscht'
    },
    yuebao: {
      currentTransferIn: 'Aktuelle Einzahlung',
      currentProfix: 'Aktuelles Einkommen',
      yuebaoProfix: 'Interest Einkommen',
      yearRate: 'Effektiver Jahreszinsen(%)',
      totalIncome: 'Einkommen',
      allType: 'Alle Typen',
      transferIn: 'Einzahlung',
      transferOut: 'Auszahlung',
      receive: 'Sammeln',
      profix: 'Zinsen',
      receiveProfix: 'Einkommen Sammeln',
      manualPull: 'Manuelle Abrufung',
      profixRecord: 'Gewinn- und Verlustrechnung',
      changeRecord: 'Interest Änderung',
      rule: 'Interest Regeln',
      receiveSussessTip: 'Erfolgreich erhalten!',
      hourProfixTips: '(Stündlich verfügbarer Verdienst)',
      table: {
        time: 'Zeit',
        type: 'Arten',
        changeAmount: 'Betragsänderung',
        incomeAmount: 'Anzahl der Einnahmen'
      },
      ruleContent: {
        desc: {
          '0': 'Interest Regeln',
          '1': '1. Der in das Yue Bao eingezahlte Betrag generiert nach einer Stunde Einnahmen.',
          '2': '2. Der Einnahmeabrechnungszyklus beträgt eine Stunde und wird stündlich verrechnet.',
          '3': '3. Jede Einzahlung muss mindestens {0} betragen und die Auszahlung muss dem Yue Bao gutgeschrieben werden. Die Einnahmen müssen dem Yue Bao gutgeschrieben werden bevor sie ausgezahlt werden.',
          '4': '4. Das Einkommen aus der Sammlung erfordert{0} doppelt fließendes Wasser (dh Auditing, Codierung oder effektive Wetten), um sich zurückzuziehen und unbegrenzte Spielplattform zu codieren.'
        },
        plan: {
          '0': 'Einkommensberechnung',
          '1': 'Einkommen pro Stunde = Ersparnisse x Jährliche Prozentrate (APR)÷365 Tage÷24 Stunden.',
          '2': 'Zum Beispiel:',
          '3': "Der jährliche Zinssatz beträgt {gold1} %. Das ursprüngliche Yu'ebao von Spieler A beträgt 0, und er überweist 10.000 um 12:30 Uhr, und das Einkommen wird jede Stunde ab 14:00 Uhr generiert:",
          '4': 'Das Einkommen beträgt somit=10000×20%÷365÷24= </c><assist_3>%{gold3}</c>'
        }
      },
      modal: {
        all: 'Alle',
        balance: 'Kontostand',
        transferInAmount: 'Einzahlungsbetrag',
        transferInAmountTips: 'Bitte gebe den zu überweisenden Betrag ein',
        transferInPlaceholder: 'Mindestbetrag {amount} pro einzahlung',
        transferOutAmount: 'Betrag Abheben',
        transferOutAmountTips: 'Bitte gebe den abzuhebenden Betrag ein',
        transferOutPlaceholder: 'Maximalbetrag pro Überweisung{amount}',
        receiveTime: 'Geschätzte Ankunftszeit des Umsatzes {time}',
        withdrawPassword: 'Bestätige das Abhebungspasswort',
        confirmIn: 'Einzahlen bestätigen',
        confirmOut: 'Abheben bestätigen',
        transferSuccess: 'Erfolgreich Eingezahlt',
        transferOutSuccess: 'Erfolgreich Abgehoben',
        transferOutErrorTips: 'Bitte gebe den richtigen Betrag ein'
      }
    },
    interest: {
      deposited: 'Hinterlegt',
      yearRate: 'Effektiver Jahreszinsen {rate}%',
      billingCycle: 'Siedlungszyklus',
      minute: '{minute} Minute',
      hour: '{hour} Stunde',
      day: '{day} Tage',
      collectedTotal: 'Kumulative Sammlung',
      interestCap: 'Sammeln',
      cycle: '{number} Zyklus',
      toCollected: 'Ausstehend',
      countdownReceive: 'Countdown zu behaupten',
      firstDepositReceive: 'Der erste Einzahlungskragen {amount}',
      rule: 'Zinsregeln',
      recordDetails: 'Details aufzeichnen',
      NotLimited: 'Nicht Limitiert',
      transferInPlaceholder: 'Single mindestens {amounti}, nur Ganzzahl',
      accountBalance: 'Kontostand',
      transferTips:
        'Ein- und Drehen wird keine Prüfung generieren. Nur das erhaltene Zinsen werden geprüft',
      countdownSettlement: 'Der Countdown dieser Siedlungsrunde {time}s',
      transferOutTips:
        'Nach dem Ausgang werden Sie das Interesse an dieser Runde des Zyklus verlieren!',
      currentTime: 'Aktuelle Zeit {time}',
      transferInTips:
        'Nach dieser Übertragung beträgt die zum ersten Mal generierte Zinszeit:{time}',
      receiveTips: '',
      currentInterest: 'Aktueller Interesse Schatz',
      transferOutPlaceholder: 'Maximaler abhebungsbetrag {amount}',
      anchorAccountNoPermissions: 'Die Ankernummer hat keine Autorität',
      notOpen: 'Interest ist noch nicht verfügbar',
      ruleContent: {
        desc: {
          '0': '',
          '1': '',
          '2': '',
          '3': '',
          '4': '',
          '5': '',
          '6': '',
          '7': '',
          '8': ''
        },
        plan: {}
      }
    },
    receiveModal: {
      kindTips: 'Tipps',
      eventContent:
        'Unterschiedliche Aktivitäten haben unterschiedliche temporäre Multiplikatoren. Bitte nehme den Bonus entgegen, nachdem du die Aktivitätsregeln sorgfältig gelesen hast. Durch die Bestätigung der Entgegennahme wird davon ausgegangen, dass du allen Aktivitätsregeln zustimmst.',
      ok: 'Entgegennahme bestätigen',
      gotIt: 'Verstanden. Ich möchte nicht mehr darauf hingewiesen werden.'
    },
    browser: {
      openMethod1: 'Methode eins',
      openMethod1Step1: 'Geklickt',
      openMethod1Step1End: 'Öffnen Sie die Menüleiste',
      openMethod1Step2: 'wählen',
      openMethod1Step2End: 'Im Browser öffnen',
      or: 'oder',
      openMethod2: 'Methode zwei',
      openMethod2Step1: 'Kopieren',
      openMethod2Step2: 'Fügen Sie zum Öffnen in den Browser ein'
    },
    theme16_dz: {
      playNow: 'Geh jetzt spielen',
      jackpotTitle: 'KOSTENLOS spielen, die Auszeichnung wartet auf Sie',
      downloadTitle: 'Sehr schnell, stabil, Tentakel und Reichweite',
      downloadSubTitle:
        'Holen Sie sich jederzeit und überall die neuesten Informationen',
      downloadTips: 'Software herunterladen',
      featuredGames: 'Einzigartiges Spiel',
      asideList: {
        games: 'Spiele',
        promotions: 'Förderung',
        help: 'helfen',
        functions: 'Funktion',
        member: 'Mitglied'
      },
      freeGet: 'Freie frei',
      selven$: 'R $ 7.00',
      entertainmentGalore: 'Unterhaltungsfest',
      entertainmentFeast: 'Unterhaltungsfest',
      entertainmentFeastTips:
        'Treffen Sie die weltweit führende Videospielplattform, Tausende von Spielautomaten -Spielen warten darauf, dass Sie spielen!',
      CategoriesGamePCTips: '',
      famousProvider: 'Nun -bekannter Lieferant',
      categoriesGameTip_CHESS: '10.000 Menschen spielen online, feurige PK!',
      categoriesGameTip_FISH:
        'Der riesige Fischereigelände in der Geschichte lädt Sie ein, zusammen zum Angeln zu kommen.',
      categoriesGameTip_ELECTRONIC:
        'Tausende von Spielautomaten -Spielen warten darauf, dass Sie kämpfen!',
      categoriesGameTip_REAL:
        'Der schönste Händler interagiert online und bringt Sie mit, um Baccarat und andere Live -Spiele zu spielen',
      categoriesGameTip_SPORTS:
        'Die höchsten Chancen der Welt, das mehrfach Quiz für Ball, Größe, Semi -Full -Feld, Wellen und Doppel, Gesamtziele, Reihe von Ebenen usw. bereitgestellt wird.',
      categoriesGameTip_COCKFIGHTING: '',
      categoriesGameTip_GAMING:
        'Alle großen und mittelgroßen Ligen der Welt der Welt sind alle verfügbar',
      categoriesGameTip_LOTTERY:
        'Konzentration auf die Lotteriespielindustrie seit vielen Jahren mit klassischen Farbspezies und Gameplay',
      categoriesGameTip_BLOCK_CHAIN:
        'Das aufregende, innovative Unterhaltungserlebnis.'
    },
    theme26_dz: {
      more: 'Mehr',
      home: {
        ty: 'Sportveranstaltung',
        tydesc:
          'Genießen Sie beliebte Top-Events und genießen Sie den Sturm auf dem Spielfeld',
        hgty: 'Kronensport',
        dz: 'Elektronische Unterhaltung',
        dzdesc:
          'Tausende von Spielautomaten -Spielen warten darauf, dass Sie kämpfen!',
        pgdz: 'PG -Elektronik',
        zr: 'Live-Video',
        zrdesc:
          'Der schönste Händler interagiert online und bringt Sie mit, um eine Vielzahl von Live -Spielen wie Baccarat zu spielen',
        agzr: 'AG echte Person',
        qp: 'Schachspiel',
        qpdesc:
          'Sammeln Sie das beliebteste Schach- und Kartenspiel der Welt, um online zu spielen, Hot PK',
        wgqp: 'WG Schachkarte',
        by: 'Angelspiel',
        bydesc:
          'Der riesige Fischereigelände in der Geschichte lädt Sie ein, zum Fischfisch zu kommen, und die Maschine wird in einem Dutzend explodiert.',
        wgby: 'WG -Fisch',
        cp: 'Lotteriespiel',
        cpdesc:
          'Konzentrieren Sie sich viele Jahre lang auf die Lotteriespielindustrie mit klassischen Farbspezies und Gameplay',
        sycp: 'Gewinnen Sie -Win Lotterie',
        dj: 'E-Sports',
        djdesc:
          'Alle großen und mittelgroßen Ligen der Welt der Welt sind alle verfügbar',
        sbdj: 'Atletico Sabah',
        qkl: 'Blockchain',
        qkldesc:
          'Blockchain -Nutzungstechnologieverschlüsselungsüberprüfung, um eine faire und faire Plattform zu erstellen',
        jdbqkl: 'Jiaduobao Blockchain',
        douji: 'Hühnerspiel',
        doujidesc:
          'Exklusive, hohe Chancen, einfache und effiziente Schnittstellen helfen Ihnen, sich leicht zu starten',
        svdouji: 'SV -Kämpfe',
        zq: 'Fußball',
        lq: 'Blueball',
        wq: 'Tennis',
        snk: 'Snooker',
        pq: 'Volleyball',
        f1: 'F1 Rennwagen',
        bq: 'Baseball',
        glq: 'Rugby',
        more: 'Mehr',
        moreGame: 'mehr Spiele'
      },
      header: {
        recharge: 'Kaution',
        withDraw: 'Zurückziehen',
        membershipCenter: 'Mitgliedszentrum',
        helpCenter: 'Hilfecenter',
        serviceCenter: 'Servicecenter'
      },
      download: {
        minTitle: 'Mobile Wettplattform für vollständige Netzwerkspieler',
        textTitle:
          'Spielen Sie jederzeit und überall Spiele • was auch immer Sie wollen',
        description:
          'Die beste native App der Branche ist reibungslos und stabil, bequem und schnell. Bieten Sie Unterhaltungsprojekte wie Sportveranstaltungen, Live -Unterhaltung, Stromveranstaltungen, Schachspiele, Lotteriewetten, elektronische Unterhaltung und andere Unterhaltung an. Fegen Sie den Code -Download sofort besitzen!'
      },
      footer: { activeTitle: 'Mitgliedszentrum' },
      vip: 'VIP -Kaiserkonferenz'
    },
    theme24_dz: {
      header: { download: '' },
      home: {
        downloadAppTxt1: '',
        downloadAppTxt2: '',
        downloadAppTxt3: '',
        description: {
          title0: '',
          description0: '',
          title1: '',
          description1: '',
          description2: '',
          title2: '',
          description3: '',
          description4: ''
        },
        midContent: { leftTitle: '' },
        footer: {
          bigTitle1: '',
          bigTitle2: '',
          bigTitle3: '',
          bigTitle4: '',
          bigTitle5: '',
          bigTitle6: '',
          bigTitle7: '',
          bigTitle8: '',
          bigTitle9: '',
          bigTitle10: '',
          minTitle1: '',
          minTitle2: '',
          minTitle3: '',
          minTitle4: '',
          minTitle5: '',
          minTitle6: '',
          minTitle7: '',
          minTitle8: '',
          bigTitle11: '',
          bigTitle12: '',
          platformTitle: '',
          tel: '',
          tg: ''
        }
      },
      aside: { yuebao: '' },
      tabbar: { service: '' }
    },
    theme21_dz: {
      footer: {
        hundredMillion: '',
        seconds: '',
        many: '',
        totalUser: '',
        saveTime: '',
        withdrawTime: '',
        partnerPlatform: '',
        onlineServie: '',
        safeTitle: '',
        safeDesc: '',
        gameTitle: '',
        gameDesc: '',
        fastTitle: '',
        fastDesc: '',
        extrmTitle: '',
        extrmDesc: '',
        slogan: '',
        changeLang: ''
      },
      header: { searchHotGame: '' }
    },
    theme20_dz: {
      licenseTitle: '',
      payMethods: '',
      followUs: '',
      event: '',
      waitingCollect: ''
    },
    theme18_dz: {
      account: { myAccount: '', confirmLogin: '' },
      mid: { task: '', activityTitle: '' },
      game: { noGame: '', searchHotGame: '', about: '' }
    },
    theme25_dz: {
      footer: {
        step1: '',
        step2: '',
        step3: '',
        context1: '',
        context2: '',
        context3: ''
      }
    },
    theme35_dz: {
      game: { nav: { hello: 'Hallo' } },
      download: {
        helpAndSupport: '',
        responsibleGaming: '',
        userAgient: '',
        bookName: '',
        project: '',
        payType: '',
        videoConcern: '',
        play: '',
        conditions: ''
      }
    },
    theme31_dz: {
      download: { title: '' },
      promote: {
        title: '',
        promoteShare: '',
        myMoney: '',
        myPerformance: '',
        myData: '',
        linkTitle: '',
        promoteTitle: '',
        unloginTips: ''
      }
    },
    officialChannel: {
      title: 'Offizieller Kanal',
      thirdPartyLogin: {
        facebook: 'Facebook Login',
        google: 'Google-Login',
        line: 'Line-Login',
        wechat: 'WeChat-Login',
        qq: 'QQ-Login'
      }
    }
  }
}
